import type { FC, SVGProps } from 'react';

import { PRIMARY_COLOR } from '../../../constants/global';

export interface ISVG {
	width?: string;
	height?: string;
	color?: string;
}

interface ISVGComponent extends React.SVGProps<SVGSVGElement> {
	color?: string;
	title?: string;
}

export const InfoSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '10'}
		height={height || '10'}
		viewBox='0 0 10 10'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM5.58125 4.1175L4.15 4.29688L4.09875 4.53438L4.38 4.58625C4.56375 4.63 4.6 4.69625 4.56 4.87938L4.09875 7.04687C3.9775 7.6075 4.16438 7.87125 4.60375 7.87125C4.94438 7.87125 5.34 7.71375 5.51938 7.4975L5.57437 7.2375C5.44937 7.3475 5.26687 7.39125 5.14562 7.39125C4.97375 7.39125 4.91125 7.27063 4.95562 7.05813L5.58125 4.1175ZM5 3.4375C5.16576 3.4375 5.32473 3.37165 5.44194 3.25444C5.55915 3.13723 5.625 2.97826 5.625 2.8125C5.625 2.64674 5.55915 2.48777 5.44194 2.37056C5.32473 2.25335 5.16576 2.1875 5 2.1875C4.83424 2.1875 4.67527 2.25335 4.55806 2.37056C4.44085 2.48777 4.375 2.64674 4.375 2.8125C4.375 2.97826 4.44085 3.13723 4.55806 3.25444C4.67527 3.37165 4.83424 3.4375 5 3.4375Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const AlertSVG = () => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<mask
			id='mask0_3789_26'
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='20'
			height='20'
		>
			<path
				d='M9.99967 19.1663C4.91634 19.1663 0.833008 15.083 0.833008 9.99967C0.833008 4.91634 4.91634 0.833008 9.99967 0.833008C15.083 0.833008 19.1663 4.91634 19.1663 9.99967C19.1663 15.083 15.083 19.1663 9.99967 19.1663ZM9.99967 2.49967C5.83301 2.49967 2.49967 5.83301 2.49967 9.99967C2.49967 14.1663 5.83301 17.4997 9.99967 17.4997C14.1663 17.4997 17.4997 14.1663 17.4997 9.99967C17.4997 5.83301 14.1663 2.49967 9.99967 2.49967Z'
				fill='#B92500'
			/>
			<path
				d='M9.99967 10.833C9.49967 10.833 9.16634 10.4997 9.16634 9.99967V6.66634C9.16634 6.16634 9.49967 5.83301 9.99967 5.83301C10.4997 5.83301 10.833 6.16634 10.833 6.66634V9.99967C10.833 10.4997 10.4997 10.833 9.99967 10.833Z'
				fill='#B92500'
			/>
			<path
				d='M9.99967 14.1663C9.74967 14.1663 9.58301 14.083 9.41634 13.9163C9.24967 13.7497 9.16634 13.583 9.16634 13.333C9.16634 13.2497 9.16634 13.083 9.24967 12.9997C9.33301 12.9163 9.33301 12.833 9.41634 12.7497C9.66634 12.4997 9.99967 12.4163 10.333 12.583C10.4163 12.583 10.4163 12.583 10.4997 12.6663C10.4997 12.6663 10.583 12.7497 10.6663 12.7497C10.7497 12.833 10.833 12.9163 10.833 12.9997C10.833 13.083 10.833 13.2497 10.833 13.333C10.833 13.4163 10.833 13.583 10.7497 13.6663C10.6663 13.7497 10.6663 13.833 10.583 13.9163C10.4163 14.083 10.2497 14.1663 9.99967 14.1663Z'
				fill='#B92500'
			/>
		</mask>
		<g mask='url(#mask0_3789_26)'>
			<rect
				width='20'
				height='20'
				fill='#1C1C1C'
			/>
		</g>
	</svg>
);

export const NotificationAlertSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='21'
		height='18'
		viewBox='0 0 23 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11.1597 7.17969C10.8478 7.17969 10.5947 7.43275 10.5947 7.74467V12.2783C10.5947 12.5902 10.8478 12.8433 11.1597 12.8433C11.4716 12.8433 11.7247 12.5902 11.7247 12.2783V7.74467C11.7247 7.59459 11.6649 7.45138 11.5589 7.34547C11.453 7.23953 11.3098 7.17969 11.1597 7.17969Z'
			fill='#f56e9d'
		/>
		<path
			d='M11.1595 14.3428C10.9329 14.3399 10.7269 14.4752 10.6387 14.6842C10.5504 14.8931 10.5975 15.1344 10.7583 15.2952C10.9182 15.4561 11.1605 15.5032 11.3694 15.4149C11.5784 15.3266 11.7137 15.1206 11.7108 14.8941C11.7108 14.59 11.4636 14.3428 11.1595 14.3428Z'
			fill='#f56e9d'
		/>
		<path
			d='M21.9214 15.5919L13.9078 1.59979C13.3448 0.61108 12.2943 0 11.1555 0C10.0177 0 8.96718 0.61108 8.40416 1.59979L0.397285 15.5919C-0.167693 16.5708 -0.127467 17.7851 0.501256 18.7239C1.03387 19.5204 1.92842 19.999 2.88672 20H19.432C20.3913 19.999 21.2869 19.5164 21.8175 18.717C22.4453 17.7803 22.4855 16.5678 21.9214 15.5919ZM20.8749 18.0892H20.8758C20.5551 18.5728 20.0127 18.8641 19.432 18.8631H2.88668C2.30601 18.8641 1.76358 18.5728 1.44285 18.0892C1.06717 17.5095 1.04854 16.768 1.3938 16.1706L9.38787 2.16495C9.75079 1.53034 10.4246 1.13897 11.1554 1.13897C11.8862 1.13897 12.561 1.53034 12.9239 2.16495L20.9247 16.1706C21.2789 16.7738 21.2602 17.5252 20.8757 18.1098L20.8749 18.0892Z'
			fill='#f56e9d'
		/>
	</svg>
);
export const EditSVG = ({ color }: { color?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 65 65'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M65 22.4605V56.4805C65 61.1797 61.1797 65 56.4805 65H8.5195C3.8203 65 0 61.1797 0 56.4805V8.5195C0 3.8203 3.8203 0 8.5195 0H42.5315C43.9104 0 45.0315 1.1211 45.0315 2.5C45.0315 3.8789 43.9104 5 42.5315 5H8.5195C6.5781 5 5 6.5781 5 8.5195V56.4685C5 58.4099 6.5781 59.988 8.5195 59.988H56.4685C58.4099 59.988 59.988 58.4099 59.988 56.4685V22.4485C59.988 21.0696 61.1091 19.9485 62.488 19.9485C63.8669 19.9485 64.988 21.0696 64.988 22.4485L65 22.4605ZM22.309 42.7185C20.9301 42.7185 19.809 43.8396 19.809 45.2185C19.809 46.5974 20.9301 47.7185 22.309 47.7185H42.688C44.0669 47.7185 45.188 46.5974 45.188 45.2185C45.188 43.8396 44.0669 42.7185 42.688 42.7185H22.309ZM33.231 32.0385C33.7193 32.5268 34.3599 32.769 35.0005 32.769C35.6411 32.769 36.2817 32.5307 36.77 32.0385L60 8.8085C60.9805 7.82803 60.9805 6.2499 60 5.2694C59.0195 4.2889 57.4414 4.28893 56.4609 5.2694L33.2309 28.4994C32.2504 29.4799 32.2505 31.058 33.231 32.0385Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const CheckSVG = ({ width, height, color }: ISVGComponent) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '15'}
		height={height || '15'}
		viewBox='0 0 29 29'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M28.74 14.37C28.74 18.1812 27.226 21.8362 24.5311 24.5311C21.8362 27.226 18.1812 28.74 14.37 28.74C10.5588 28.74 6.90377 27.226 4.20888 24.5311C1.51398 21.8362 0 18.1812 0 14.37C0 10.5588 1.51398 6.90377 4.20888 4.20888C6.90377 1.51398 10.5588 0 14.37 0C18.1812 0 21.8362 1.51398 24.5311 4.20888C27.226 6.90377 28.74 10.5588 28.74 14.37ZM21.6089 8.92736C21.4806 8.7995 21.3278 8.69883 21.1597 8.63137C20.9916 8.5639 20.8116 8.53103 20.6305 8.53472C20.4494 8.53841 20.2709 8.57858 20.1057 8.65284C19.9405 8.72709 19.7919 8.8339 19.6689 8.96688L13.4306 16.9153L9.67101 13.1539C9.41563 12.916 9.07785 12.7864 8.72884 12.7926C8.37982 12.7987 8.04682 12.9401 7.8 13.187C7.55317 13.4338 7.41178 13.7668 7.40562 14.1158C7.39947 14.4648 7.52902 14.8026 7.76698 15.058L12.5199 19.8126C12.6479 19.9404 12.8004 20.0412 12.9682 20.1088C13.136 20.1764 13.3157 20.2095 13.4966 20.2061C13.6774 20.2028 13.8558 20.163 14.021 20.0892C14.1862 20.0155 14.3348 19.9092 14.458 19.7767L21.6286 10.8134C21.8731 10.5593 22.0082 10.2194 22.0048 9.86673C22.0014 9.51409 21.8599 9.17683 21.6107 8.92736H21.6089Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const AngleRightSVG = ({ className }: { className?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='8'
		height='13'
		viewBox='0 0 8 13'
		fill='none'
		className={className}
	>
		<path
			d='M0.657227 12.3135L6.31408 6.65662L0.657227 0.999768'
			stroke='currentColor'
		/>
	</svg>
);

export const MapPinSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M12 21s7-5.686 7-11a7 7 0 10-14 0c0 5.314 7 11 7 11z'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<circle
			cx='12'
			cy='10'
			r='2.5'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
	</svg>
);

export const AngleDownSVG = ({ className }: { className?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='13'
		height='8'
		viewBox='0 0 13 8'
		fill='none'
		className={className}
	>
		<path
			d='M0.657227 0.686523L6.31408 6.34338L11.9709 0.686523'
			stroke='currentColor'
		/>
	</svg>
);

export const HamburgerSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '19'}
		height={height || '15'}
		viewBox='0 0 19 15'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 14.1667C0 13.9457 0.0877975 13.7337 0.244078 13.5774C0.400358 13.4211 0.61232 13.3333 0.833333 13.3333H17.5C17.721 13.3333 17.933 13.4211 18.0893 13.5774C18.2455 13.7337 18.3333 13.9457 18.3333 14.1667C18.3333 14.3877 18.2455 14.5996 18.0893 14.7559C17.933 14.9122 17.721 15 17.5 15H0.833333C0.61232 15 0.400358 14.9122 0.244078 14.7559C0.0877975 14.5996 0 14.3877 0 14.1667ZM0 7.5C0 7.27899 0.0877975 7.06702 0.244078 6.91074C0.400358 6.75446 0.61232 6.66667 0.833333 6.66667H17.5C17.721 6.66667 17.933 6.75446 18.0893 6.91074C18.2455 7.06702 18.3333 7.27899 18.3333 7.5C18.3333 7.72101 18.2455 7.93297 18.0893 8.08926C17.933 8.24554 17.721 8.33333 17.5 8.33333H0.833333C0.61232 8.33333 0.400358 8.24554 0.244078 8.08926C0.0877975 7.93297 0 7.72101 0 7.5ZM0 0.833333C0 0.61232 0.0877975 0.400358 0.244078 0.244078C0.400358 0.0877975 0.61232 0 0.833333 0H17.5C17.721 0 17.933 0.0877975 18.0893 0.244078C18.2455 0.400358 18.3333 0.61232 18.3333 0.833333C18.3333 1.05435 18.2455 1.26631 18.0893 1.42259C17.933 1.57887 17.721 1.66667 17.5 1.66667H0.833333C0.61232 1.66667 0.400358 1.57887 0.244078 1.42259C0.0877975 1.26631 0 1.05435 0 0.833333Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const EllipsisSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width ?? '3'}
		height={height ?? '10'}
		viewBox='0 0 3 10'
		fill='none'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.538391 8.38614C0.538391 8.67624 0.653634 8.95447 0.85877 9.1596C1.0639 9.36474 1.34213 9.47998 1.63223 9.47998C1.92234 9.47998 2.20056 9.36474 2.4057 9.1596C2.61083 8.95447 2.72607 8.67624 2.72607 8.38614C2.72607 8.09603 2.61083 7.81781 2.4057 7.61268C2.20056 7.40754 1.92234 7.2923 1.63223 7.2923C1.34213 7.2923 1.0639 7.40754 0.858769 7.61268C0.653634 7.81781 0.538391 8.09603 0.538391 8.38614ZM0.538391 4.74C0.538391 5.03011 0.653634 5.30833 0.858769 5.51346C1.0639 5.7186 1.34213 5.83384 1.63223 5.83384C1.92234 5.83384 2.20056 5.7186 2.4057 5.51346C2.61083 5.30833 2.72607 5.03011 2.72607 4.74C2.72607 4.4499 2.61083 4.17167 2.4057 3.96654C2.20056 3.7614 1.92234 3.64616 1.63223 3.64616C1.34213 3.64616 1.0639 3.7614 0.858769 3.96654C0.653634 4.17167 0.538391 4.4499 0.538391 4.74ZM0.538391 1.09386C0.538391 1.38397 0.653634 1.66219 0.858769 1.86732C1.0639 2.07246 1.34213 2.1877 1.63223 2.1877C1.92234 2.1877 2.20056 2.07246 2.4057 1.86732C2.61083 1.66219 2.72607 1.38397 2.72607 1.09386C2.72607 0.803757 2.61083 0.525534 2.4057 0.320399C2.20056 0.115264 1.92234 2.01219e-05 1.63223 2.01346e-05C1.34213 2.01473e-05 1.0639 0.115264 0.858769 0.320399C0.653634 0.525534 0.53839 0.803757 0.538391 1.09386Z'
			fill={color ?? '#274169'}
		/>
	</svg>
);

export const MenuCollapseSVG = ({ color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<line
			x1='3'
			y1='6'
			x2='21'
			y2='6'
		/>
		<line
			x1='3'
			y1='12'
			x2='21'
			y2='12'
		/>
		<line
			x1='3'
			y1='18'
			x2='21'
			y2='18'
		/>
	</svg>
);

export const MenuExpandSVG = ({ color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<line
			x1='3'
			y1='6'
			x2='15'
			y2='6'
		/>
		<line
			x1='3'
			y1='12'
			x2='21'
			y2='12'
		/>
		<line
			x1='3'
			y1='18'
			x2='15'
			y2='18'
		/>
	</svg>
);

export const CloseSVG: FC<ISVGComponent & ISVG> = ({ color = '#F56E9D', title, width = '9', height = '9', ...rest }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width}
		height={height}
		viewBox='0 0 6 6'
		fill='none'
		{...rest}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.125881 0.125881C0.165683 0.0859786 0.212966 0.0543201 0.265022 0.0327193C0.317078 0.0111185 0.372884 0 0.429244 0C0.485604 0 0.54141 0.0111185 0.593466 0.0327193C0.645521 0.0543201 0.692805 0.0859786 0.732606 0.125881L3.00011 2.39424L5.26762 0.125881C5.30746 0.0860432 5.35475 0.0544418 5.4068 0.0328815C5.45885 0.0113213 5.51464 0.000224337 5.57098 0.000224337C5.62732 0.000224337 5.68311 0.0113213 5.73516 0.0328815C5.78721 0.0544418 5.83451 0.0860432 5.87434 0.125881C5.91418 0.165719 5.94578 0.213014 5.96734 0.265065C5.9889 0.317116 6 0.372904 6 0.429244C6 0.485583 5.9889 0.541372 5.96734 0.593423C5.94578 0.645474 5.91418 0.692768 5.87434 0.732606L3.60598 3.00011L5.87434 5.26762C5.91418 5.30746 5.94578 5.35475 5.96734 5.4068C5.9889 5.45885 6 5.51464 6 5.57098C6 5.62732 5.9889 5.68311 5.96734 5.73516C5.94578 5.78721 5.91418 5.83451 5.87434 5.87434C5.83451 5.91418 5.78721 5.94578 5.73516 5.96734C5.68311 5.9889 5.62732 6 5.57098 6C5.51464 6 5.45885 5.9889 5.4068 5.96734C5.35475 5.94578 5.30746 5.91418 5.26762 5.87434L3.00011 3.60598L0.732606 5.87434C0.692768 5.91418 0.645474 5.94578 0.593423 5.96734C0.541372 5.9889 0.485583 6 0.429244 6C0.372904 6 0.317116 5.9889 0.265065 5.96734C0.213014 5.94578 0.165719 5.91418 0.125881 5.87434C0.0860432 5.83451 0.0544418 5.78721 0.0328815 5.73516C0.0113213 5.68311 0.000224337 5.62732 0.000224337 5.57098C0.000224337 5.51464 0.0113213 5.45885 0.0328815 5.4068C0.0544418 5.35475 0.0860432 5.30746 0.125881 5.26762L2.39424 3.00011L0.125881 0.732606C0.0859786 0.692805 0.0543201 0.645521 0.0327193 0.593466C0.0111185 0.54141 0 0.485604 0 0.429244C0 0.372884 0.0111185 0.317078 0.0327193 0.265022C0.0543201 0.212966 0.0859786 0.165683 0.125881 0.125881Z'
			fill={color}
		/>
	</svg>
);

export const GenerateSVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'currentColor';
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M10.6158 8.32848C10.6238 8.31357 10.6258 8.30065 10.6288 8.28773C10.6288 8.28773 10.6317 8.28773 10.6337 8.29071H10.6367C10.6367 8.29071 10.6288 8.30065 10.6268 8.3086C10.5532 8.49646 10.8534 8.44378 11.085 8.52728L11.4031 8.63463C11.5253 8.67538 11.6138 8.77676 11.6396 8.90201L11.8225 9.82839V9.83833L11.8325 9.85125C11.8961 9.98643 12.0511 10.0799 12.2012 10.0779C12.3513 10.0809 12.5044 9.98345 12.565 9.85125L12.573 9.83634V9.82839L12.7181 8.99145C12.7638 8.80359 12.9089 8.65847 13.0948 8.60977L13.9118 8.45968H13.9218L13.9317 8.45172C14.056 8.39109 14.1454 8.25094 14.1484 8.11378C14.1564 7.97661 14.0749 7.83149 13.9526 7.76489L13.9347 7.75495H13.9297L13.9168 7.747L13.0928 7.5999C12.9069 7.55417 12.7618 7.40607 12.7141 7.22119L12.567 6.39718V6.38923L12.559 6.3763C12.4984 6.24609 12.3533 6.15763 12.2102 6.15962C12.068 6.15664 11.9229 6.24609 11.8613 6.3763L11.8563 6.38923V6.39718L11.7062 7.22119C11.6605 7.40706 11.5124 7.55218 11.3275 7.5999L10.5949 7.74501H10.587L10.579 7.74998L10.5691 7.75495C10.4955 7.79074 10.416 7.8623 10.3783 7.95077C10.3405 8.04022 10.3375 8.14161 10.3703 8.22013C10.4369 8.38812 10.5969 8.41396 10.6297 8.33245L10.6158 8.32848Z'
				fill={fila}
			/>
			<path
				d='M15.6283 2.65409C15.6382 2.63421 15.6412 2.61632 15.6462 2.59843C15.6462 2.59843 15.6512 2.60141 15.6541 2.6034H15.6591C15.6591 2.6034 15.6492 2.61831 15.6442 2.62924C15.5448 2.88667 16.3976 3.02881 16.7127 3.14312L16.7684 3.16299L17.0735 4.36869L17.0785 4.38161L17.0864 4.3995C17.1759 4.58538 17.3866 4.7146 17.5904 4.70763C17.7942 4.71061 18.0029 4.5804 18.0894 4.39749L18.0993 4.37761V4.36767L18.3995 3.14409L19.6111 2.83098L19.6241 2.82601L19.637 2.81806C19.8079 2.73655 19.9322 2.54373 19.9322 2.35289C19.9421 2.16502 19.8308 1.96624 19.6628 1.87479L19.637 1.85988L19.629 1.85491L19.6111 1.84994L18.3895 1.54181L18.0814 0.320215V0.310275L18.0715 0.295365C17.988 0.119431 17.7892 -0.00481799 17.5934 0.000143928C17.3996 -0.00482613 17.1988 0.119421 17.1153 0.295365L17.1073 0.310275V0.320215L16.7972 1.5438L15.5856 1.84894L15.5657 1.85888L15.5508 1.86684C15.4494 1.91554 15.342 2.01394 15.2913 2.1362C15.2406 2.25846 15.2357 2.39562 15.2814 2.50496C15.3728 2.73358 15.5915 2.76937 15.6353 2.66002L15.6283 2.65409Z'
				fill={fila}
			/>
			<path
				d='M0.345118 15.6214C0.454456 16.0797 0.617464 16.5558 0.866959 17.006L1.06774 17.3341C1.13633 17.4335 1.20491 17.5329 1.27846 17.6293C1.42557 17.8231 1.58361 18.006 1.7516 18.179C2.11044 18.5428 2.48713 18.8529 2.94735 19.1252C3.41053 19.3976 3.91151 19.5755 4.3906 19.6898C5.35276 19.9085 6.25033 19.9473 7.13111 19.9751C8.88946 20.0109 10.5714 20.0029 12.3215 19.9831C13.1972 19.9602 14.0848 19.9344 15.034 19.7594C15.5072 19.67 16.0012 19.5328 16.4823 19.2992C16.9733 19.0597 17.3828 18.7595 17.7545 18.4215C18.1283 18.0776 18.4573 17.6959 18.7346 17.2635C19.0268 16.8103 19.2256 16.3123 19.3529 15.8312C19.6043 14.8621 19.6431 13.9586 19.6789 13.076C19.7147 11.916 19.9532 10.2441 19.0199 10.1696C18.005 10.091 18.3003 11.8464 18.2565 12.9019C18.2207 13.7259 18.17 14.5459 17.9941 15.2914C17.9047 15.6632 17.7804 16.0091 17.6025 16.3172C17.4266 16.6204 17.183 16.9305 16.9226 17.1899C16.6602 17.4493 16.355 17.6939 16.0499 17.8668C15.7418 18.0447 15.3988 18.17 15.0291 18.2564C14.2856 18.4274 13.4666 18.4731 12.6445 18.501C10.9955 18.5387 9.29893 18.5338 7.63885 18.5208C5.99483 18.4701 4.28714 18.4801 3.18585 17.506C2.89562 17.2694 2.63917 16.9941 2.41454 16.6939C2.19089 16.3888 2.03583 16.0886 1.91557 15.7347C1.681 15.035 1.61737 14.2259 1.58457 13.4118C1.53587 11.7757 1.58457 10.0779 1.61738 8.41707C1.64322 7.58711 1.67801 6.76012 1.78238 5.97688C1.88674 5.19363 2.08256 4.47797 2.46921 3.95414C2.67794 3.66689 2.92245 3.40747 3.19182 3.18283C3.46416 2.95621 3.76434 2.76537 4.0516 2.64807C4.64202 2.39659 5.39544 2.32999 6.18169 2.31211C7.65477 2.29421 9.94282 2.43138 9.88633 1.14916C9.84061 0.113442 7.71551 0.194944 6.19161 0.284411C5.33381 0.343056 4.41041 0.431518 3.45111 0.829103C3.21454 0.928499 2.97995 1.05076 2.75929 1.1929C2.53763 1.33007 2.34977 1.47321 2.15595 1.63324C1.77724 1.94833 1.4383 2.31015 1.14807 2.70972C1.00593 2.90355 0.862794 3.12718 0.740527 3.36078C0.618268 3.59237 0.518872 3.83193 0.440344 4.06847C0.280313 4.54459 0.190856 5.01274 0.130211 5.46005C0.0208733 6.35859 0.00596448 7.20349 0 8.03745C0.00496981 9.70633 0.00993961 11.3177 0.0636143 13.0024C0.101386 13.8443 0.14512 14.7071 0.353848 15.6256L0.345118 15.6214Z'
				fill={fila}
			/>
		</svg>
	);
};

export const ArrowLeftSVG: FC<ISVGComponent> = ({ color, title, ...rest }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='15'
		height='8'
		viewBox='0 0 26 8'
		fill='none'
		{...rest}
	>
		<title>{title}</title>
		<path
			d='M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35356L3.82843 7.53554C4.02369 7.7308 4.34027 7.7308 4.53553 7.53554C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976313 4.7308 0.65973 4.53553 0.464468C4.34027 0.269206 4.02369 0.269206 3.82843 0.464468L0.646447 3.64645ZM26 3.5L1 3.5L1 4.5L26 4.5L26 3.5Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const NotificationBellSVG = ({ color }: { color?: string }) => (
	<svg
		width='15'
		height='16'
		viewBox='0 0 15 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.46332 0.72C6.46332 0.323328 6.77833 0 7.16666 0C7.35499 0 7.52998 0.0749994 7.66332 0.210001C7.79665 0.345003 7.86998 0.526673 7.86998 0.719996V1.63667H6.46331L6.46332 0.72ZM2.1734 6.57173C2.1734 4.21675 4.05673 2.30165 6.37009 2.30165H7.96343C10.2768 2.30165 12.1601 4.21666 12.1601 6.57173V11.3751H2.17357L2.1734 6.57173ZM7.16668 16C6.11667 16 5.24668 15.2067 5.09835 14.1767H9.23339C9.08672 15.2067 8.21668 16 7.16668 16ZM14.3334 12.7851C14.3334 13.1851 14.0084 13.5101 13.6084 13.5101H0.724992C0.324992 13.5101 0 13.1851 0 12.7851V12.7684C0 12.3684 0.324992 12.0434 0.724992 12.0434H13.6084C14.0084 12.0434 14.3334 12.3684 14.3334 12.7684V12.7851Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);
export const NotificationBellAlertSVG = ({ color }: { color?: string }) => (
	<svg
		width='18'
		height='17'
		viewBox='0 0 18 17'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6.46332 1.72C6.46332 1.32333 6.77833 1 7.16666 1C7.35499 1 7.52998 1.075 7.66332 1.21C7.79665 1.345 7.86998 1.52667 7.86998 1.72V2.63667H6.46331L6.46332 1.72ZM2.1734 7.57173C2.1734 5.21675 4.05673 3.30165 6.37009 3.30165H7.96343C10.2768 3.30165 12.1601 5.21666 12.1601 7.57173V12.3751H2.17357L2.1734 7.57173ZM7.16668 17C6.11667 17 5.24668 16.2067 5.09835 15.1767H9.23339C9.08672 16.2067 8.21668 17 7.16668 17ZM14.3334 13.7851C14.3334 14.1851 14.0084 14.5101 13.6084 14.5101H0.724992C0.324992 14.5101 0 14.1851 0 13.7851V13.7684C0 13.3684 0.324992 13.0434 0.724992 13.0434H13.6084C14.0084 13.0434 14.3334 13.3684 14.3334 13.7684V13.7851Z'
			fill={color || 'currentColor'}
		/>
		<circle
			cx='15'
			cy='3'
			r='3'
		/>
	</svg>
);

export const AlertNotificationSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='13'
		height='11'
		viewBox='0 0 17 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M16.6756 12.8352L9.68609 0.721832C9.42631 0.269925 8.95953 0 8.43523 0C7.91093 0 7.44415 0.269249 7.18437 0.721832L0.194832 12.8352C-0.0649441 13.2871 -0.0649441 13.8263 0.194832 14.2782C0.454608 14.7301 0.921392 15 1.44569 15H15.4303C15.9499 15 16.4214 14.7308 16.6812 14.2782C16.9409 13.8263 16.9409 13.2871 16.6812 12.8352H16.6756ZM15.8435 13.7972C15.8002 13.8696 15.6798 14.038 15.4248 14.038H1.44015C1.18984 14.038 1.06468 13.8696 1.02139 13.7972C0.978092 13.7248 0.896235 13.5327 1.02139 13.3162L8.01647 1.20353C8.14162 0.987046 8.34864 0.962696 8.43523 0.962696C8.52182 0.962696 8.72883 0.987049 8.85399 1.20353L15.8491 13.3169C15.9742 13.5334 15.8924 13.7255 15.8491 13.7979L15.8435 13.7972ZM7.95412 9.42428V5.09468C7.95412 4.83018 8.1706 4.6137 8.43511 4.6137C8.69961 4.6137 8.91609 4.83018 8.91609 5.09468V9.42428C8.91609 9.68879 8.69961 9.90527 8.43511 9.90527C8.1706 9.90527 7.95412 9.68879 7.95412 9.42428ZM9.15694 11.5891C9.15694 11.9882 8.83492 12.3109 8.43511 12.3109C8.03597 12.3109 7.71328 11.9889 7.71328 11.5891C7.71328 11.1899 8.03529 10.8673 8.43511 10.8673C8.83425 10.8673 9.15694 11.1893 9.15694 11.5891Z'
			fill='currentColor'
		/>
	</svg>
);
export const ActivityNotificationSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='11'
		height='11'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M3.27732 0C1.46638 0 0 1.46432 0 3.27525V12.068C0 13.8789 1.46638 15.3453 3.27732 15.3453H12.0685C13.8795 15.3453 15.3458 13.8789 15.3458 12.068V3.27525C15.3458 1.46432 13.8795 0 12.0685 0H3.27732ZM3.27732 0.5271H12.0685C13.5954 0.5271 14.8162 1.74832 14.8162 3.27525V12.068C14.8162 13.5949 13.5954 14.8162 12.0685 14.8162H3.27732C1.75039 14.8162 0.52916 13.5949 0.52916 12.068V3.27525C0.52916 1.74832 1.75039 0.5271 3.27732 0.5271ZM11.8887 5.75107C11.8538 5.75195 11.8195 5.75971 11.7877 5.7739C11.7558 5.78809 11.7271 5.80843 11.7032 5.83375L9.00203 8.67751L6.54482 6.08955C6.52008 6.06332 6.49025 6.04243 6.45715 6.02815C6.42405 6.01387 6.38838 6.0065 6.35232 6.0065C6.31627 6.0065 6.2806 6.01387 6.2475 6.02815C6.2144 6.04243 6.18457 6.06332 6.15983 6.08955L3.25768 9.14621C3.20969 9.19709 3.18381 9.26491 3.18568 9.33483C3.18756 9.40474 3.21704 9.47107 3.26768 9.51931C3.31854 9.56733 3.38634 9.59325 3.45625 9.59141C3.52617 9.58957 3.59251 9.56013 3.64078 9.50951L6.35173 6.65594L8.81049 9.2439C8.83523 9.27012 8.86506 9.29102 8.89816 9.3053C8.93126 9.31958 8.96693 9.32695 9.00299 9.32695C9.03904 9.32695 9.07471 9.31958 9.10781 9.3053C9.14091 9.29102 9.17074 9.27012 9.19548 9.2439L12.0878 6.19706C12.1358 6.14617 12.1617 6.07836 12.1598 6.00844C12.1579 5.93852 12.1285 5.87219 12.0778 5.82395C12.0526 5.79997 12.023 5.78119 11.9905 5.76869C11.958 5.75619 11.9234 5.75019 11.8887 5.75107Z'
			fill='currentColor'
		/>
	</svg>
);
export const ReminderNotificationSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='11'
		height='11'
		viewBox='0 0 15 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.5 1.02054C7.55362 1.02496 7.60708 1.03009 7.6603 1.03592C7.43663 1.33129 7.24858 1.65512 7.10253 2.00102C7.06843 2.00035 7.03425 2 7 2C4.23857 2 2 4.23857 2 7V11.5298C2 11.5846 1.991 11.639 1.97337 11.6908L1.69817 12.5H12.3018L12.0266 11.6908C12.009 11.639 12 11.5846 12 11.5298V8.18777C12.3485 8.1293 12.6835 8.03075 13 7.89705V11.4471L13.3581 12.5H13.5C13.7761 12.5 14 12.7239 14 13C14 13.2761 13.7761 13.5 13.5 13.5H0.5C0.223857 13.5 0 13.2761 0 13C0 12.7239 0.223857 12.5 0.5 12.5H0.641922L1 11.4471V7C1 3.85468 3.42022 1.27461 6.5 1.02054V0.5C6.5 0.223857 6.72385 0 7 0C7.27615 0 7.5 0.223857 7.5 0.5V1.02054Z'
			fill='currentColor'
		/>
		<path
			d='M6 14C5.72385 14 5.5 14.2239 5.5 14.5C5.5 14.7761 5.72385 15 6 15H8C8.27615 15 8.5 14.7761 8.5 14.5C8.5 14.2239 8.27615 14 8 14H6Z'
			fill='currentColor'
		/>
		<path
			d='M12.1959 2.22045C12.2702 1.95448 12.1147 1.67869 11.8487 1.60447C11.5828 1.53024 11.307 1.68568 11.2328 1.95166L10.9951 2.80323L10.8445 2.65653C10.6467 2.4638 10.3302 2.46793 10.1375 2.6657C9.94477 2.86348 9.9489 3.18003 10.1467 3.37275L10.9011 4.10788C11.0276 4.23108 11.2096 4.27845 11.3801 4.23255C11.5506 4.18663 11.6842 4.0542 11.7317 3.88415L12.1959 2.22045Z'
			fill='currentColor'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11.25 0C13.3211 0 15 1.67893 15 3.75C15 5.82107 13.3211 7.5 11.25 7.5C9.17893 7.5 7.5 5.82107 7.5 3.75C7.5 3.62055 7.50655 3.49265 7.51935 3.36658C7.7114 1.47563 9.30838 0 11.25 0ZM13.9858 3.46883C13.845 2.08213 12.6739 1 11.25 1C9.73123 1 8.5 2.23123 8.5 3.75C8.5 5.26877 9.73123 6.5 11.25 6.5C12.7688 6.5 14 5.26877 14 3.75C14 3.65507 13.9952 3.56128 13.9858 3.46883Z'
			fill='currentColor'
		/>
	</svg>
);
export const SupportNotificationSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='11'
		height='13'
		viewBox='0 0 13 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M1.19975 11.1577H2.91017C3.06399 11.1577 3.19934 11.0347 3.19934 10.8839V6.10029C3.19934 5.94647 3.06399 5.83573 2.91017 5.83573H1.44586V5.4758C1.44586 2.76251 3.60234 0.553733 6.24487 0.553733C8.88741 0.553733 11.0439 2.76251 11.0439 5.4758V5.83573H9.57957C9.42576 5.83573 9.2904 5.94647 9.2904 6.10029V10.8839C9.2904 11.0377 9.42576 11.1577 9.57957 11.1577H10.0287V12.4713C10.0287 13.0989 9.51805 13.6187 8.89048 13.6187H6.47559C6.36177 13.1265 5.93417 12.782 5.42043 12.782C4.82055 12.782 4.33449 13.265 4.33449 13.8648V13.9079C4.33449 14.5078 4.82055 15 5.42043 15C5.93109 15 6.3587 14.6339 6.47559 14.1725H8.89048C9.8226 14.1725 10.5824 13.4034 10.5824 12.4713V11.1577H11.29C11.9514 11.1577 12.4897 10.6224 12.4897 9.96103V7.02317C12.4897 6.46329 12.1206 5.99262 11.5976 5.86034V5.4758C11.5976 2.45488 9.19196 0 6.24487 0C3.29778 0 0.892125 2.45488 0.892125 5.4758V5.86034C0.369155 5.99262 0 6.46329 0 7.02317V9.96103C0 10.6224 0.538351 11.1577 1.19975 11.1577ZM5.96801 13.9079C5.96801 14.2032 5.72498 14.4432 5.42966 14.4432C5.13433 14.4432 4.8913 14.2032 4.8913 13.9079V13.8648C4.8913 13.5695 5.13433 13.3296 5.42966 13.3296C5.72498 13.3296 5.96801 13.5695 5.96801 13.8648V13.9079ZM11.936 7.02317V9.96103C11.936 10.3179 11.6468 10.604 11.29 10.604H9.84413V6.38946H11.29C11.6468 6.38946 11.936 6.66632 11.936 7.02317ZM0.553733 7.02317C0.553733 6.66632 0.842904 6.38946 1.19975 6.38946H2.64561V10.604H1.19975C0.842904 10.604 0.553733 10.3148 0.553733 9.96103V7.02317Z'
			fill='currentColor'
		/>
	</svg>
);
export const UpdatesSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 13 13'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M12.143 3.42792C12.143 2.51483 11.5662 1.69575 10.7073 1.38742L7.56311 0.260033C7.0837 0.0889343 6.5831 0 6.07149 0C5.55988 0 5.05844 0.0863973 4.57988 0.260033L1.43571 1.38742C0.576835 1.69575 0 2.51481 0 3.42792V8.05093C0 9.30198 0.67424 10.4624 1.76266 11.0823L4.34782 12.5528C5.39474 13.1491 6.74823 13.1491 7.79513 12.5528L10.3803 11.0823C11.467 10.464 12.1429 9.3019 12.1429 8.05093L12.143 3.42792ZM11.2756 8.05353C11.2756 8.99203 10.7683 9.86618 9.95088 10.3303L7.36572 11.8008C6.97949 12.0201 6.53054 12.137 6.06891 12.137C5.60728 12.137 5.16005 12.0202 4.77464 11.8008L2.18949 10.3303C1.37211 9.86618 0.864732 8.99203 0.864732 8.05353V3.43052C0.864732 2.8842 1.21202 2.39206 1.72532 2.20573L4.86949 1.0758C5.64113 0.797989 6.49325 0.797989 7.26751 1.0758L10.4117 2.20573C10.9275 2.39038 11.2723 2.88251 11.2723 3.43052V8.05353H11.2756Z'
			fill='currentColor'
		/>
		<path
			d='M6.07235 3.46875C5.83348 3.46875 5.63867 3.66357 5.63867 3.90243V6.07082C5.63867 6.30969 5.83349 6.5045 6.07235 6.5045C6.31121 6.5045 6.50603 6.30968 6.50603 6.07082V3.90243C6.50603 3.66356 6.31121 3.46875 6.07235 3.46875Z'
			fill='currentColor'
		/>
		<path
			d='M6.50603 9.10772C6.50603 9.68625 5.63867 9.68625 5.63867 9.10772C5.63867 8.5292 6.50603 8.5292 6.50603 9.10772Z'
			fill='currentColor'
		/>
	</svg>
);

export const HomeSVG = (_props: ISVG) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 15 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M14.3055 4.47812L8.46709 0.310019C7.88758 -0.103339 7.10981 -0.103339 6.53111 0.310019L0.692684 4.47812C0.258449 4.78794 0 5.28959 0 5.82175V13.3473C0 14.2592 0.744854 15 1.66147 15H13.3391C14.2549 15 15.0006 14.2584 15.0006 13.3473V5.82175C15.0006 5.29041 14.7413 4.78796 14.3079 4.47892L14.3055 4.47812ZM5.47884 13.9726V10.2619C5.47884 9.15825 6.377 8.26009 7.48064 8.26009H7.51595C8.61959 8.26009 9.51775 9.15825 9.51775 10.2619V13.9726H5.47807H5.47884ZM13.9708 13.3473C13.9708 13.6925 13.6867 13.9726 13.3367 13.9726H10.5451V10.2619C10.5451 8.59158 9.18622 7.23274 7.51596 7.23274H7.48064C5.81034 7.23274 4.4515 8.59162 4.4515 10.2619V13.9726H1.65989C1.31074 13.9726 1.02581 13.6917 1.02581 13.3473V5.82173C1.02581 5.62187 1.12373 5.43166 1.28826 5.31445L7.12669 1.14635C7.23745 1.06689 7.36748 1.02756 7.49751 1.02756C7.62754 1.02756 7.75756 1.06689 7.86833 1.14635L13.7068 5.31445C13.8713 5.43164 13.9692 5.62106 13.9692 5.82173V13.3473H13.9708Z'
			fill='currentColor'
		/>
	</svg>
);

export const RightArrowSVG: FC<ISVGComponent> = ({ color, title, ...rest }) => (
	<svg
		width='6'
		height='11'
		viewBox='0 0 6 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<title>{title}</title>
		<path
			d='M1 9.65625L5.24264 5.41361L0.999999 1.17097'
			stroke={color || 'currentColor'}
		/>
	</svg>
);

export const NavArrowLeftSVG: FC<ISVGComponent> = ({ color, title, ...rest }) => (
	<svg
		width='11'
		height='11'
		viewBox='0 0 11 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<title>{title}</title>
		<path
			d='M-0.00692765 5.50431C0.00145332 5.66221 0.0578183 5.78633 0.132226 5.86443L4.84652 10.8406C5.06343 11.0584 5.38794 11.0497 5.58723 10.8611C5.78648 10.6725 5.79625 10.3197 5.60766 10.1204L1.73635 6.02812L10.4693 6.02812C10.7585 6.02812 10.9931 5.79361 10.9931 5.50431C10.9931 5.21501 10.7585 4.9805 10.4693 4.9805L1.73635 4.9805L5.60766 0.888225C5.7962 0.688967 5.77986 0.342833 5.58723 0.14753C5.38794 -0.0544777 5.03507 -0.0312731 4.84653 0.167958L0.132226 5.14416C0.00787292 5.27134 0.00119143 5.37946 -0.00692765 5.50431Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const NavArrowRightSVG: FC<ISVGComponent> = ({ color, title, ...rest }) => (
	<svg
		width='11'
		height='11'
		viewBox='0 0 11 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<title>{title}</title>
		<path
			d='M11 5.50546C10.9916 5.34755 10.9353 5.22344 10.8608 5.14534L6.14655 0.169126C5.92964 -0.0486411 5.60513 -0.039894 5.40585 0.14867C5.20659 0.337226 5.19682 0.690101 5.38542 0.889372L9.25672 4.98164L0.523811 4.98164C0.234536 4.98164 6.90066e-08 5.21615 6.55567e-08 5.50546C6.21068e-08 5.79476 0.234536 6.02927 0.523811 6.02927L9.25672 6.02927L5.38542 10.1215C5.19687 10.3208 5.21321 10.6669 5.40585 10.8622C5.60513 11.0642 5.958 11.041 6.14655 10.8418L10.8608 5.8656C10.9852 5.73842 10.9919 5.63031 11 5.50546Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const LeftNavSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
	>
		<circle
			cx='16'
			cy='16'
			r='16'
			transform='rotate(180 16 16)'
			fill='#f5f5f5'
		/>
		<path
			d='M17.3431 21.6569L11.6863 16L17.3431 10.3431'
			stroke='#5F8080'
		/>
	</svg>
);
export const RightNavSVG = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
	>
		<circle
			cx='16'
			cy='16'
			r='16'
			fill='#f5f5f5'
		/>
		<path
			d='M14.6569 10.3431L20.3137 16L14.6569 21.6569'
			stroke='#5F8080'
		/>
	</svg>
);

export const CopySVG = ({ fill }: { fill?: string }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='15'
		height='15'
		viewBox='0 0 90 90'
		fill='none'
	>
		<path
			d='M27 22H17V78H63V68H73V12H27V22ZM61 76H19V24H61V76ZM71 14V66H63V22H29V14H71Z'
			fill={fill || 'currentColor'}
		/>
	</svg>
);
export const LinkSVG = ({ fill: _fill }: { fill?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 15 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11.8031 0C10.9842 0 10.1687 0.315672 9.54602 0.938002L7.6876 2.79642C7.05961 3.42407 6.74357 4.24881 6.7496 5.07108C6.74901 5.14561 6.76322 5.21952 6.79143 5.28852C6.81963 5.35752 6.86126 5.42022 6.91389 5.473C6.96653 5.52578 7.02912 5.56758 7.09804 5.59597C7.16696 5.62436 7.24083 5.63878 7.31537 5.63839C7.38991 5.63801 7.46362 5.62282 7.53224 5.59371C7.60086 5.5646 7.66302 5.52215 7.7151 5.46883C7.76718 5.4155 7.80815 5.35237 7.83564 5.28308C7.86312 5.21379 7.87657 5.13974 7.8752 5.06521C7.87129 4.5316 8.06769 3.99899 8.47904 3.58786L10.3433 1.72944C11.1611 0.912112 12.451 0.912112 13.2687 1.72944C14.0865 2.54679 14.0865 3.84337 13.2687 4.6607L11.4103 6.51912C11.0021 6.92713 10.4737 7.12882 9.94467 7.12882C9.87009 7.12776 9.79605 7.14154 9.72684 7.16935C9.65763 7.19716 9.59464 7.23845 9.54153 7.29082C9.48842 7.34318 9.44625 7.40558 9.41746 7.47439C9.38868 7.54319 9.37385 7.61703 9.37385 7.69162C9.37385 7.76621 9.38868 7.84005 9.41746 7.90885C9.44625 7.97766 9.48842 8.04006 9.54153 8.09242C9.59464 8.14479 9.65763 8.18608 9.72684 8.21389C9.79605 8.2417 9.87009 8.25548 9.94467 8.25442C10.7618 8.25442 11.5843 7.93352 12.2076 7.31056L14.066 5.45214C15.3113 4.20748 15.3113 2.18268 14.066 0.938002C13.4434 0.315672 12.6219 0 11.8031 0ZM9.68672 4.68415C9.55917 4.70097 9.44124 4.76097 9.35255 4.85416L4.85014 9.35657C4.79256 9.40761 4.74605 9.46991 4.71349 9.53962C4.68093 9.60934 4.66301 9.68499 4.66084 9.7619C4.65866 9.83881 4.67228 9.91535 4.70085 9.9868C4.72942 10.0582 4.77233 10.1231 4.82694 10.1773C4.88155 10.2315 4.94669 10.2739 5.01834 10.302C5.08999 10.33 5.16663 10.343 5.24353 10.3403C5.32042 10.3376 5.39594 10.3191 5.46541 10.286C5.53488 10.2529 5.59684 10.206 5.64744 10.148L10.1499 5.6456C10.2343 5.56327 10.2907 5.4565 10.3112 5.34036C10.3317 5.22423 10.3152 5.10459 10.264 4.99834C10.2128 4.8921 10.1296 4.80461 10.026 4.74824C9.9224 4.69186 9.80373 4.66944 9.68672 4.68415ZM5.05533 6.75362C4.23818 6.75362 3.41571 7.06866 2.7924 7.69162L0.933983 9.55004C-0.31133 10.7947 -0.311325 12.8254 0.933983 14.07C2.1793 15.3147 4.20867 15.3147 5.45398 14.07L7.3124 12.2116C7.94039 11.584 8.25643 10.7534 8.2504 9.9311C8.25099 9.85657 8.23678 9.78265 8.20857 9.71366C8.18037 9.64466 8.13874 9.58195 8.08611 9.52918C8.03347 9.4764 7.97088 9.4346 7.90196 9.40621C7.83304 9.37781 7.75917 9.36339 7.68463 9.36378C7.61009 9.36417 7.53638 9.37936 7.46776 9.40847C7.39914 9.43758 7.33698 9.48003 7.2849 9.53335C7.23282 9.58667 7.19185 9.64981 7.16436 9.7191C7.13688 9.78838 7.12343 9.86244 7.1248 9.93696C7.12871 10.4706 6.93231 11.0032 6.52096 11.4143L4.65668 13.2727C3.83892 14.0901 2.54904 14.0901 1.73128 13.2727C0.913518 12.4554 0.913524 11.1647 1.73128 10.3473L3.5897 8.48892C3.99793 8.08091 4.52627 7.87922 5.05533 7.87922C5.12991 7.88028 5.20395 7.8665 5.27316 7.83869C5.34237 7.81088 5.40536 7.76959 5.45847 7.71722C5.51158 7.66486 5.55375 7.60246 5.58254 7.53365C5.61132 7.46485 5.62615 7.391 5.62615 7.31642C5.62615 7.24183 5.61132 7.16799 5.58254 7.09919C5.55375 7.03038 5.51158 6.96798 5.45847 6.91561C5.40536 6.86325 5.34237 6.82196 5.27316 6.79415C5.20395 6.76634 5.12991 6.75256 5.05533 6.75362Z'
			fill='currentColor'
		/>
	</svg>
);

export const PulseSVG: FC<ISVGComponent> = ({ ...props }) => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'
		fill={PRIMARY_COLOR}
		{...props}
	>
		<style>
			{
				'.spinner_ZCsl{animation:spinner_qV4G 1.2s cubic-bezier(0.52,.6,.25,.99) infinite}.spinner_gaIW{animation-delay:.6s}@keyframes spinner_qV4G{0%{r:0;opacity:1}100%{r:11px;opacity:0}}'
			}
		</style>
		<circle
			className='spinner_ZCsl'
			cx='12'
			cy='12'
			r='0'
		/>
		<circle
			className='spinner_ZCsl spinner_gaIW'
			cx='12'
			cy='12'
			r='0'
		/>
	</svg>
);

export const PlusSVG: FC<ISVGComponent> = ({ color, ...rest }) => (
	<svg
		width='11'
		height='11'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M10 0C9.40292 0 8.91892 0.484027 8.91892 1.08108V8.91895H1.08108C0.484027 8.91895 0 9.40295 0 10C0 10.5971 0.484027 11.0811 1.08108 11.0811H8.91892V18.9189C8.91892 19.516 9.40292 20 10 20C10.5971 20 11.0811 19.516 11.0811 18.9189V11.0811H18.9189C19.516 11.0811 20 10.5971 20 10C20 9.40295 19.516 8.91895 18.9189 8.91895H11.0811V1.08108C11.0811 0.484027 10.5971 0 10 0Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const MinusSVG: FC<ISVGComponent> = ({ color, ...rest }) => (
	<svg
		width='11'
		height='3'
		viewBox='0 0 20 3'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M0.833333 0C0.373096 0 6.62275e-08 0.522317 0 1.16667C0 1.81102 0.373096 2.33333 0.833333 2.33333H19.1667C19.6269 2.33333 20 1.81102 20 1.16667C20 0.522317 19.6269 0 19.1667 0H0.833333Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const PreviewSVG = ({ color }: { color?: string }) => (
	<svg
		width='15.5'
		height='14'
		viewBox='0 0 62 56'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M51 0H11C4.93 0 0 4.93 0 11V15C0 16.65 1.35 18 3 18C4.65 18 6 16.65 6 15V11C6 8.24 8.24 6 11 6H51C53.76 6 56 8.24 56 11V45C56 47.76 53.76 50 51 50H41C39.35 50 38 51.35 38 53C38 54.65 39.35 56 41 56H51C57.07 56 62 51.07 62 45V11C62 4.93 57.07 0 51 0Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M0 53C0 53.8 0.309999 54.55 0.879999 55.12C2.01 56.25 3.99 56.25 5.12 55.12L22 38.24V51C22 52.65 23.35 54 25 54C26.65 54 28 52.65 28 51V37C28 32.04 23.96 28 19 28H5C3.35 28 2 29.35 2 31C2 32.65 3.35 34 5 34H17.76L0.879999 50.88C0.309999 51.45 0 52.2 0 53Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const RefreshSVG = () => (
	<svg
		width='16'
		height='13'
		viewBox='0 0 56 43'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M41.2419 36.6719C37.5695 39.9007 32.8536 41.6797 27.9641 41.6797C16.8601 41.6797 7.82608 32.6272 7.82608 21.5003C7.82608 18.8585 8.35188 16.3111 9.33602 13.897L12.3184 21.1937C12.4227 21.449 12.6694 21.6036 12.9285 21.6036C13.0122 21.6036 13.0971 21.5879 13.1783 21.5548C13.5155 21.4171 13.676 21.0316 13.5386 20.6937L9.72443 11.3615L0.409433 15.1823C0.0722275 15.3199 -0.0882575 15.7054 0.0491226 16.0433C0.186503 16.3812 0.576787 16.542 0.908373 16.4043L8.09397 13.4558C7.06113 16.0114 6.50848 18.707 6.50848 21.5003C6.50848 33.3555 16.1332 43 27.9641 43C33.174 43 38.1971 41.1053 42.1118 37.665C42.3847 37.4241 42.4115 37.0073 42.1724 36.7333C41.9326 36.4592 41.5173 36.4316 41.2419 36.6719ZM55.8691 21.8169C55.6518 21.5228 55.2391 21.464 54.9481 21.683L48.8934 26.2084C49.2362 24.6684 49.4192 23.0909 49.4192 21.4997C49.4192 9.64448 39.7944 0 27.9635 0C23.9476 0 20.0317 1.11882 16.6371 3.23569C16.3287 3.42904 16.2344 3.83639 16.4261 4.14551C16.619 4.45337 17.0256 4.54911 17.334 4.35701C20.5175 2.37029 24.1943 1.3203 27.9635 1.3203C39.0676 1.3203 48.1016 10.3728 48.1016 21.4997C48.1016 23.1391 47.8942 24.7642 47.5058 26.3435L42.7069 19.8991C42.4883 19.605 42.0756 19.5455 41.7858 19.7651C41.4936 19.9829 41.4349 20.3965 41.6522 20.6881L47.6701 28.7714L55.7355 22.7399C56.0271 22.5221 56.0865 22.1085 55.8691 21.8169Z'
			fill='currentColor'
		/>
	</svg>
);

export const BackArrowSVG: FC<ISVGComponent & ISVG> = ({ color = '#7D7D7D', ...rest }) => (
	<svg
		width='13'
		height='8'
		viewBox='0 0 19 8'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53554C4.02369 7.7308 4.34027 7.7308 4.53553 7.53554C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976312 4.7308 0.659729 4.53553 0.464467C4.34027 0.269205 4.02369 0.269205 3.82843 0.464467L0.646447 3.64645ZM19 3.5L1 3.5L1 4.5L19 4.5L19 3.5Z'
			fill={color}
		/>
	</svg>
);

export const SwitchOffSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 11 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5.17762 12C4.15424 12.0004 3.15371 11.6974 2.3025 11.1293C1.45129 10.5612 0.7876 9.75348 0.395325 8.80827C0.00304991 7.86306 -0.100204 6.82277 0.0986137 5.81889C0.297432 4.81501 0.789396 3.8926 1.51233 3.16826C1.5637 3.11587 1.62494 3.07416 1.69251 3.04553C1.76007 3.01691 1.83264 3.00194 1.90601 3.00148C1.97939 3.00102 2.05214 3.01509 2.12006 3.04287C2.18797 3.07064 2.24973 3.11158 2.30175 3.16333C2.35378 3.21508 2.39506 3.27661 2.4232 3.34437C2.45135 3.41214 2.4658 3.48481 2.46574 3.55819C2.46568 3.63157 2.4511 3.70421 2.42285 3.77193C2.39459 3.83965 2.35321 3.90111 2.3011 3.95277C1.73429 4.52132 1.34867 5.24509 1.19295 6.03266C1.03723 6.82023 1.11839 7.63629 1.42619 8.37777C1.73398 9.11924 2.2546 9.75288 2.92229 10.1986C3.58998 10.6444 4.3748 10.8823 5.17762 10.8823C5.98044 10.8823 6.76525 10.6444 7.43295 10.1986C8.10064 9.75288 8.62125 9.11924 8.92905 8.37777C9.23684 7.63629 9.318 6.82023 9.16228 6.03266C9.00656 5.24509 8.62094 4.52132 8.05413 3.95277C7.95132 3.84793 7.89413 3.70668 7.89505 3.55983C7.89596 3.41299 7.95491 3.27246 8.05903 3.16891C8.16314 3.06535 8.30398 3.00717 8.45083 3.00705C8.59768 3.00692 8.73862 3.06488 8.84291 3.16826C9.56552 3.89272 10.0572 4.81511 10.2558 5.81888C10.4545 6.82266 10.3512 7.86279 9.95895 8.80787C9.56673 9.75296 8.9032 10.5606 8.05218 11.1287C7.20117 11.6969 6.20086 12.0001 5.17762 12ZM5.17762 5.20619C5.02573 5.20602 4.8801 5.14561 4.7727 5.03821C4.6653 4.9308 4.60488 4.78518 4.60471 4.63329V0.572903C4.60471 0.42096 4.66507 0.27524 4.77251 0.167799C4.87995 0.0603593 5.02567 0 5.17762 0C5.32956 0 5.47528 0.0603593 5.58272 0.167799C5.69016 0.27524 5.75052 0.42096 5.75052 0.572903V4.63329C5.75035 4.78518 5.68993 4.9308 5.58253 5.03821C5.47513 5.14561 5.32951 5.20602 5.17762 5.20619Z'
			fill='red'
		/>
	</svg>
);

export const AdminManagementSVG = ({ color }: { color?: string }) => (
	<svg
		width='10'
		height='12'
		viewBox='0 0 10 12'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9.47381 12C9.2715 12 9.09486 11.8357 9.09486 11.6211V8.84211C9.09486 7.51579 8.00834 6.42922 6.68198 6.42922H3.17078C1.84446 6.42922 0.757895 7.51574 0.757895 8.84211V11.6211C0.757895 11.8234 0.593583 12 0.378947 12C0.164312 12 0 11.8357 0 11.6211V8.84211C0 7.09882 1.41461 5.67133 3.17078 5.67133H6.6696C8.41288 5.67133 9.84038 7.08594 9.84038 8.84211V11.6211C9.83989 11.8357 9.67611 12 9.47381 12ZM7.51592 2.58947C7.51592 1.16198 6.35391 0 4.92644 0C3.49897 0 2.33697 1.162 2.33697 2.58947C2.33697 4.01694 3.49897 5.19183 4.92644 5.19183C6.35391 5.19183 7.51592 4.02933 7.51592 2.58947ZM6.77085 2.58947C6.77085 3.6 5.9498 4.43394 4.92639 4.43394C3.90298 4.43394 3.08193 3.61288 3.08193 2.58947C3.08193 1.57895 3.91581 0.757895 4.92639 0.757895C5.93697 0.757895 6.77085 1.57895 6.77085 2.58947Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const OneColumnSVG = ({ color }: { color?: string }) => (
	<svg
		width='7'
		height='14'
		viewBox='0 0 7 19'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<rect
			x='0.5'
			y='0.5'
			width='5.92308'
			height='17.4615'
			rx='1.5'
			stroke={color || 'currentColor'}
		/>
	</svg>
);

export const TwoColumnSVG = ({ color }: { color?: string }) => (
	<svg
		width='15'
		height='14'
		viewBox='0 0 15 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<rect
			x='0.5'
			y='1.26953'
			width='5.92308'
			height='17.4615'
			rx='1.5'
			stroke={color || 'currentColor'}
		/>
		<rect
			x='8.57617'
			y='1.26953'
			width='5.92308'
			height='17.4615'
			rx='1.5'
			stroke={color || 'currentColor'}
		/>
	</svg>
);

export const UploadSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width={width || '22'}
		height={height || '22'}
		viewBox='0 0 22 22'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M2.75 21.5H18.75C19.4792 21.4995 20.1783 21.2096 20.694 20.694C21.2096 20.1783 21.4995 19.4792 21.5 18.75V15.75C21.5 15.5511 21.421 15.3603 21.2803 15.2197C21.1397 15.079 20.9489 15 20.75 15C20.5511 15 20.3603 15.079 20.2197 15.2197C20.079 15.3603 20 15.5511 20 15.75V18.75C19.9995 19.0814 19.8676 19.399 19.6333 19.6333C19.399 19.8676 19.0814 19.9995 18.75 20H2.75C2.41864 19.9995 2.10101 19.8676 1.8667 19.6333C1.63239 19.399 1.50053 19.0814 1.5 18.75V15.75C1.5 15.5511 1.42098 15.3603 1.28033 15.2197C1.13968 15.079 0.948912 15 0.75 15C0.551088 15 0.360322 15.079 0.21967 15.2197C0.0790177 15.3603 0 15.5511 0 15.75V18.75C0.000529737 19.4792 0.290431 20.1783 0.806041 20.694C1.32165 21.2096 2.02082 21.4995 2.75 21.5Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M10.75 15.5C10.9489 15.5 11.1396 15.421 11.2803 15.2803C11.4209 15.1397 11.5 14.9489 11.5 14.75V2.35L16.27 6.325C16.4233 6.4467 16.6182 6.50359 16.813 6.48353C17.0078 6.46346 17.187 6.36803 17.3123 6.21762C17.4377 6.0672 17.4992 5.87373 17.4838 5.67854C17.4684 5.48335 17.3773 5.30192 17.23 5.173L11.23 0.173C11.1934 0.146641 11.1542 0.124185 11.113 0.106C11.0838 0.08616 11.053 0.0687675 11.021 0.054C10.9372 0.020521 10.8481 0.00256161 10.758 0.00100005L10.75 0H10.742C10.6518 0.00156156 10.5627 0.0195209 10.479 0.053C10.4469 0.0677675 10.4161 0.0851601 10.387 0.105C10.3457 0.123185 10.3065 0.145641 10.27 0.172L4.26997 5.172C4.1226 5.30092 4.0315 5.48235 4.01611 5.67754C4.00073 5.87273 4.06228 6.0662 4.18763 6.21662C4.31297 6.36703 4.49217 6.46246 4.68693 6.48253C4.8817 6.50259 5.07659 6.4457 5.22997 6.324L9.99997 2.35V14.75C9.99997 14.9489 10.079 15.1397 10.2196 15.2803C10.3603 15.421 10.5511 15.5 10.75 15.5Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const ImportVotersSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M14.08 14.15C11.29 12.29 6.74 12.29 3.93 14.15C2.66 14.99 1.96 16.15 1.96 17.4C1.96 18.65 2.66 19.8 3.92 20.63C5.32 21.57 7.16 22.04 9 22.04C10.84 22.04 12.68 21.57 14.08 20.63C15.34 19.79 16.04 18.64 16.04 17.38C16.03 16.13 15.34 14.98 14.08 14.15Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M19.99 7.34C20.15 9.28 18.77 10.98 16.86 11.21C16.85 11.21 16.85 11.21 16.84 11.21H16.81C16.75 11.21 16.69 11.21 16.64 11.23C15.67 11.28 14.78 10.97 14.11 10.4C15.14 9.48 15.73 8.1 15.61 6.6C15.54 5.79 15.26 5.05 14.84 4.42C15.22 4.23 15.66 4.11 16.11 4.07C18.07 3.9 19.82 5.36 19.99 7.34Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M21.99 16.59C21.91 17.56 21.29 18.4 20.25 18.97C19.25 19.52 17.99 19.78 16.74 19.75C17.46 19.1 17.88 18.29 17.96 17.43C18.06 16.19 17.47 15.0 16.29 14.05C15.62 13.52 14.84 13.1 13.99 12.79C16.2 12.15 18.98 12.58 20.69 13.96C21.61 14.7 22.08 15.63 21.99 16.59Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const StateSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='22'
		height='20'
		viewBox='0 0 22 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M20.9901 20C21.0918 19.9983 21.1876 19.95 21.2493 19.8683C21.3109 19.7875 21.3326 19.6825 21.3068 19.5833L17.9734 7.91663C17.9359 7.77163 17.8068 7.66912 17.6568 7.66663H11.9235L11.5401 8.33329H13.1568L12.7068 9.39995L11.8401 9.53328C11.7285 9.55328 11.6343 9.62828 11.5901 9.73328L11.2568 10.5333C11.1976 10.6774 11.246 10.8433 11.3735 10.9333L12.2235 11.5499L11.5401 12.4666L10.7068 12.3333C10.5793 12.3091 10.4493 12.3608 10.3735 12.4666L8.64016 14.9666L8.4235 14.85V14.1666C8.42184 14.0783 8.386 13.995 8.3235 13.9333L7.62352 13.2333L8.52352 11.8667C8.59936 11.7483 8.59269 11.595 8.50686 11.4833L7.99019 10.75L8.44019 10.4667C8.52102 10.4133 8.57519 10.3275 8.58769 10.2317C8.60102 10.1358 8.57102 10.0392 8.50686 9.96667L7.85686 9.25L8.00685 8.35H8.39019L8.0402 7.68333H3.65686C3.50687 7.68583 3.3777 7.78833 3.34019 7.93334L0.00688207 19.6C-0.0131178 19.6967 0.0110487 19.7967 0.0718822 19.8734C0.133548 19.9509 0.225215 19.9967 0.32355 20L20.9901 20ZM12.1067 10.1667L12.9734 10.0333C13.0917 10.0192 13.1934 9.9425 13.2401 9.83333L13.8734 8.33335H17.4066L19.1399 14.4167L18.1066 13.9167L17.3899 12.6667C17.3416 12.5892 17.2633 12.5351 17.1733 12.5167L14.0398 11.8167L12.8232 11.1834L11.9399 10.5334L12.1067 10.1667ZM10.8067 13.0334L11.5901 13.1668C11.7126 13.1843 11.8342 13.1334 11.9067 13.0334L12.7401 11.9001L13.7734 12.4334L13.8567 12.4668L16.8735 13.1334L17.5734 14.3334C17.6043 14.3901 17.6501 14.4359 17.7068 14.4667L19.3734 15.2834L20.5234 19.3333H12.6069C12.6052 19.2866 12.5935 19.2416 12.5735 19.2L12.1235 18.15C12.0944 18.0791 12.041 18.02 11.9735 17.9833L10.1236 16.9666L10.3902 16.35C10.4561 16.1975 10.3994 16.0191 10.2569 15.9333L9.20689 15.3167L10.8067 13.0334ZM3.90673 8.3335H7.34009L7.17343 9.28349C7.15593 9.38599 7.18676 9.49015 7.25676 9.56681L7.75677 10.1168L7.32345 10.3668C7.24511 10.4176 7.19178 10.4985 7.17595 10.5901C7.16012 10.6818 7.18345 10.776 7.24011 10.8502L7.85677 11.6835L7.02345 12.9335H5.32345L4.55678 11.9668L4.24011 11.2668C4.19595 11.1618 4.10178 11.0868 3.99011 11.0668L3.15679 10.9002L3.90673 8.3335ZM2.99006 11.5501L3.70673 11.6835L3.97339 12.2668L4.00673 12.3335L4.89005 13.4668C4.95338 13.5509 5.05172 13.6001 5.15672 13.6001H7.07338L7.77336 14.3001V15.0501C7.77503 15.1676 7.83836 15.2751 7.94003 15.3334L9.69001 16.3501L9.42334 16.9667C9.35001 17.1284 9.41585 17.3184 9.57334 17.4L11.59 18.5167L11.94 19.3334H0.773334L2.99006 11.5501Z'
			fill='currentColor'
		/>
		<path
			d='M9.94057 8.5347e-05C9.02391 8.5347e-05 8.14058 0.48341 7.52395 1.33341C7.12977 1.88758 6.89312 2.5384 6.84062 3.21673C6.78729 3.89506 6.91979 4.57505 7.22396 5.18339C7.45062 5.61006 7.7123 6.01756 8.00729 6.40005C8.21729 6.67838 8.41228 6.96755 8.59063 7.26671C8.99063 7.96669 9.33646 8.69669 9.62397 9.44995C9.67063 9.57578 9.78897 9.66161 9.92395 9.66661C10.0548 9.66411 10.1715 9.58661 10.2239 9.46661C10.5489 8.72078 10.9214 7.99745 11.3406 7.30001C11.5156 7.02334 11.7048 6.75667 11.9073 6.50001C12.2223 6.10919 12.5006 5.69084 12.7406 5.25002C13.0764 4.58169 13.2022 3.82835 13.1014 3.08747C12.9997 2.34663 12.6764 1.6533 12.1739 1.09998C11.6181 0.434152 10.8073 0.0342398 9.94057 8.5347e-05ZM12.1739 4.93339C11.9523 5.33838 11.6956 5.72338 11.4073 6.08338C11.1923 6.36171 10.9914 6.65088 10.8073 6.95004C10.4406 7.56669 10.1573 8.10002 9.97396 8.50002C9.79063 8.10002 9.54064 7.55003 9.19062 6.95004C8.99729 6.62754 8.78564 6.31587 8.55728 6.01671C8.28228 5.66505 8.03729 5.29172 7.82396 4.90004C7.57395 4.3992 7.46562 3.84004 7.50978 3.28173C7.55395 2.72423 7.74895 2.18923 8.07394 1.73341C8.57395 1.05008 9.24061 0.666748 9.95725 0.666748C10.6431 0.690082 11.2856 1.00507 11.7239 1.53341C12.5614 2.46507 12.7406 3.81574 12.1739 4.93339Z'
			fill='currentColor'
		/>
		<path
			d='M9.98985 1.83345C9.35402 1.84012 8.81153 2.29512 8.69403 2.91927C8.57653 3.54427 8.9157 4.16508 9.50569 4.40342C10.0949 4.64092 10.7699 4.42925 11.119 3.89842C11.4673 3.36675 11.3923 2.66259 10.9399 2.21677C10.6882 1.96593 10.3457 1.82763 9.98985 1.83345ZM9.98985 3.83344C9.62151 3.83344 9.32319 3.53511 9.32319 3.16678C9.32319 2.79844 9.62151 2.50011 9.98985 2.50011C10.3582 2.50011 10.6565 2.79844 10.6565 3.16678C10.6565 3.53511 10.3582 3.83344 9.98985 3.83344Z'
			fill='currentColor'
		/>
	</svg>
);

export const LGASVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='14'
		height='20'
		viewBox='0 0 14 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.32673 14.2668V10.47C9.98857 10.2195 12.0792 7.97395 12.0792 5.24752C12.0792 2.354 9.72502 0 6.83168 0C3.93835 0 1.58416 2.354 1.58416 5.24752C1.58416 7.97395 3.6748 10.2195 6.33663 10.47V14.2668C3.17854 14.3615 0 15.3565 0 17.1287C0 18.9937 3.51988 20 6.83168 20C10.1435 20 13.6634 18.9937 13.6634 17.1287C13.6634 15.3565 10.4848 14.3615 7.32673 14.2668ZM2.57426 5.24752C2.57426 2.89991 4.48407 0.990099 6.83168 0.990099C9.1793 0.990099 11.0891 2.89991 11.0891 5.24752C11.0891 7.59514 9.1793 9.50495 6.83168 9.50495C4.48407 9.50495 2.57426 7.59514 2.57426 5.24752ZM6.83168 19.0099C3.26578 19.0099 0.990099 17.8957 0.990099 17.1287C0.990099 16.3981 3.05814 15.3546 6.33663 15.2571V17.1287C6.33663 17.4022 6.55825 17.6238 6.83168 17.6238C7.10512 17.6238 7.32673 17.4022 7.32673 17.1287V15.2571C10.6052 15.3546 12.6733 16.3981 12.6733 17.1287C12.6733 17.8957 10.3976 19.0099 6.83168 19.0099Z'
			fill='currentColor'
		/>
	</svg>
);

export const WardSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='21'
		height='20'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M8.08497 20H1.94482C0.872513 20 0.00488281 19.1279 0.00488281 18.0601V13.1302C0.00488281 12.9566 0.142814 12.8187 0.31634 12.8187C0.489866 12.8187 0.627797 12.9566 0.627797 13.1302V18.0601C0.627797 18.7853 1.21957 19.3771 1.94482 19.3771H8.08497C8.2585 19.3771 8.39643 19.515 8.39643 19.6886C8.39643 19.8621 8.2585 20 8.08497 20Z'
			fill='currentColor'
		/>
		<path
			d='M18.4739 19.7998H13.9221C13.7486 19.7998 13.6107 19.6618 13.6107 19.4883C13.6107 19.3148 13.7486 19.1769 13.9221 19.1769H18.4739C19.1991 19.1769 19.7909 18.5851 19.7909 17.8598V1.93993C19.7909 1.21468 19.1991 0.622914 18.4739 0.622914H1.94438C1.21468 0.622914 0.622914 1.21468 0.622914 1.93993V9.10345C0.622914 9.27697 0.484983 9.4149 0.311457 9.4149C0.137931 9.4149 0 9.27697 0 9.10345V1.93993C0 0.86763 0.87208 0 1.93993 0H18.4694C19.5417 0 20.4093 0.872079 20.4093 1.93993V17.8554C20.4138 18.9277 19.5417 19.7998 18.4739 19.7998Z'
			fill='currentColor'
		/>
		<path
			d='M12.1911 20H8.32904C8.15551 20 8.01758 19.8621 8.01758 19.6885V13.5751C8.01758 13.4015 8.15551 13.2636 8.32904 13.2636H12.1911C12.3646 13.2636 12.5026 13.4015 12.5026 13.5751V19.6885C12.5026 19.8621 12.3646 20 12.1911 20ZM8.64494 19.3771H11.8796V13.8865H8.64049V19.3771H8.64494Z'
			fill='currentColor'
		/>
		<path
			d='M10.247 9.40601C10.0735 9.40601 9.93555 9.26808 9.93555 9.09455V4.11569C9.93555 3.94216 10.0735 3.80423 10.247 3.80423C10.4205 3.80423 10.5585 3.94216 10.5585 4.11569V9.09455C10.5585 9.26363 10.4161 9.40601 10.247 9.40601Z'
			fill='currentColor'
		/>
		<path
			d='M12.7347 6.91436H7.75579C7.58227 6.91436 7.44434 6.77643 7.44434 6.6029C7.44434 6.42937 7.58227 6.29144 7.75579 6.29144H12.7347C12.9082 6.29144 13.0461 6.42937 13.0461 6.6029C13.0461 6.77643 12.9082 6.91436 12.7347 6.91436Z'
			fill='currentColor'
		/>
		<path
			d='M10.2691 10.4916C8.07999 10.4916 6.30469 8.71189 6.30469 6.52724C6.30469 4.34259 8.08444 2.56284 10.2691 2.56284C12.4537 2.56284 14.2335 4.34259 14.2335 6.52724C14.2335 8.71189 12.4537 10.4916 10.2691 10.4916ZM10.2691 3.18575C8.42705 3.18575 6.9276 4.68519 6.9276 6.52724C6.9276 8.36929 8.42705 9.86873 10.2691 9.86873C12.1111 9.86873 13.6106 8.36929 13.6106 6.52724C13.6106 4.68519 12.1111 3.18575 10.2691 3.18575Z'
			fill='currentColor'
		/>
		<path
			d='M5.59772 17.0456H3.01263C2.8391 17.0456 2.70117 16.9077 2.70117 16.7341C2.70117 16.5606 2.8391 16.4227 3.01263 16.4227H5.28627V14.149C5.28627 13.9755 5.4242 13.8376 5.59772 13.8376C5.77125 13.8376 5.90918 13.9755 5.90918 14.149V16.7341C5.90918 16.9032 5.7668 17.0456 5.59772 17.0456Z'
			fill='currentColor'
		/>
		<path
			d='M17.5264 17.0456H14.9413C14.7678 17.0456 14.6299 16.9077 14.6299 16.7341C14.6299 16.5606 14.7678 16.4227 14.9413 16.4227H17.215V14.149C17.215 13.9755 17.3529 13.8376 17.5264 13.8376C17.7 13.8376 17.8379 13.9755 17.8379 14.149V16.7341C17.8379 16.9032 17.7 17.0456 17.5264 17.0456Z'
			fill='currentColor'
		/>
	</svg>
);

export const PollingSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M3.29428 1.10016L1.98998 0.721313L0.721313 5.08716L2.02562 5.46626C2.44902 4.01098 2.87089 2.55544 3.29428 1.10016ZM7.53869 13.1348C7.71716 13.1348 7.86203 13.2796 7.86203 13.4581C7.86203 13.6366 7.71716 13.7814 7.53869 13.7814H6.09766L3.93307 17.0378H18.1684L15.9071 13.6361C15.8088 13.4876 15.8495 13.2875 15.998 13.1892C16.1464 13.091 16.3465 13.1317 16.4448 13.2801L19.0259 17.1628C19.0684 17.2178 19.0939 17.2865 19.0939 17.3611V19.6767C19.0939 19.8551 18.949 20 18.7705 20H3.33095C3.15247 20 3.00761 19.8551 3.00761 19.6767V17.3611C3.00761 17.2865 3.03307 17.2178 3.07558 17.1628L5.64372 13.2997C5.69896 13.2015 5.80462 13.1348 5.92556 13.1348H7.53869ZM18.4472 17.6844H3.65429V19.3533H18.4472V17.6844ZM14.8704 15.0863C15.0488 15.0863 15.1937 15.2311 15.1937 15.4096C15.1937 15.5881 15.0488 15.7329 14.8704 15.7329H7.65097C7.47249 15.7329 7.32763 15.5881 7.32763 15.4096C7.32763 15.2311 7.47249 15.0863 7.65097 15.0863H8.92651L6.91976 7.81417C6.54932 7.67643 6.21274 7.56619 5.93498 7.50712C4.12631 7.12293 3.70139 6.75606 2.65244 5.61775L2.55442 5.95509C2.50503 6.12592 2.3263 6.2242 2.15547 6.17481L0.232485 5.61596C0.0616493 5.56657 -0.0366256 5.38784 0.0127664 5.21701L1.46118 0.232485C1.51057 0.0616493 1.6893 -0.0366256 1.86013 0.0127665L3.78311 0.571355C3.95395 0.620747 4.05222 0.799475 4.00283 0.97031L3.92314 1.24477L9.86979 2.68528C10.3451 2.79247 10.7268 2.94778 11.0852 3.18939C11.4394 3.42846 11.7648 3.74849 12.1316 4.18818L16.0942 8.75771C16.6826 9.43621 16.9685 9.94261 17.0248 10.2957C17.0736 10.6025 16.9802 10.8271 16.7709 10.9753C16.6029 11.0949 16.3689 11.1402 16.0873 11.1186C15.6102 11.0822 14.9256 10.8482 14.1738 10.4663L15.2227 13.7769C15.2762 13.9469 15.182 14.1287 15.0119 14.1822L11.7342 15.0863H14.8704ZM9.79341 6.58522C9.61774 6.5567 9.49833 6.39096 9.52685 6.21529C9.55536 6.03962 9.72111 5.92021 9.89678 5.94872C10.0238 5.9696 10.2743 6.05235 10.5788 6.18015L12.5785 6.17506C12.7223 6.17506 12.8445 6.26977 12.8855 6.40013L13.8917 9.57548C14.7919 10.1053 15.6237 10.4358 16.1352 10.4745C16.2684 10.4846 16.3603 10.4768 16.3997 10.449L16.3883 10.3966C16.3501 10.1565 16.111 9.76057 15.6069 9.17932L11.6367 4.60215C11.3085 4.2088 11.0239 3.92671 10.7242 3.72455C10.4337 3.52877 10.1208 3.40198 9.72824 3.31338L3.74314 1.8642L2.86299 4.89316L2.91595 4.95095C4.01989 6.15469 4.34527 6.5096 6.0689 6.87572C6.74562 7.01931 7.73091 7.43634 8.38319 7.70367C9.57038 8.19046 10.8342 8.70857 11.5906 8.71112L11.6359 8.71137C11.9753 8.7129 12.3127 8.71442 12.386 8.3753C12.4046 8.13827 12.1319 7.8465 11.7648 7.57026C11.4111 7.30421 10.3164 6.67102 9.79341 6.58522ZM7.6693 8.10772L9.57471 15.0132L14.5058 13.6526L12.9509 8.7437C12.72 9.36034 12.1787 9.35805 11.6334 9.3555L11.5893 9.35525C10.7051 9.35194 9.38173 8.80914 8.13827 8.29943L7.6693 8.10772ZM12.514 7.36404L12.3417 6.81971L11.8126 6.82123C11.9303 6.89634 12.0443 6.97425 12.1512 7.05495C12.2824 7.15348 12.4048 7.25685 12.514 7.36404Z'
			fill='currentColor'
		/>
	</svg>
);

export const OverviewSVG = ({ color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.03699 0H1.85184C0.829625 0 0 0.829625 0 1.85184V7.03699C0 8.05921 0.829625 8.88884 1.85184 8.88884H7.03699C8.05921 8.88884 8.88884 8.05921 8.88884 7.03699V1.85184C8.88884 0.829625 8.05921 0 7.03699 0ZM8.1481 7.03711C8.1481 7.64821 7.6481 8.14822 7.03699 8.14822H1.85184C1.24074 8.14822 0.740736 7.64821 0.740736 7.03711V1.85196C0.740736 1.24086 1.24074 0.740855 1.85184 0.740855H7.03699C7.6481 0.740855 8.1481 1.24086 8.1481 1.85196V7.03711Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M18.1483 0H12.9632C11.941 0 11.1113 0.829625 11.1113 1.85184V7.03699C11.1113 8.05921 11.941 8.88884 12.9632 8.88884H18.1483C19.1705 8.88884 20.0002 8.05921 20.0002 7.03699V1.85184C20.0002 0.829625 19.1705 0 18.1483 0ZM19.2594 7.03711C19.2594 7.64821 18.7594 8.14822 18.1483 8.14822H12.9632C12.3521 8.14822 11.8521 7.64821 11.8521 7.03711V1.85196C11.8521 1.24086 12.3521 0.740855 12.9632 0.740855H18.1483C18.7594 0.740855 19.2594 1.24086 19.2594 1.85196V7.03711Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M7.03699 11.1111H1.85184C0.829625 11.1111 0 11.9408 0 12.963V18.1481C0 19.1704 0.829625 20 1.85184 20H7.03699C8.05921 20 8.88884 19.1704 8.88884 18.1481V12.963C8.88884 11.9408 8.05921 11.1111 7.03699 11.1111ZM8.1481 18.1483C8.1481 18.7594 7.6481 19.2594 7.03699 19.2594H1.85184C1.24074 19.2594 0.740736 18.7594 0.740736 18.1483V12.9631C0.740736 12.352 1.24074 11.852 1.85184 11.852H7.03699C7.6481 11.852 8.1481 12.352 8.1481 12.9631V18.1483Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M18.1483 11.1111H12.9632C11.941 11.1111 11.1113 11.9408 11.1113 12.963V18.1481C11.1113 19.1704 11.941 20 12.9632 20H18.1483C19.1705 20 20.0002 19.1704 20.0002 18.1481V12.963C20.0002 11.9408 19.1705 11.1111 18.1483 11.1111ZM19.2594 18.1483C19.2594 18.7594 18.7594 19.2594 18.1483 19.2594H12.9632C12.3521 19.2594 11.8521 18.7594 11.8521 18.1483V12.9631C11.8521 12.352 12.3521 11.852 12.9632 11.852H18.1483C18.7594 11.852 19.2594 12.352 19.2594 12.9631V18.1483Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const VerificationRequestSVG = ({ color }: { color?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10.2049 8.98815C9.90738 9.28568 9.42498 9.28568 9.12745 8.98815C8.82991 8.69062 8.82991 8.20818 9.12745 7.91065C9.42498 7.61312 9.90738 7.61312 10.2049 7.91065C10.5024 8.20818 10.5024 8.69062 10.2049 8.98815Z'
			fill={color || 'currentColor'}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M6.77109 5.5537C8.37036 3.95443 10.9633 3.95443 12.5626 5.5537C14.1618 7.15297 14.1618 9.7459 12.5626 11.3452C11.5323 12.3754 10.0904 12.7412 8.76856 12.4453L7.17489 14.039C6.31946 14.8944 4.93256 14.8944 4.07712 14.039C3.22169 13.1836 3.22169 11.7966 4.07712 10.9412L5.67089 9.34747C5.37509 8.0257 5.74089 6.58387 6.77109 5.5537ZM11.6198 6.4965C10.5412 5.41793 8.79246 5.41793 7.71389 6.4965C6.94782 7.26257 6.72489 8.36753 7.04892 9.33183C7.12952 9.57173 7.06732 9.8366 6.88836 10.0156L5.01992 11.884C4.68519 12.2187 4.68519 12.7614 5.01992 13.0962C5.35466 13.4309 5.89736 13.4309 6.23209 13.0962L8.10046 11.2278C8.27942 11.0488 8.54432 10.9867 8.78422 11.0673C9.74859 11.3914 10.8536 11.1685 11.6198 10.4024C12.6983 9.3238 12.6983 7.57507 11.6198 6.4965Z'
			fill={color || 'currentColor'}
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9.33664 0.08616C8.89727 -0.02872 8.43607 -0.02872 7.9967 0.08616L1.9967 1.65497C0.81711 1.96339 0 3.03538 0 4.25509V9.67739C0 13.5675 2.08017 17.1579 5.4453 19.0643L5.7286 19.2247C7.55327 20.2584 9.78007 20.2584 11.6047 19.2247L11.888 19.0643C15.2532 17.1579 17.3333 13.5675 17.3333 9.67739V4.25509C17.3333 3.03538 16.5162 1.96339 15.3366 1.65497L9.33664 0.08616ZM8.334 1.37613C8.5522 1.31907 8.78114 1.31907 8.99934 1.37613L14.9993 2.94495C15.5845 3.09795 16 3.63392 16 4.25509V9.67739C16 13.0917 14.1743 16.2366 11.2308 17.9041L10.9475 18.0646C9.53057 18.8674 7.80277 18.8674 6.3858 18.0646L6.10254 17.9041C3.15907 16.2366 1.33333 13.0917 1.33333 9.67739V4.25509C1.33333 3.63392 1.7488 3.09795 2.334 2.94495L8.334 1.37613Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);
export const CogSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M10.9618 0.824668H9.03816C8.88799 0.824668 8.76645 0.946194 8.76645 1.09551V2.29082C8.76732 2.4844 8.63277 2.65193 8.4444 2.6936C7.56507 2.88197 6.72652 3.22744 5.96863 3.71355C5.80457 3.83855 5.57281 3.82379 5.42697 3.67796L4.57975 2.83074C4.47384 2.72744 4.3037 2.72744 4.19779 2.83074L2.83582 4.19271V4.19358C2.73165 4.29948 2.73165 4.46963 2.83582 4.57554L3.68217 5.42189C3.81932 5.55991 3.84276 5.77431 3.73773 5.93751C3.24466 6.69358 2.89484 7.53386 2.70475 8.41573C2.67437 8.61712 2.50163 8.76642 2.29764 8.76642H1.09538C0.94607 8.76642 0.824533 8.88795 0.824533 9.03813V10.9626V10.9617C0.824533 11.1119 0.946059 11.2335 1.09538 11.2335H2.29068C2.48426 11.2326 2.6518 11.3671 2.69346 11.5555C2.88183 12.4348 3.2273 13.2734 3.71341 14.0313C3.83841 14.1953 3.82366 14.4271 3.67782 14.5729L2.8306 15.4202C2.72731 15.5261 2.72731 15.6962 2.8306 15.8021L4.19258 17.1641H4.19345C4.29935 17.2683 4.46949 17.2683 4.5754 17.1641L5.42175 16.3177C5.55977 16.1806 5.77418 16.1571 5.93738 16.2622C6.69344 16.7552 7.53373 17.1051 8.41559 17.2952C8.61698 17.3255 8.76628 17.4983 8.76628 17.7023V18.8976C8.76628 19.0477 8.88781 19.1693 9.03799 19.1693H10.9625H10.9616C11.1118 19.1693 11.2333 19.0478 11.2333 18.8976V17.7092C11.2325 17.5156 11.367 17.3481 11.5554 17.3064C12.4347 17.118 13.2732 16.7726 14.0311 16.2865C14.1952 16.1615 14.427 16.1762 14.5728 16.3221L15.42 17.1693C15.5259 17.2726 15.6961 17.2726 15.802 17.1693L17.1639 15.8073V15.8064C17.2681 15.7005 17.2681 15.5304 17.1639 15.4245L16.3219 14.5781C16.1848 14.4401 16.1613 14.2257 16.2664 14.0625C16.7594 13.3064 17.1093 12.4662 17.3002 11.5843C17.3297 11.3829 17.5025 11.2336 17.7065 11.2336H18.9018C19.0519 11.2336 19.1735 11.1121 19.1735 10.9619V9.03829C19.1735 8.88812 19.052 8.76658 18.9018 8.76658H17.7091C17.5155 8.76745 17.3479 8.6329 17.3063 8.44454C17.1179 7.56521 16.7724 6.72665 16.2863 5.96877C16.1613 5.8047 16.1761 5.57294 16.3219 5.4271L17.1691 4.57988C17.2724 4.47398 17.2724 4.30384 17.1691 4.19793L15.8072 2.83595H15.8063C15.7004 2.73178 15.5303 2.73178 15.4243 2.83595L14.578 3.67797C14.44 3.81512 14.2256 3.83856 14.0624 3.73353C13.3063 3.24046 12.466 2.89064 11.5842 2.69968C11.3828 2.67017 11.2335 2.49743 11.2335 2.29344V1.09553C11.2335 0.946226 11.1119 0.824668 10.9618 0.824668ZM9.03816 2.51134e-05H10.9626H10.9618C11.5677 2.51134e-05 12.0581 0.490468 12.0581 1.09551V1.96444C12.8185 2.15976 13.5468 2.46271 14.2222 2.86462L14.8376 2.24918C15.0434 2.04171 15.3237 1.92627 15.6154 1.92627C15.9071 1.92627 16.1875 2.04172 16.3932 2.24918L17.7534 3.60942V3.60855C17.96 3.81515 18.0763 4.09466 18.0763 4.38633C18.0763 4.67886 17.96 4.95837 17.7534 5.1641L17.1354 5.77781C17.5338 6.4549 17.8333 7.18492 18.0243 7.94707H18.8932C19.1849 7.9436 19.4661 8.05732 19.6736 8.26218C19.881 8.46704 19.9991 8.74569 20 9.03823V10.9627V10.9618C20 11.5678 19.5095 12.0582 18.9045 12.0582H18.0356C17.8437 12.8195 17.5451 13.5495 17.1467 14.2266L17.7621 14.842C17.9687 15.0486 18.085 15.3281 18.085 15.6198C18.085 15.9123 17.9687 16.1919 17.7621 16.3976L16.4019 17.7578C16.1961 17.9644 15.9166 18.0807 15.6241 18.0807C15.3324 18.0807 15.0529 17.9644 14.8463 17.7578L14.2222 17.1354C13.546 17.5347 12.8151 17.8342 12.0529 18.0243V18.8958C12.0555 19.1866 11.9418 19.467 11.737 19.6745C11.5321 19.882 11.2534 19.9991 10.9618 20H9.03818C8.43227 20 7.94183 19.5096 7.94183 18.9045V18.0356C7.18054 17.8437 6.45052 17.5451 5.77343 17.1467L5.15799 17.7621C4.95139 17.9687 4.67188 18.085 4.38021 18.085C4.08768 18.085 3.80817 17.9687 3.60244 17.7621L2.2422 16.4019C2.0356 16.1962 1.91928 15.9167 1.91928 15.6241C1.91928 15.3325 2.0356 15.0529 2.2422 14.8463L2.86459 14.2222C2.46268 13.546 2.15973 12.8151 1.96442 12.053H1.09549C0.492199 12.053 0.00259999 11.566 0 10.9618V9.0382C0 8.43229 0.490443 7.94185 1.09549 7.94185H1.96442C2.15973 7.18143 2.46268 6.45314 2.86459 5.77779L2.24915 5.16234C2.04169 4.95662 1.92624 4.67623 1.92624 4.38457C1.92624 4.0929 2.04169 3.81253 2.24915 3.60679L3.60939 2.24655H3.60852C3.81512 2.03995 4.09463 1.92364 4.3863 1.92364C4.67883 1.92364 4.95834 2.03996 5.16408 2.24655L5.77779 2.86459C6.45401 2.46268 7.18489 2.15973 7.94705 1.96442V1.09549C7.94705 0.492199 8.43398 0.00262511 9.03816 2.51134e-05ZM12.933 7.0669C13.7117 7.84467 14.1483 8.90023 14.1492 10C14.1492 11.1007 13.7117 12.1562 12.9339 12.934C12.1553 13.7126 11.1006 14.1493 9.99991 14.1493C8.89925 14.1493 7.84454 13.7127 7.06592 12.934C6.28814 12.1562 5.85063 11.1007 5.85063 10C5.8515 8.90018 6.28814 7.84463 7.06678 7.0669C7.84369 6.28739 8.89925 5.84988 9.99989 5.84988C11.1005 5.84988 12.1562 6.28739 12.933 7.0669ZM9.99993 5.02697C11.3185 5.02697 12.5842 5.55041 13.5164 6.48357C14.4495 7.41585 14.973 8.68147 14.973 10C14.973 11.3185 14.4495 12.5842 13.5164 13.5164C12.5841 14.4496 11.3185 14.973 9.99993 14.973C8.6814 14.973 7.41572 14.4496 6.4835 13.5164C5.55034 12.5842 5.0269 11.3185 5.0269 10C5.0269 8.68147 5.55034 7.41579 6.4835 6.48357C7.41578 5.55041 8.6814 5.02697 9.99993 5.02697Z'
			fill='currentColor'
		/>
	</svg>
);

export const TokenSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M4.23595 12.9638L4.87885 12.9424C5.06636 12.9353 5.21728 12.7835 5.22173 12.596L5.24674 11.9531L5.88964 11.9316C5.97983 11.9281 6.06465 11.8914 6.12895 11.828L9.67207 8.28493C10.4471 8.58049 11.2909 8.64655 12.1026 8.47512C12.9134 8.30278 13.659 7.90097 14.2474 7.317C14.9787 6.58659 15.4207 5.61598 15.4931 4.58468C15.5645 3.55336 15.2618 2.53095 14.6394 1.70493C14.0171 0.87986 13.117 0.307498 12.1062 0.0931967C11.0945 -0.121105 10.04 0.0369433 9.1364 0.538761C8.23276 1.04147 7.54074 1.85314 7.18805 2.82464C6.83623 3.79614 6.84695 4.8632 7.21841 5.82761L0.103594 12.9424C0.0366241 13.0094 -0.000878162 13.1014 1.56181e-05 13.196V15.1461C1.56181e-05 15.2408 0.0375179 15.3319 0.104487 15.3989C0.171457 15.4658 0.262536 15.5033 0.357192 15.5033H2.30376C2.39841 15.5024 2.48949 15.4658 2.55735 15.3997L3.10025 14.8569C3.16186 14.7917 3.19937 14.7068 3.20383 14.6175L3.22526 13.9746L3.86816 13.9532C4.05657 13.947 4.20837 13.7952 4.21461 13.6068L4.23595 12.9638ZM12.2258 2.38088C12.5865 2.38088 12.9125 2.59876 13.0509 2.93183C13.1893 3.26577 13.1125 3.64973 12.8571 3.90511C12.6017 4.16049 12.2178 4.23727 11.8838 4.09888C11.5508 3.96047 11.3329 3.63457 11.3329 3.27381C11.3347 2.78093 11.7329 2.38267 12.2258 2.38088Z'
			fill='currentColor'
		/>
		<path
			d='M17.0368 15.4106H4.89305C4.49926 15.4115 4.1796 15.7312 4.17871 16.125V19.2859C4.1796 19.6797 4.49926 19.9994 4.89305 20.0002H17.0368C17.4306 19.9993 17.7503 19.6797 17.7511 19.2859V16.125C17.7503 15.7312 17.4306 15.4115 17.0368 15.4106ZM7.46833 17.9894C7.53619 18.0563 7.57369 18.1474 7.57369 18.2429C7.57369 18.3385 7.53619 18.4296 7.46833 18.4965C7.40046 18.5635 7.30939 18.601 7.21384 18.6001C7.11919 18.6001 7.02811 18.5608 6.96113 18.493L6.67896 18.2108L6.39679 18.493C6.2575 18.6323 6.03247 18.6323 5.8923 18.4939C5.753 18.3555 5.75122 18.1295 5.88962 17.9894L6.17536 17.7072L5.88962 17.4215C5.82265 17.3545 5.78515 17.2643 5.78515 17.1696C5.78515 17.075 5.82265 16.9848 5.88962 16.9178C6.02981 16.7785 6.25662 16.7785 6.39681 16.9178L6.67898 17.2L6.96115 16.9178C7.10134 16.7785 7.32815 16.7785 7.46834 16.9178C7.53531 16.9848 7.57282 17.075 7.57282 17.1696C7.57282 17.2643 7.53531 17.3545 7.46834 17.4215L7.18261 17.7072L7.46833 17.9894ZM10.3257 17.9894C10.3935 18.0563 10.431 18.1474 10.431 18.2429C10.431 18.3385 10.3935 18.4296 10.3257 18.4965C10.2578 18.5635 10.1667 18.601 10.0712 18.6001C9.97654 18.6001 9.88546 18.5608 9.81849 18.493L9.53632 18.2108L9.25415 18.493C9.18718 18.5608 9.09699 18.5992 9.00144 18.5992C8.9068 18.6001 8.81482 18.5626 8.74785 18.4956C8.67999 18.4287 8.64248 18.3376 8.64248 18.2429C8.64248 18.1474 8.67999 18.0563 8.74696 17.9893L9.03269 17.7072L8.74696 17.4214C8.67999 17.3545 8.64248 17.2643 8.64248 17.1696C8.64248 17.075 8.67999 16.9848 8.74696 16.9178C8.88714 16.7785 9.11395 16.7785 9.25415 16.9178L9.53632 17.2L9.81849 16.9178C9.95867 16.7785 10.1855 16.7785 10.3257 16.9178C10.3926 16.9848 10.4301 17.075 10.4301 17.1696C10.4301 17.2643 10.3926 17.3545 10.3257 17.4214L10.0399 17.7072L10.3257 17.9894ZM13.183 17.9894C13.2509 18.0563 13.2884 18.1474 13.2884 18.2429C13.2884 18.3385 13.2509 18.4296 13.183 18.4965C13.1152 18.5635 13.0241 18.601 12.9285 18.6001C12.8339 18.6001 12.7428 18.5608 12.6758 18.493L12.3937 18.2108L12.1115 18.493C12.0445 18.5608 11.9543 18.5992 11.8588 18.5992C11.7641 18.6001 11.6722 18.5626 11.6052 18.4956C11.5373 18.4287 11.4998 18.3376 11.4998 18.2429C11.4998 18.1474 11.5373 18.0563 11.6043 17.9893L11.89 17.7072L11.6043 17.4214C11.5373 17.3545 11.4998 17.2643 11.4998 17.1696C11.4998 17.075 11.5373 16.9848 11.6043 16.9178C11.7445 16.7785 11.9713 16.7785 12.1115 16.9178L12.3937 17.2L12.6758 16.9178C12.816 16.7785 13.0428 16.7785 13.183 16.9178C13.25 16.9848 13.2875 17.075 13.2875 17.1696C13.2875 17.2643 13.25 17.3545 13.183 17.4214L12.8973 17.7072L13.183 17.9894ZM16.0404 17.9894C16.1083 18.0563 16.1458 18.1474 16.1458 18.2429C16.1458 18.3385 16.1083 18.4296 16.0404 18.4965C15.9725 18.5635 15.8814 18.601 15.7859 18.6001C15.6913 18.6001 15.6002 18.5608 15.5332 18.493L15.251 18.2108L14.9689 18.493C14.9019 18.5608 14.8117 18.5992 14.7162 18.5992C14.6215 18.6001 14.5295 18.5626 14.4626 18.4956C14.3947 18.4287 14.3572 18.3376 14.3572 18.2429C14.3572 18.1474 14.3947 18.0563 14.4617 17.9893L14.7474 17.7072L14.4617 17.4214C14.3947 17.3545 14.3572 17.2643 14.3572 17.1696C14.3572 17.075 14.3947 16.9848 14.4617 16.9178C14.6019 16.7785 14.8287 16.7785 14.9689 16.9178L15.251 17.2L15.5332 16.9178C15.6734 16.7785 15.9002 16.7785 16.0404 16.9178C16.1074 16.9848 16.1449 17.075 16.1449 17.1696C16.1449 17.2643 16.1074 17.3545 16.0404 17.4214L15.7546 17.7072L16.0404 17.9894Z'
			fill='currentColor'
		/>
	</svg>
);

export const ElectionSVG = ({ color }: { color?: string }) => (
	<svg
		width='17'
		height='20'
		viewBox='0 0 17 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M15.7742 20H0.397668C0.178124 20 0 19.8219 0 19.6023V7.40717C0 7.18763 0.178124 7.0095 0.397668 7.0095H15.7742C15.9937 7.0095 16.1718 7.18763 16.1718 7.40717V19.6023C16.1718 19.8219 15.9937 20 15.7742 20ZM0.795337 19.2047H15.3765V7.80484H0.795337V19.2047Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M15.7742 10.456H0.397668C0.178124 10.456 0 10.2778 0 10.0583V7.40717C0 7.18763 0.178124 7.0095 0.397668 7.0095H15.7742C15.9937 7.0095 16.1718 7.18763 16.1718 7.40717V10.0583C16.1718 10.2778 15.9937 10.456 15.7742 10.456ZM0.795337 9.66063H15.3765V7.80484H0.795337V9.66063Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M9.2289 6.21417H5.81664C5.71205 6.21417 5.61056 6.17171 5.536 6.09714L4.2415 4.80265C4.08617 4.64731 4.08617 4.39565 4.2415 4.24032L8.36718 0.116505C8.52252 -0.038835 8.77418 -0.038835 8.92951 0.116505L11.9295 3.11545C12.0849 3.27079 12.0849 3.52245 11.9295 3.67778L9.51141 6.0959C9.43684 6.1715 9.33536 6.21396 9.22869 6.21396L9.2289 6.21417ZM5.98128 5.41883H9.06427L11.0847 3.39838L8.64796 0.961632L5.08644 4.52209L5.98128 5.41883Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const PoliticalPartySVG = ({ color }: { color?: string }) => (
	<svg
		width='13'
		height='20'
		viewBox='0 0 13 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M5.09553 15.4579C5.16626 15.5286 5.26984 15.5615 5.33804 15.5615C5.40372 15.5615 5.50477 15.5337 5.58309 15.4579L8.19519 12.8432C8.3316 12.7043 8.3316 12.4946 8.19519 12.3557C8.05625 12.2193 7.84657 12.2193 7.70763 12.3557L5.33804 14.7253L4.61555 14.0003C4.47661 13.8613 4.26693 13.8613 4.12799 14.0003C4.06231 14.0685 4.02441 14.1544 4.02441 14.2428C4.02441 14.3337 4.06231 14.4196 4.12799 14.4853L5.09553 15.4579Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M11.7923 8.09903H10.3044C10.1756 6.60351 9.20551 5.45661 7.68473 4.99179C8.38449 4.49918 8.79373 3.72363 8.79373 2.87988V2.56663C8.79373 1.15195 7.64178 0 6.22458 0H5.91133C4.49665 0 3.3447 1.15195 3.3447 2.56663V2.87988C3.3447 3.72363 3.75647 4.49918 4.45371 4.99179C2.93293 5.45661 1.96539 6.60351 1.83403 8.09903H0.34609C0.141467 8.09903 0 8.24302 0 8.44512V9.72591C0 9.90527 0.169256 10.072 0.34609 10.072H1.12416V19.6539C1.12416 19.8585 1.26563 20 1.47025 20H10.6682C10.8728 20 11.0143 19.856 11.0143 19.6539V10.0745H11.7898C11.9944 10.0745 12.1359 9.93053 12.1359 9.72843V8.44764C12.141 8.24302 11.997 8.09903 11.7923 8.09903ZM10.3221 10.0745V19.3103H1.81887V10.0745H10.3221ZM6.07048 5.42377C7.71757 5.42377 9.43287 6.24479 9.6097 8.07377H2.53126C2.7081 6.24226 4.42592 5.42377 6.07048 5.42377ZM4.03941 2.85462V2.54137C4.03941 1.52583 4.89832 0.666919 5.91386 0.666919H6.22711C7.24264 0.666919 8.10155 1.52583 8.10155 2.54137V2.85462C8.10155 3.87015 7.24264 4.72906 6.22711 4.72906H5.91386C4.89832 4.72906 4.03941 3.87268 4.03941 2.85462ZM11.421 8.79373V9.37981H0.694708V8.79373H11.421Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const FilterSVG: FC<ISVGComponent> = ({ fill, width, height, ...rest }) => {
	const filler = fill || 'currentColor';
	return (
		<svg
			width={width || '16'}
			height={height || '12'}
			viewBox='0 0 16 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M9 10C9.55229 10 10 10.4477 10 11C10 11.5523 9.55229 12 9 12H7C6.44771 12 6 11.5523 6 11C6 10.4477 6.44771 10 7 10H9ZM12 5C12.5523 5 13 5.44771 13 6C13 6.55229 12.5523 7 12 7H4C3.44771 7 3 6.55229 3 6C3 5.44771 3.44771 5 4 5H12ZM15 0C15.5523 0 16 0.447715 16 1C16 1.55229 15.5523 2 15 2H1C0.447715 2 0 1.55229 0 1C0 0.447715 0.447715 0 1 0H15Z'
				fill={filler}
			/>
		</svg>
	);
};

export const SortSVG: FC<ISVGComponent> = ({ fill, width, height, ...rest }) => {
	const filler = fill || 'currentColor';
	return (
		<svg
			width={width || '44'}
			height={height || '23'}
			viewBox='0 0 44 83'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M21.649 0L0.000976562 37.5H43.302L21.649 0Z'
				fill={filler}
			/>
			<path
				d='M21.649 83L43.301 45.5H0L21.649 83Z'
				fill={filler}
			/>
		</svg>
	);
};

export const GroupSVG: FC<ISVGComponent> = ({ fill, width, height, ...rest }) => {
	const filler = fill || 'currentColor';
	return (
		<svg
			width={width || '12'}
			height={height || '12'}
			viewBox='0 0 12 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<path
				d='M11.8132 5.55636L11.8082 5.55132C11.5601 5.30321 11.1597 5.30321 10.9146 5.55132C10.6665 5.79943 10.6665 6.19982 10.9146 6.4449L10.9196 6.44995C11.1678 6.69806 11.5682 6.69806 11.8132 6.44995C12.0583 6.20184 12.0613 5.80144 11.8132 5.55636Z'
				fill={filler}
			/>
			<path
				d='M0.189992 6.44799C0.438102 6.6961 0.8385 6.6961 1.08358 6.44799C1.33169 6.19988 1.33169 5.79948 1.08358 5.55441L1.07854 5.54936C0.830426 5.30125 0.430028 5.30125 0.184949 5.54936C-0.0601344 5.79747 -0.0631605 6.19787 0.184949 6.44295L0.189992 6.44799Z'
				fill={filler}
			/>
			<path
				d='M6.44295 1.08358L6.44799 1.07854C6.6961 0.830426 6.6961 0.430028 6.44799 0.184949C6.19988 -0.0601344 5.79948 -0.0631605 5.55441 0.184949L5.54936 0.189992C5.30125 0.438102 5.30125 0.8385 5.54936 1.08358C5.79747 1.32866 6.19787 1.33169 6.44295 1.08358Z'
				fill={filler}
			/>
			<path
				d='M6.44295 11.8132L6.44799 11.8082C6.6961 11.5601 6.6961 11.1597 6.44799 10.9146C6.19988 10.6665 5.79948 10.6665 5.55441 10.9146L5.54936 10.9196C5.30125 11.1678 5.30125 11.5682 5.54936 11.8132C5.79747 12.0613 6.19787 12.0613 6.44295 11.8132Z'
				fill={filler}
			/>
			<path
				d='M8.05718 5.26188C7.65979 5.65926 7.65979 6.30475 8.06222 6.70818C8.26091 6.90687 8.52212 7.00469 8.78235 7.00469C9.04357 7.00469 9.30378 6.90686 9.50248 6.70818C9.69613 6.51453 9.80204 6.25936 9.80204 5.98805C9.80204 5.71674 9.69614 5.45854 9.49745 5.26288C9.10006 4.8655 8.45457 4.8655 8.05721 5.26288L8.05718 5.26188Z'
				fill={filler}
			/>
			<path
				d='M6.91765 5.07562C6.67256 4.83053 6.34477 4.69336 5.99581 4.69336C5.64684 4.69336 5.32208 4.8275 5.07398 5.07562C4.56565 5.58395 4.56565 6.41097 5.07902 6.9213C5.32411 7.16638 5.65191 7.30355 6.00086 7.30355C6.34983 7.30355 6.67459 7.16941 6.92269 6.9213C7.43102 6.41296 7.43102 5.58594 6.91765 5.07562ZM5.97565 6.02872C5.96052 6.01359 5.96052 5.99039 5.97565 5.97425L6.02507 6.02367C6.02507 6.02367 5.98372 6.03679 5.97565 6.02872ZM6.02507 6.02367L5.97565 5.97425C5.97565 5.97425 5.99582 5.96417 6.00691 5.96417C6.01498 5.96417 6.02204 5.96417 6.02507 5.96921C6.0402 5.98434 6.0402 6.00754 6.02507 6.02367Z'
				fill={filler}
			/>
			<path
				d='M6.70445 8.05781C6.30706 7.66042 5.66157 7.66042 5.26421 8.05781C4.86682 8.45519 4.86682 9.10068 5.26925 9.50411C5.4629 9.69776 5.71807 9.80367 5.98938 9.80367C6.26069 9.80367 6.51889 9.69777 6.70951 9.50411C7.1069 9.10672 7.10688 8.46124 6.70445 8.05781Z'
				fill={filler}
			/>
			<path
				d='M5.29462 3.94154C5.49331 4.14023 5.75451 4.23805 6.01475 4.23805C6.27597 4.23805 6.53617 4.14022 6.73488 3.94154C7.13227 3.54415 7.13227 2.89866 6.72984 2.49523C6.34557 2.11096 5.67387 2.11096 5.2896 2.49523C4.89221 2.89262 4.89219 3.53811 5.29462 3.94154Z'
				fill={filler}
			/>
			<path
				d='M2.49989 6.73849C2.69858 6.93717 2.95978 7.035 3.22002 7.035C3.48123 7.035 3.74144 6.93716 3.94015 6.73849C4.33754 6.3411 4.33754 5.69561 3.93511 5.29218C3.53772 4.89479 2.89223 4.89479 2.49487 5.29218C2.30122 5.48583 2.19531 5.741 2.19531 6.01231C2.19531 6.28362 2.30121 6.54182 2.4999 6.73748L2.49989 6.73849Z'
				fill={filler}
			/>
			<path
				d='M8.90024 2.21484H8.89016C8.42319 2.21484 8.04297 2.59408 8.04297 3.06203C8.04297 3.529 8.4222 3.90922 8.89016 3.90922H8.90024C9.36721 3.90922 9.74743 3.52998 9.74743 3.06203C9.74743 2.59506 9.36819 2.21484 8.90024 2.21484Z'
				fill={filler}
			/>
			<path
				d='M8.90024 9.78422C9.36721 9.78422 9.74743 9.40498 9.74743 8.93703C9.74743 8.47006 9.36819 8.08984 8.90024 8.08984H8.89016C8.42319 8.08984 8.04297 8.46908 8.04297 8.93703C8.04297 9.404 8.4222 9.78422 8.89016 9.78422H8.90024Z'
				fill={filler}
			/>
			<path
				d='M3.09719 3.90727H3.10727C3.57425 3.90727 3.95446 3.52803 3.95446 3.06008C3.95446 2.59311 3.57523 2.21289 3.10727 2.21289H3.09719C2.63022 2.21289 2.25 2.59213 2.25 3.06008C2.25 3.52705 2.62924 3.90727 3.09719 3.90727Z'
				fill={filler}
			/>
			<path
				d='M3.10727 8.0918H3.09719C2.63022 8.0918 2.25 8.47103 2.25 8.93899C2.25 9.40596 2.62924 9.78617 3.09719 9.78617H3.10727C3.57424 9.78617 3.95446 9.40694 3.95446 8.93899C3.95446 8.47201 3.57523 8.0918 3.10727 8.0918Z'
				fill={filler}
			/>
		</svg>
	);
};

export const SortBySVG = ({ fill, width, height }: { fill?: string; width?: string; height?: string }) => {
	const filler = fill || 'currentColor';
	return (
		<svg
			width={width || '44'}
			height={height || '23'}
			viewBox='0 0 86 70'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M0.92985 18.9979C1.52307 19.5758 2.29232 19.8628 3.06163 19.8628C3.86153 19.8628 4.65758 19.5528 5.25848 18.9328L13.311 10.6315V66.9379C13.311 68.6296 14.6811 69.9997 16.3728 69.9997C18.0645 69.9997 19.4346 68.6296 19.4346 66.9379V3.06179C19.4346 3.05797 19.4307 3.05414 19.4307 3.04649C19.4269 2.79389 19.3466 2.54895 19.2815 2.30018C19.0327 1.35485 18.3859 0.577935 17.4866 0.225806C17.4636 0.218152 17.4406 0.221979 17.4177 0.214325C17.0885 0.0918535 16.7441 0 16.3728 0C15.5079 0 14.7309 0.367414 14.176 0.945322L0.864834 14.6699C-0.313928 15.8832 -0.283406 17.819 0.92985 18.9979Z'
				fill={filler}
			/>
			<path
				d='M74.9331 24.3489C74.9331 22.6572 73.563 21.2871 71.8713 21.2871H34.3069C32.6152 21.2871 31.2451 22.6572 31.2451 24.3489C31.2451 26.0406 32.6152 27.4107 34.3069 27.4107H71.8674C73.559 27.4107 74.9331 26.0406 74.9331 24.3489Z'
				fill={filler}
			/>
			<path
				d='M64.1331 45.636C64.1331 43.9443 62.763 42.5742 61.0713 42.5742H34.3079C32.6162 42.5742 31.2461 43.9443 31.2461 45.636C31.2461 47.3277 32.6162 48.6978 34.3079 48.6978H61.0713C62.763 48.6978 64.1331 47.3277 64.1331 45.636Z'
				fill={filler}
			/>
			<path
				d='M34.3079 63.877C32.6162 63.877 31.2461 65.2471 31.2461 66.9387C31.2461 68.6304 32.6162 70.0005 34.3079 70.0005H50.2713C51.9629 70.0005 53.3331 68.6304 53.3331 66.9387C53.3331 65.2471 51.9629 63.877 50.2713 63.877H34.3079Z'
				fill={filler}
			/>
			<path
				d='M82.6684 0H34.3079C32.6162 0 31.2461 1.37011 31.2461 3.06178C31.2461 4.75345 32.6162 6.12356 34.3079 6.12356H82.6684C84.36 6.12356 85.7301 4.75345 85.7301 3.06178C85.7301 1.37011 84.36 0 82.6684 0Z'
				fill={filler}
			/>
		</svg>
	);
};

export const SortDescendSVG = ({ fill, width, height }: { fill?: string; width?: string; height?: string }) => {
	const filler = fill || 'currentColor';
	return (
		<svg
			width={width || '10'}
			height={height || '12'}
			viewBox='0 0 10 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M8.93657 5.904L5.508 9.59143V0H4.308V9.59314L0.879428 5.904L0 6.72171L4.90629 12L9.81429 6.72171L8.93657 5.904Z'
				fill={filler}
			/>
		</svg>
	);
};
export const SortAscendSVG = ({ fill, width, height }: { fill?: string; width?: string; height?: string }) => {
	const filler = fill || 'currentColor';
	return (
		<svg
			width={width || '10'}
			height={height || '12'}
			viewBox='0 0 10 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M9.81429 5.27829L4.908 0L0 5.27829L0.877714 6.096L4.30629 2.40857V12H5.50629V2.40686L8.93486 6.096L9.81429 5.27829Z'
				fill={filler}
			/>
		</svg>
	);
};

export const ConstituencySVG = ({ fill: _fill }: { fill?: string }) => (
	<svg
		width='22'
		height='20'
		viewBox='0 0 22 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M21.668 19.257C18.8094 16.3984 15.0873 14.9196 11.333 14.8134V6.09249H17.8607C18.0212 6.09249 18.1688 6.00414 18.2445 5.86271C18.3202 5.72128 18.3115 5.54938 18.2227 5.41622L16.643 3.04624L18.2227 0.676701C18.3115 0.543102 18.3202 0.371642 18.2445 0.230209C18.1688 0.0887764 18.0212 0 17.8607 0H10.8978C10.6576 0 10.4626 0.19496 10.4626 0.435178V14.8134C6.70881 14.9196 2.9863 16.3984 0.127616 19.257C-0.0425386 19.4272 -0.0425386 19.7022 0.127616 19.8724C0.212475 19.9572 0.323881 19.9999 0.435286 19.9999C0.546692 19.9999 0.658097 19.9572 0.742957 19.8724C6.34195 14.2738 15.4524 14.2734 21.0523 19.8724C21.2224 20.0425 21.4974 20.0425 21.6676 19.8724C21.8378 19.7022 21.8382 19.4272 21.668 19.257ZM15.7579 2.80472C15.6604 2.95094 15.6604 3.14111 15.7579 3.28733L17.0478 5.22213H11.333V0.870355H17.0478L15.7579 2.80472Z'
			fill='currentColor'
		/>
	</svg>
);

export const ResultSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='15'
		height='20'
		viewBox='0 0 15 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12.1322 1.27911H12.7984C13.2939 1.27911 13.7692 1.47602 14.1197 1.82656C14.4703 2.17711 14.6672 2.65235 14.6672 3.14787V18.1312C14.6672 18.6268 14.4703 19.1023 14.1197 19.4525C13.7692 19.8031 13.2939 20 12.7984 20H1.86876C1.37324 20 0.898001 19.8031 0.547456 19.4525C0.196911 19.1023 0 18.6268 0 18.1312V3.14787C0 2.65235 0.196911 2.17711 0.547456 1.82656C0.898001 1.47602 1.37324 1.27911 1.86876 1.27911H2.53496V1.16875C2.53496 0.523108 3.05834 0 3.70371 0H10.9635C11.6088 0 12.1322 0.523108 12.1322 1.16875V1.27911ZM2.53496 1.82008H1.86876C1.51659 1.82008 1.17903 1.96018 0.929919 2.20903C0.681075 2.45814 0.540965 2.79571 0.540965 3.14787V18.1312C0.540965 18.4834 0.681075 18.821 0.929919 19.0701C1.17903 19.3192 1.51659 19.459 1.86876 19.459H12.7984C13.1506 19.459 13.4881 19.3192 13.7373 19.0701C13.9861 18.821 14.1262 18.4834 14.1262 18.1312V3.14787C14.1262 2.79571 13.9861 2.45814 13.7373 2.20903C13.4881 1.96018 13.1506 1.82008 12.7984 1.82008H12.1322V2.1625C12.1322 2.80788 11.6088 3.33125 10.9635 3.33125H3.70371C3.05834 3.33125 2.53496 2.80788 2.53496 2.1625V1.82008ZM11.5912 2.1625V1.16875C11.5912 0.821991 11.3102 0.540965 10.9635 0.540965H3.70371C3.35696 0.540965 3.07592 0.821991 3.07592 1.16875V2.1625C3.07592 2.50926 3.35696 2.79029 3.70371 2.79029H10.9635C11.3102 2.79029 11.5912 2.50926 11.5912 2.1625ZM3.29042 17.597C3.14111 17.597 3.01993 17.4759 3.01993 17.3266C3.01993 17.1773 3.14111 17.0561 3.29042 17.0561H4.27092C4.42022 17.0561 4.5414 17.1773 4.5414 17.3266C4.5414 17.4759 4.42022 17.597 4.27092 17.597H3.29042ZM5.36042 15.9557C5.21111 15.9557 5.08994 15.8346 5.08994 15.6853C5.08994 15.536 5.21111 15.4148 5.36042 15.4148H11.3768C11.5261 15.4148 11.6472 15.536 11.6472 15.6853C11.6472 15.8346 11.5261 15.9557 11.3768 15.9557H5.36042ZM3.29042 14.3145C3.14111 14.3145 3.01993 14.1933 3.01993 14.044C3.01993 13.8947 3.14111 13.7735 3.29042 13.7735H4.27092C4.42022 13.7735 4.5414 13.8947 4.5414 14.044C4.5414 14.1933 4.42022 14.3145 4.27092 14.3145H3.29042ZM5.36042 14.3145C5.21111 14.3145 5.08994 14.1933 5.08994 14.044C5.08994 13.8947 5.21111 13.7735 5.36042 13.7735H11.3768C11.5261 13.7735 11.6472 13.8947 11.6472 14.044C11.6472 14.1933 11.5261 14.3145 11.3768 14.3145H5.36042ZM3.29042 15.9557C3.14111 15.9557 3.01993 15.8346 3.01993 15.6853C3.01993 15.536 3.14111 15.4148 3.29042 15.4148H4.27092C4.42022 15.4148 4.5414 15.536 4.5414 15.6853C4.5414 15.8346 4.42022 15.9557 4.27092 15.9557H3.29042ZM7.33359 4.99364C9.22777 4.99364 10.7655 6.53134 10.7655 8.42552C10.7655 10.3197 9.22777 11.8574 7.33359 11.8574C5.4394 11.8574 3.90171 10.3197 3.90171 8.42552C3.90171 6.53134 5.4394 4.99364 7.33359 4.99364ZM7.33359 5.5346C5.73801 5.5346 4.44267 6.82995 4.44267 8.42552C4.44267 10.0211 5.73801 11.3164 7.33359 11.3164C8.92916 11.3164 10.2245 10.0211 10.2245 8.42552C10.2245 6.82995 8.92916 5.5346 7.33359 5.5346ZM5.20949 8.32517C5.104 8.21941 5.104 8.04819 5.20949 7.9427C5.31498 7.83694 5.48646 7.83694 5.59195 7.9427L6.88378 9.23426L9.07522 7.04282C9.18071 6.93733 9.3522 6.93733 9.45769 7.04282C9.56317 7.14858 9.56317 7.31979 9.45769 7.42554L7.07501 9.80796C6.96952 9.91372 6.79803 9.91372 6.69254 9.80796L5.20949 8.32517ZM5.36042 17.597C5.21111 17.597 5.08994 17.4759 5.08994 17.3266C5.08994 17.1773 5.21111 17.0561 5.36042 17.0561H9.58779C9.73682 17.0561 9.85827 17.1773 9.85827 17.3266C9.85827 17.4759 9.73682 17.597 9.58779 17.597H5.36042Z'
			fill={fill || 'currentColor'}
		/>
	</svg>
);

export const ElectiveCategorySVG = ({ fill }: { fill?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M11.6184 9.59754C11.4834 9.59754 11.3742 9.48837 11.3742 9.35338C11.3742 9.21839 11.4834 9.10922 11.6184 9.10922H15.5984C15.7334 9.10922 15.8425 9.21839 15.8425 9.35338C15.8425 9.48837 15.7334 9.59754 15.5984 9.59754H11.6184ZM11.5809 2.975C11.4459 2.975 11.3367 2.86583 11.3367 2.73083C11.3367 2.59583 11.4459 2.48667 11.5809 2.48667H13.5709C13.7059 2.48667 13.8151 2.59584 13.8151 2.73083C13.8151 2.86583 13.7059 2.975 13.5709 2.975H11.5809ZM11.6184 1.68082C11.4834 1.68082 11.3742 1.57166 11.3742 1.43666C11.3742 1.30167 11.4834 1.1925 11.6184 1.1925H15.5984C15.7334 1.1925 15.8425 1.30167 15.8425 1.43666C15.8425 1.57166 15.7334 1.68082 15.5984 1.68082H11.6184ZM11.5809 18.6667C11.4459 18.6667 11.3367 18.5576 11.3367 18.4226C11.3367 18.2876 11.4459 18.1784 11.5809 18.1784H15.5617C15.6967 18.1784 15.8059 18.2876 15.8059 18.4226C15.8059 18.5576 15.6967 18.6667 15.5617 18.6667H11.5809ZM11.6184 17.3734C11.4834 17.3734 11.3742 17.2642 11.3742 17.1292C11.3742 16.9942 11.4834 16.8851 11.6184 16.8851H13.6084C13.7434 16.8851 13.8526 16.9942 13.8526 17.1292C13.8526 17.2642 13.7434 17.3734 13.6084 17.3734H11.6184ZM3.06666 7.01835C2.21998 7.01835 1.45332 7.36169 0.898331 7.91668C0.343319 8.47169 0 9.23835 0 10.085C0 10.9317 0.343341 11.6984 0.898331 12.2533C1.45334 12.8084 2.22 13.1517 3.06666 13.1517C3.91332 13.1517 4.68001 12.8083 5.235 12.2533C5.73667 11.7525 6.065 11.0783 6.12334 10.3283H7.85253V17.4192C7.85253 17.5983 7.92586 17.7608 8.04336 17.8783C8.16086 17.9958 8.32419 18.0692 8.50252 18.0692H10.06V19.1983C10.06 19.4192 10.15 19.6192 10.295 19.7642C10.4409 19.91 10.6409 20 10.8609 20H16.3184C16.5392 20 16.7392 19.91 16.8842 19.765C17.0292 19.62 17.1192 19.42 17.1192 19.1992V16.4525C17.1192 16.2316 17.0292 16.0316 16.8842 15.8867C16.7392 15.7417 16.5392 15.6516 16.3184 15.6516H10.8609C10.64 15.6516 10.44 15.7416 10.295 15.8867C10.15 16.0317 10.06 16.2317 10.06 16.4525V17.5817H8.50252C8.45752 17.5817 8.41752 17.5633 8.38752 17.5342C8.35835 17.505 8.34002 17.4642 8.34002 17.4192L8.34085 10.3292H10.0609V11.3734C10.0609 11.5942 10.1509 11.7942 10.2959 11.9392C10.4409 12.0842 10.6409 12.1742 10.8617 12.1742H16.3192C16.5401 12.1742 16.7401 12.0842 16.8851 11.9392C17.0301 11.7942 17.1201 11.5942 17.1201 11.3734L17.1192 8.62668C17.1192 8.40584 17.0292 8.20583 16.8842 8.06085C16.7392 7.91585 16.5392 7.82584 16.3184 7.82584H10.8609C10.64 7.82584 10.44 7.91584 10.295 8.06085C10.15 8.20585 10.06 8.40586 10.06 8.62668V9.84168H8.34002L8.34085 2.58084C8.34085 2.53584 8.35919 2.49584 8.38835 2.46584C8.41752 2.43667 8.45835 2.41834 8.50335 2.41834H10.0609V3.54752C10.0609 3.76836 10.1509 3.96837 10.2959 4.11335C10.4409 4.25833 10.6409 4.34836 10.8617 4.34836H16.3192C16.5401 4.34836 16.7401 4.25836 16.8851 4.11335C17.0301 3.96835 17.1201 3.76834 17.1201 3.54752L17.1192 0.800837C17.1192 0.579993 17.0292 0.379992 16.8842 0.235009C16.7392 0.090008 16.5384 0 16.3184 0H10.8609C10.64 0 10.44 0.0900016 10.295 0.235009C10.15 0.380011 10.06 0.580014 10.06 0.800837V1.93002H8.50252C8.32335 1.93002 8.16084 2.00252 8.04336 2.12085C7.92586 2.23835 7.85253 2.40168 7.85253 2.58001V9.84085H6.12334C6.06418 9.09169 5.73584 8.41751 5.235 7.91585C4.67998 7.36167 3.91332 7.01835 3.06666 7.01835ZM4.89001 8.26168C5.35668 8.72835 5.64503 9.37335 5.64503 10.0859C5.64503 10.7984 5.35668 11.4434 4.89001 11.91C4.42334 12.3767 3.77835 12.6651 3.06583 12.6651C2.35332 12.6651 1.70832 12.3767 1.24165 11.91C0.774981 11.4434 0.486638 10.7984 0.486638 10.0859C0.486638 9.37335 0.774981 8.72835 1.24165 8.26168C1.70832 7.79501 2.35332 7.50667 3.06583 7.50667C3.77833 7.50584 4.42334 7.79501 4.89001 8.26168ZM16.3183 16.1401H10.8608C10.775 16.1401 10.6967 16.1751 10.64 16.2318C10.5833 16.2885 10.5475 16.3668 10.5475 16.4526V19.1993C10.5475 19.2852 10.5825 19.3635 10.64 19.4202C10.6966 19.4768 10.775 19.5118 10.8608 19.5118H16.3183C16.4042 19.5118 16.4825 19.4768 16.5392 19.4202C16.5959 19.3635 16.6309 19.2852 16.6309 19.1993V16.4526C16.6309 16.3668 16.5959 16.2885 16.5392 16.2318C16.4825 16.1751 16.4042 16.1401 16.3183 16.1401ZM16.3183 8.31416H10.8608C10.775 8.31416 10.6967 8.34916 10.64 8.40583C10.5833 8.4625 10.5475 8.54083 10.5475 8.62668V11.3734C10.5475 11.4592 10.5825 11.5375 10.64 11.5942C10.6966 11.6509 10.775 11.6859 10.8608 11.6859H16.3183C16.4042 11.6859 16.4825 11.6509 16.5392 11.5942C16.5959 11.5375 16.6309 11.4592 16.6309 11.3734V8.62668C16.6309 8.54084 16.5959 8.46251 16.5392 8.40583C16.4825 8.34915 16.4042 8.31416 16.3183 8.31416ZM16.3183 0.487344H10.8608C10.775 0.487344 10.6967 0.522343 10.64 0.579011C10.5833 0.63568 10.5475 0.714012 10.5475 0.799855V3.54654C10.5475 3.63237 10.5825 3.71071 10.64 3.76738C10.6966 3.82405 10.775 3.85905 10.8608 3.85905H16.3183C16.4042 3.85905 16.4825 3.82405 16.5392 3.76738C16.5959 3.71071 16.6309 3.63238 16.6309 3.54654V0.800709C16.6309 0.714876 16.5959 0.636541 16.5392 0.579865C16.4825 0.523188 16.4042 0.487344 16.3183 0.487344ZM11.5808 10.8908C11.4458 10.8908 11.3367 10.7817 11.3367 10.6467C11.3367 10.5117 11.4458 10.4025 11.5808 10.4025H15.5617C15.6967 10.4025 15.8058 10.5117 15.8058 10.6467C15.8058 10.7817 15.6966 10.8908 15.5617 10.8908H11.5808Z'
			fill={fill || 'currentColor'}
		/>
	</svg>
);

export const BulbSVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'currentColor';
	return (
		<svg
			width='12'
			height='17'
			viewBox='0 0 15 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.81868 14.8463C3.13986 12.8281 0 11.7647 0 7.24736C0 3.24468 3.24557 0 7.24825 0C11.2509 0 14.4965 3.2449 14.4965 7.24825C14.4965 10.1963 13.1666 11.6632 12.0312 12.9158C11.3324 13.6867 10.7117 14.3716 10.5763 15.2656C10.5884 15.3281 11.0216 16.0139 10.4035 16.6319L10.2256 16.776C10.7126 17.2066 10.7369 17.954 10.2768 18.4141L10.2759 18.4132C9.92089 18.7682 9.58409 18.7439 9.15267 18.7439C9.11968 19.4427 8.53895 20 7.83669 20H6.56673C5.86534 20 5.28374 19.4427 5.24988 18.7448C4.79414 18.7448 4.50247 18.7708 4.12574 18.4132C3.68302 17.9931 3.68129 17.2439 4.14831 16.8021C3.53113 16.408 3.70559 15.4488 3.81844 14.8463L3.81868 14.8463ZM8.68426 18.7447H5.7198C5.75192 19.1849 6.12258 19.5312 6.56616 19.5312H7.83612C8.28057 19.5312 8.65128 19.1849 8.68426 18.7447ZM9.48288 16.9626H4.92131C4.05237 16.9626 4.06539 18.276 4.92131 18.276H9.48199C9.67991 18.276 9.81446 18.2014 9.9464 18.0833L9.94553 18.0824C10.3631 17.6658 10.0584 16.9626 9.48288 16.9626ZM10.1478 15.4626C10.015 15.2899 9.84573 15.1805 9.60875 15.1805H5.31095C5.0028 15.1805 5.0028 14.7117 5.31095 14.7117H9.60875C9.81795 14.7117 10.0133 14.7699 10.1817 14.8697C10.7988 12.5737 14.0272 11.6857 14.0272 7.24726C14.0281 3.50325 10.9926 0.468566 7.24854 0.468566C3.50453 0.468566 0.468957 3.50325 0.468957 7.24815C0.468957 11.1544 2.92986 12.2559 3.98208 14.0833C4.11837 13.5182 4.28331 12.9678 4.46906 12.4418C2.93259 9.578 3.3753 6.56932 6.50378 4.84021C7.49945 4.28985 8.79201 3.84802 10.4387 3.56589C10.5706 3.54332 10.6948 3.63447 10.7113 3.77509C11.1219 6.72466 10.7564 8.85578 9.72775 10.2978C8.71212 11.7214 7.06618 12.461 4.8944 12.6434C4.67304 13.2762 4.00984 15.4376 4.21644 16.1303C4.31279 16.4523 4.56366 16.4931 4.92218 16.4931H9.60975C10.1358 16.494 10.4508 15.8966 10.1478 15.4626ZM4.69202 11.8437C5.33264 10.2196 6.31007 8.52081 7.20581 7.72303C7.43585 7.51817 7.74748 7.868 7.51656 8.07286C6.63809 8.85584 5.67716 10.5798 5.07122 12.1562C6.99572 11.9566 8.44968 11.2803 9.34457 10.026C10.2769 8.7187 10.6198 6.77243 10.2769 4.06931C6.84552 4.70473 3.5155 6.4382 4.15884 10.184C4.2578 10.7508 4.44375 11.3107 4.69202 11.8437Z'
				fill={fila}
			/>
		</svg>
	);
};

export const SearchLGSVG = ({ fill: _fill }: { fill?: string }) => (
	<svg
		width='15'
		height='15'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M20 19.3578L13.578 12.9358C14.7706 11.5596 15.5963 9.72477 15.5963 7.79817C15.5963 3.48624 12.1101 0 7.79817 0C3.48624 0 0 3.48624 0 7.79817C0 12.1101 3.48624 15.5963 7.79817 15.5963C9.81651 15.5963 11.5596 14.8624 12.9358 13.578L19.3578 20L20 19.3578ZM7.70642 14.6789C3.94495 14.6789 0.825688 11.5596 0.825688 7.79817C0.825688 4.0367 3.94495 0.917431 7.70642 0.917431C11.4679 0.917431 14.5872 4.0367 14.5872 7.79817C14.5872 11.5596 11.4679 14.6789 7.70642 14.6789Z'
			fill='currentColor'
		/>
	</svg>
);

export const OrganizationSVG = ({ fill: _fill }: { fill?: string }) => (
	<svg
		width='25'
		height='13'
		viewBox='0 0 25 13'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M12.4997 4.78256C13.818 4.78256 14.891 3.70959 14.891 2.39128C14.891 1.07296 13.818 0 12.4997 0C11.1814 0 10.1084 1.07296 10.1084 2.39128C10.1084 3.70959 11.1814 4.78256 12.4997 4.78256ZM12.4997 0.609602C13.4822 0.609602 14.2812 1.40868 14.2812 2.39116C14.2812 3.37364 13.4822 4.17271 12.4997 4.17271C11.5172 4.17271 10.7181 3.37364 10.7181 2.39116C10.7181 1.40868 11.5172 0.609602 12.4997 0.609602Z'
			fill='currentColor'
		/>
		<path
			d='M7.46966 12.2366C7.634 12.2687 7.79358 12.158 7.82574 11.9936L8.35449 9.16414C8.58909 7.6184 9.8931 6.49541 11.4568 6.49541H13.542C15.1056 6.49541 16.4096 7.61721 16.6455 9.17369L17.173 11.9925C17.2004 12.139 17.329 12.2414 17.4731 12.2414C17.4922 12.2414 17.5112 12.2402 17.5291 12.2366C17.6946 12.2056 17.8042 12.0461 17.7732 11.8805L17.2469 9.07247C16.967 7.22662 15.4094 5.88574 13.5422 5.88574H11.457C9.58969 5.88574 8.03215 7.22546 7.7535 9.0618L7.22594 11.8806C7.19498 12.0461 7.30454 12.2057 7.47007 12.2367L7.46966 12.2366Z'
			fill='currentColor'
		/>
		<path
			d='M20.2289 5.54465C21.4293 5.54465 22.407 4.56815 22.407 3.36656C22.407 2.16617 21.4305 1.18848 20.2289 1.18848C19.0285 1.18848 18.0508 2.16498 18.0508 3.36656C18.0508 4.56696 19.0273 5.54465 20.2289 5.54465ZM20.2289 1.7982C21.0934 1.7982 21.7972 2.50201 21.7972 3.36656C21.7972 4.23112 21.0934 4.93493 20.2289 4.93493C19.3643 4.93493 18.6605 4.23112 18.6605 3.36656C18.6605 2.50201 19.3643 1.7982 20.2289 1.7982Z'
			fill='currentColor'
		/>
		<path
			d='M17.9941 7.40392C18.3918 7.19433 18.8419 7.08239 19.2933 7.08239H21.1653C22.5539 7.08239 23.7126 8.07913 23.921 9.46174L24.395 11.9923C24.4224 12.1388 24.551 12.2412 24.6951 12.2412C24.7141 12.2412 24.7332 12.24 24.751 12.2365C24.9166 12.2055 25.0261 12.0459 24.9952 11.8804L24.5236 9.36052C24.2711 7.68735 22.8588 6.47266 21.1664 6.47266H19.2944C18.7442 6.47266 18.1964 6.60841 17.7106 6.86446C17.5617 6.94306 17.5045 7.12765 17.5831 7.27652C17.6617 7.42537 17.8463 7.48254 17.9952 7.40394L17.9941 7.40392Z'
			fill='currentColor'
		/>
		<path
			d='M4.77086 5.54465C5.97126 5.54465 6.94895 4.56815 6.94895 3.36656C6.94895 2.16617 5.97245 1.18848 4.77086 1.18848C3.57047 1.18848 2.59277 2.16498 2.59277 3.36656C2.59277 4.56696 3.56928 5.54465 4.77086 5.54465ZM4.77086 1.7982C5.63542 1.7982 6.33923 2.50201 6.33923 3.36656C6.33923 4.23112 5.63542 4.93493 4.77086 4.93493C3.9063 4.93493 3.2025 4.23112 3.2025 3.36656C3.2025 2.50201 3.9063 1.7982 4.77086 1.7982Z'
			fill='currentColor'
		/>
		<path
			d='M0.2494 12.2365C0.268453 12.24 0.287508 12.2412 0.30537 12.2412C0.449466 12.2412 0.576886 12.1388 0.60547 11.9923L1.08063 9.45103C1.28784 8.07796 2.44656 7.0824 3.83512 7.0824H5.70716C6.15969 7.0824 6.60863 7.19315 7.00639 7.40394C7.15525 7.48254 7.33985 7.42538 7.41844 7.27652C7.49704 7.12766 7.43988 6.94306 7.29102 6.86447C6.80513 6.60843 6.25735 6.47266 5.70716 6.47266H3.83513C2.1429 6.47266 0.730411 7.68735 0.479205 9.34979L0.0052356 11.8804C-0.0257262 12.0459 0.0838686 12.2055 0.2494 12.2365Z'
			fill='currentColor'
		/>
	</svg>
);

export const GridSVG = ({ fill: _fill }: { fill?: string }) => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7.91485 8.63748C5.83196 8.63748 3.74906 8.63748 1.66616 8.63748C1.26101 8.63748 0.824688 8.66864 0.606529 8.23752C0.471478 7.97261 0.528615 7.58824 0.528615 7.29736C0.528615 6.02477 0.528615 4.75737 0.528615 3.48477C0.528615 2.92379 0.528615 2.36281 0.528615 1.79664C0.528615 1.47979 0.471478 1.07463 0.674054 0.804533C0.933767 0.466906 1.34411 0.518849 1.7181 0.518849C2.2583 0.518849 2.8037 0.518849 3.3439 0.518849C4.63208 0.518849 5.92026 0.518849 7.20324 0.518849C7.47334 0.518849 7.7798 0.482489 8.0499 0.529237C8.6005 0.633123 8.64205 1.13177 8.64205 1.57848C8.64205 2.77316 8.64205 3.97303 8.64205 5.16771C8.64205 6.07671 8.67841 6.9909 8.64205 7.89989C8.62647 8.31544 8.3252 8.6219 7.91485 8.63748C7.58242 8.64787 7.58242 9.16729 7.91485 9.15691C8.6836 9.13093 9.16667 8.5284 9.16667 7.79081C9.16667 7.3493 9.16667 6.90779 9.16667 6.46628C9.16667 5.07422 9.16667 3.67696 9.16667 2.2849C9.16667 1.94727 9.17706 1.60445 9.16667 1.26682C9.14589 0.54482 8.5953 0.00981138 7.8733 0.00461712C6.7877 -0.0057714 5.7021 0.00461712 4.6165 0.00461712C3.52051 0.00461712 2.41933 -0.0057714 1.32334 0.00461712C0.601334 0.00981138 0.0351598 0.529238 0.0143827 1.26163C0.00399422 1.58887 0.0143827 1.91611 0.0143827 2.24334C0.0143827 3.63541 0.0143827 5.02747 0.0143827 6.41953C0.0143827 6.87143 0.0143827 7.32333 0.0143827 7.77523C0.0143827 8.46607 0.424729 9.08419 1.15712 9.15171C1.45839 9.17768 1.77004 9.15691 2.07131 9.15691C2.7154 9.15691 3.35429 9.15691 3.99838 9.15691C5.22942 9.15691 6.46565 9.15691 7.69669 9.15691C7.76941 9.15691 7.84213 9.15691 7.91485 9.15691C8.24729 9.15691 8.24729 8.63748 7.91485 8.63748Z'
			fill='currentColor'
		/>
		<path
			d='M7.90509 19.4727C5.82219 19.4727 3.73929 19.4727 1.65639 19.4727C1.25124 19.4727 0.814922 19.5038 0.596763 19.0727C0.461712 18.8078 0.518849 18.4234 0.518849 18.1326C0.518849 16.86 0.518849 15.5926 0.518849 14.32C0.518849 13.759 0.518849 13.198 0.518849 12.6318C0.518849 12.315 0.461712 11.9098 0.664288 11.6397C0.924001 11.3021 1.33435 11.3541 1.70833 11.3541C2.24854 11.3541 2.79394 11.3541 3.33414 11.3541C4.62232 11.3541 5.91049 11.3541 7.19347 11.3541C7.46358 11.3541 7.77004 11.3177 8.04014 11.3644C8.59073 11.4683 8.63228 11.967 8.63228 12.4137C8.63228 13.6084 8.63228 14.8082 8.63228 16.0029C8.63228 16.9119 8.66864 17.8261 8.63228 18.7351C8.6219 19.1506 8.32063 19.4571 7.90509 19.4727C7.57266 19.4831 7.57266 20.0025 7.90509 19.9921C8.67384 19.9661 9.15691 19.3636 9.15691 18.626C9.15691 18.1845 9.15691 17.743 9.15691 17.3015C9.15691 15.9094 9.15691 14.5122 9.15691 13.1201C9.15691 12.7825 9.16729 12.4397 9.15691 12.102C9.13613 11.38 8.58554 10.845 7.86353 10.8398C6.77793 10.8294 5.69233 10.8398 4.60673 10.8398C3.51074 10.8398 2.40956 10.8294 1.31357 10.8398C0.591569 10.845 0.0253942 11.3644 0.00461712 12.0968C-0.0057714 12.4241 0.00461712 12.7513 0.00461712 13.0785C0.00461712 14.4706 0.00461712 15.8627 0.00461712 17.2547C0.00461712 17.7066 0.00461712 18.1585 0.00461712 18.6104C0.00461712 19.3013 0.414964 19.9194 1.14735 19.9869C1.44862 20.0129 1.76028 19.9921 2.06154 19.9921C2.70563 19.9921 3.34453 19.9921 3.98862 19.9921C5.21966 19.9921 6.45589 19.9921 7.68693 19.9921C7.75965 19.9921 7.83237 19.9921 7.90509 19.9921C8.24271 19.9921 8.24271 19.4727 7.90509 19.4727Z'
			fill='currentColor'
		/>
		<path
			d='M18.9324 8.63748C16.8495 8.63748 14.7666 8.63748 12.6837 8.63748C12.2786 8.63748 11.8423 8.66864 11.6241 8.23752C11.4891 7.97261 11.5462 7.58824 11.5462 7.29736C11.5462 6.02477 11.5462 4.75737 11.5462 3.48477C11.5462 2.92379 11.5462 2.36281 11.5462 1.79664C11.5462 1.47979 11.4891 1.07463 11.6916 0.804533C11.9513 0.466906 12.3617 0.518849 12.7357 0.518849C13.2759 0.518849 13.8213 0.518849 14.3615 0.518849C15.6497 0.518849 16.9378 0.518849 18.2208 0.518849C18.4909 0.518849 18.7974 0.482489 19.0675 0.529237C19.6181 0.633123 19.6596 1.13177 19.6596 1.57848C19.6596 2.77316 19.6596 3.97303 19.6596 5.16771C19.6596 6.07671 19.696 6.9909 19.6596 7.89989C19.644 8.31544 19.3428 8.6219 18.9324 8.63748C18.6 8.64787 18.6 9.16729 18.9324 9.15691C19.7012 9.13093 20.1842 8.5284 20.1842 7.79081C20.1842 7.3493 20.1842 6.90779 20.1842 6.46628C20.1842 5.07422 20.1842 3.67696 20.1842 2.2849C20.1842 1.94727 20.1946 1.60445 20.1842 1.26682C20.1635 0.54482 19.6129 0.00981138 18.8909 0.00461712C17.8053 -0.0057714 16.7197 0.00461712 15.6341 0.00461712C14.5381 0.00461712 13.4369 -0.0057714 12.3409 0.00461712C11.6189 0.00981138 11.0527 0.529238 11.032 1.26163C11.0216 1.58887 11.032 1.91611 11.032 2.24334C11.032 3.63541 11.032 5.02747 11.032 6.41953C11.032 6.87143 11.032 7.32333 11.032 7.77523C11.032 8.46607 11.4423 9.08419 12.1747 9.15171C12.476 9.17768 12.7876 9.15691 13.0889 9.15691C13.733 9.15691 14.3719 9.15691 15.016 9.15691C16.247 9.15691 17.4832 9.15691 18.7143 9.15691C18.787 9.15691 18.8597 9.15691 18.9324 9.15691C19.2649 9.15691 19.2649 8.63748 18.9324 8.63748Z'
			fill='currentColor'
		/>
		<path
			d='M18.9227 19.4727C16.8398 19.4727 14.7569 19.4727 12.674 19.4727C12.2688 19.4727 11.8325 19.5039 11.6143 19.0728C11.4793 18.8079 11.5364 18.4235 11.5364 18.1326C11.5364 16.86 11.5364 15.5926 11.5364 14.32C11.5364 13.7591 11.5364 13.1981 11.5364 12.6319C11.5364 12.3151 11.4793 11.9099 11.6819 11.6398C11.9416 11.3022 12.3519 11.3541 12.7259 11.3541C13.2661 11.3541 13.8115 11.3541 14.3517 11.3541C15.6399 11.3541 16.9281 11.3541 18.2111 11.3541C18.4812 11.3541 18.7876 11.3178 19.0577 11.3645C19.6083 11.4684 19.6499 11.967 19.6499 12.4137C19.6499 13.6084 19.6499 14.8083 19.6499 16.003C19.6499 16.912 19.6862 17.8262 19.6499 18.7352C19.6395 19.1507 19.3382 19.4572 18.9227 19.4727C18.5902 19.4831 18.5902 20.0026 18.9227 19.9922C19.6914 19.9662 20.1745 19.3637 20.1745 18.6261C20.1745 18.1846 20.1745 17.7431 20.1745 17.3015C20.1745 15.9095 20.1745 14.5122 20.1745 13.1202C20.1745 12.7825 20.1849 12.4397 20.1745 12.1021C20.1537 11.3801 19.6031 10.8451 18.8811 10.8399C17.7955 10.8295 16.7099 10.8399 15.6243 10.8399C14.5283 10.8399 13.4271 10.8295 12.3311 10.8399C11.6091 10.8451 11.043 11.3645 11.0222 12.0969C11.0118 12.4241 11.0222 12.7514 11.0222 13.0786C11.0222 14.4707 11.0222 15.8627 11.0222 17.2548C11.0222 17.7067 11.0222 18.1586 11.0222 18.6105C11.0222 19.3013 11.4325 19.9194 12.1649 19.987C12.4662 20.0129 12.7779 19.9922 13.0791 19.9922C13.7232 19.9922 14.3621 19.9922 15.0062 19.9922C16.2372 19.9922 17.4735 19.9922 18.7045 19.9922C18.7772 19.9922 18.8499 19.9922 18.9227 19.9922C19.2551 19.9922 19.2603 19.4727 18.9227 19.4727Z'
			fill='currentColor'
		/>
	</svg>
);

export const TableSVG = () => (
	<svg
		width='11'
		height='12'
		viewBox='0 0 25 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M22.4595 3.71822H10.1124C9.23907 3.71822 8.53027 3.00943 8.53027 2.13609C8.53027 1.2625 9.23882 0.553711 10.1124 0.553711H22.4595C23.3331 0.553711 24.0427 1.26225 24.0427 2.13609C24.0427 3.00943 23.3331 3.71822 22.4595 3.71822Z'
			fill='currentColor'
		/>
		<path
			d='M3.99446 4.19865H1.58213C0.708543 4.19865 0 3.49036 0 2.61652V1.58213C0 0.708543 0.708543 0 1.58213 0H3.99446C4.8678 0 5.57659 0.708543 5.57659 1.58213V2.61652C5.57659 3.49036 4.8678 4.19865 3.99446 4.19865Z'
			fill='currentColor'
		/>
		<path
			d='M22.4595 11.582H10.1124C9.23907 11.582 8.53027 10.8733 8.53027 10.0002C8.53027 9.12658 9.23882 8.41779 10.1124 8.41779H22.4595C23.3331 8.41779 24.0427 9.12658 24.0427 10.0002C24.0427 10.8733 23.3331 11.582 22.4595 11.582Z'
			fill='currentColor'
		/>
		<path
			d='M3.99446 12.0996H1.58213C0.708543 12.0996 0 11.391 0 10.5175V9.48306C0 8.60973 0.708543 7.90118 1.58213 7.90118H3.99446C4.8678 7.90118 5.57659 8.60973 5.57659 9.48306V10.5175C5.57659 11.391 4.8678 12.0996 3.99446 12.0996Z'
			fill='currentColor'
		/>
		<path
			d='M22.4595 19.4827H10.1124C9.23907 19.4827 8.53027 18.7744 8.53027 17.9008C8.53027 17.027 9.23882 16.3187 10.1124 16.3187H22.4595C23.3331 16.3187 24.0427 17.027 24.0427 17.9008C24.0427 18.7746 23.3331 19.4827 22.4595 19.4827Z'
			fill='currentColor'
		/>
		<path
			d='M3.99446 20H1.58213C0.708543 20 0 19.2912 0 18.4179V17.3843C0 16.5107 0.708543 15.8019 1.58213 15.8019H3.99446C4.8678 15.8019 5.57659 16.5107 5.57659 17.3843V18.4179C5.57659 19.2912 4.8678 20 3.99446 20Z'
			fill='currentColor'
		/>
	</svg>
);

export const AISVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'white';
	return (
		<svg
			width='25'
			height='20'
			viewBox='0 0 25 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M11.7385 5.57707C11.6255 5.61134 11.5215 5.66617 11.429 5.7427C11.3981 5.76783 11.3673 5.79182 11.3399 5.82152C11.2428 5.92775 11.1754 6.04541 11.1331 6.16992C11.084 6.31499 11.0737 6.46577 11.1 6.61198C11.1343 6.80503 11.2302 6.99123 11.3924 7.14087C11.7842 7.47555 12.3497 7.45271 12.7129 7.08832C12.8374 6.95353 12.9128 6.79818 12.9471 6.6371C12.9711 6.5263 12.9722 6.41322 12.9528 6.30242C12.9197 6.10709 12.8237 5.91975 12.6592 5.76783C12.3965 5.54394 12.0447 5.48454 11.7385 5.57707Z'
				fill={fila}
			/>
			<path
				d='M13.6405 5.30184C13.7318 5.29841 13.8198 5.26072 13.9009 5.20703C13.9386 5.1819 13.9786 5.16134 14.0117 5.12593C14.1202 5.00827 14.1648 4.8552 14.1522 4.7067C14.1408 4.57305 14.086 4.44283 13.9797 4.34459C13.8986 4.2692 13.8061 4.21208 13.7181 4.14697C13.6108 4.06815 13.5 3.99619 13.3835 3.93451C13.147 3.80885 12.8945 3.71747 12.6307 3.66264C12.3931 3.61238 12.1509 3.58154 11.8996 3.59182C11.6152 3.60324 11.341 3.66949 11.076 3.76087C10.8327 3.8454 10.5997 3.95392 10.3872 4.10129C10.2593 4.19039 10.1416 4.29434 10.0274 4.40515C9.99082 4.4417 9.94742 4.46912 9.91201 4.50796C9.70525 4.73184 9.71896 5.08252 9.94399 5.28929C10.0308 5.37039 10.1382 5.40695 10.2479 5.42066C10.3655 5.43551 10.4832 5.41609 10.5883 5.35669C10.6362 5.32927 10.6854 5.30072 10.7242 5.25845C10.7984 5.17049 10.8818 5.0951 10.9721 5.02885C11.0657 4.95917 11.1663 4.90091 11.2713 4.85408C11.4256 4.78554 11.5935 4.74556 11.766 4.72157C11.8334 4.71243 11.9008 4.69873 11.9704 4.6953C12.0241 4.69301 12.0755 4.70215 12.1292 4.70444C12.5507 4.72386 12.9357 4.88149 13.2578 5.15679C13.3686 5.25846 13.5057 5.30641 13.6405 5.30184Z'
				fill={fila}
			/>
			<path
				d='M14.4398 3.83851C14.5152 3.90818 14.6021 3.9436 14.6912 3.96416C14.7346 3.97444 14.7791 3.987 14.8237 3.98586C14.947 3.98129 15.0658 3.92532 15.1641 3.83165C15.1732 3.82252 15.1846 3.81909 15.1938 3.80881C15.4005 3.58492 15.3868 3.23425 15.1618 3.02747C15.059 2.92923 14.9505 2.83785 14.8396 2.74989C14.3039 2.32725 13.6859 2.03938 13.0223 1.89431C12.635 1.80978 12.2318 1.76865 11.8194 1.78465C11.4059 1.80178 11.0027 1.87603 10.6143 1.99711C9.98032 2.19359 9.3909 2.5203 8.88717 2.97148C8.77408 3.072 8.66442 3.17938 8.56047 3.29248C8.55361 3.29933 8.55133 3.30961 8.54562 3.31761C8.42225 3.46611 8.39369 3.65803 8.44852 3.83278C8.47594 3.92188 8.51934 4.00641 8.59245 4.07495C8.64043 4.11949 8.69754 4.1492 8.75466 4.17318C8.88716 4.22916 9.03338 4.2303 9.16587 4.17889C9.2424 4.1492 9.31437 4.10693 9.37377 4.04296C9.42745 3.98471 9.48457 3.93216 9.54169 3.87847C9.76786 3.66258 10.0169 3.47981 10.2853 3.33131C10.5629 3.17824 10.8599 3.06059 11.1729 2.98633C11.3968 2.93379 11.6275 2.90066 11.864 2.89152C12.0468 2.88467 12.2295 2.89495 12.41 2.91551C12.7401 2.95321 13.0623 3.03659 13.3695 3.16225C13.6974 3.29704 14.0058 3.48093 14.2845 3.71055C14.3359 3.75281 14.3896 3.79281 14.4398 3.83851Z'
				fill={fila}
			/>
			<path
				d='M16.4125 2.48973C16.6467 2.2647 16.6318 1.914 16.4079 1.70725C15.1469 0.543243 13.4769 -0.0633098 11.7519 0.0052352C10.0282 0.0749148 8.43812 0.812832 7.24794 2.07507C7.04119 2.29896 7.0549 2.64963 7.27993 2.8564C7.39187 2.96035 7.52895 3.00833 7.66374 3.00262C7.79853 2.99691 7.93104 2.93751 8.03384 2.82556C8.56956 2.24527 9.20925 1.80206 9.9095 1.50508C10.4932 1.2572 11.1192 1.10983 11.7692 1.08357C12.0787 1.07101 12.3849 1.09042 12.6864 1.13041C12.8132 1.14754 12.9389 1.17039 13.0634 1.19552C13.1925 1.22179 13.3215 1.25149 13.4483 1.28804C14.2491 1.51765 14.9962 1.93229 15.6324 2.51943C15.8552 2.72847 16.2057 2.71362 16.4125 2.48973Z'
				fill={fila}
			/>
			<path
				d='M17.6679 19.9989C19.2625 19.9989 20.559 18.7024 20.559 17.1077L20.5579 10.8638C20.5579 9.26916 19.2613 7.97266 17.6667 7.97266H6.68021C5.08557 7.97266 3.78906 9.26916 3.78906 10.8638V17.1077C3.78906 18.7024 5.08557 19.9989 6.68021 19.9989H17.6679ZM4.3738 17.1077V10.8638C4.3738 9.59241 5.40873 8.55751 6.68009 8.55751H17.6666C18.938 8.55751 19.9729 9.59244 19.9729 10.8638V17.1077C19.9729 18.3791 18.938 19.414 17.6666 19.414H6.68009C5.4087 19.414 4.3738 18.3791 4.3738 17.1077Z'
				fill={fila}
			/>
			<path
				d='M0 14.0075C0 15.834 1.48041 17.3154 3.30794 17.3154V10.6992C1.48141 10.6992 0 12.1808 0 14.0072V14.0075Z'
				fill={fila}
			/>
			<path
				d='M21.0078 10.6992V17.3142C22.8343 17.3142 24.3158 15.8338 24.3158 14.0063C24.3146 12.1798 22.8342 10.6983 21.0078 10.6992Z'
				fill={fila}
			/>
			<path
				d='M8.5485 14.2689C9.20532 14.2689 9.73763 13.7366 9.73763 13.0798C9.73763 12.4229 9.20532 11.8906 8.5485 11.8906C7.89168 11.8906 7.35938 12.4229 7.35938 13.0798C7.35938 13.7366 7.89168 14.2689 8.5485 14.2689Z'
				fill={fila}
			/>
			<path
				d='M15.5485 14.2689C16.2053 14.2689 16.7376 13.7366 16.7376 13.0798C16.7376 12.4229 16.2053 11.8906 15.5485 11.8906C14.8917 11.8906 14.3594 12.4229 14.3594 13.0798C14.3605 13.7366 14.8928 14.2689 15.5485 14.2689Z'
				fill={fila}
			/>
			<path
				d='M10.875 15.7383H13.5857V17.1433H10.875V15.7383Z'
				fill={fila}
			/>
		</svg>
	);
};

export const AISVG2 = ({ fill }: { fill?: string }) => {
	const fila = fill || 'white';
	return (
		<svg
			width='25'
			height='27'
			viewBox='0 0 57 63'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M22.0078 18.0156C22.0078 22.0156 16.0078 22.0156 16.0078 18.0156C16.0078 14.0156 22.0078 14.0156 22.0078 18.0156Z'
				fill={fila}
			/>
			<path
				d='M40.0078 18.0156C40.0078 22.0156 34.0078 22.0156 34.0078 18.0156C34.0078 14.0156 40.0078 14.0156 40.0078 18.0156Z'
				fill={fila}
			/>
			<path
				d='M38.0078 36.0155C40.9883 36.0155 42.4883 36.0155 43.9375 35.7265C49.9063 34.5351 54.5395 29.9179 55.7265 23.9375C56.0155 22.4883 56.0155 20.9961 56.0155 18.0078C56.0155 15.0195 56.0155 13.5273 55.7265 12.0781C54.5351 6.10926 49.9179 1.47606 43.9375 0.289061C42.4883 5.96046e-07 40.9883 0 38.0078 0H18.0078C15.0273 0 13.5273 5.96046e-07 12.0781 0.289061C6.10926 1.48046 1.47606 6.09766 0.289059 12.0781C-1.3113e-06 13.5273 0 15.0195 0 18.0078C0 20.9961 -1.3113e-06 22.4883 0.289059 23.9375C1.48046 29.9063 6.09766 34.5395 12.0781 35.7265C13.5273 36.0155 15.0273 36.0155 18.0078 36.0155H25.0078V46.0155H22.668C17.7266 46.0155 14.9961 46.0155 12.387 47.0272C11.0159 47.5585 9.74636 48.2772 8.58616 49.1756C6.37526 50.8944 4.97676 53.2342 2.43776 57.4647C2.0276 58.1561 1.90651 58.953 2.09792 59.7342C2.28933 60.5154 2.77761 61.1639 3.46902 61.5858C4.16043 61.996 4.95732 62.1171 5.73852 61.9257C6.51972 61.7342 7.16822 61.246 7.57832 60.5546C9.81662 56.8163 10.9494 54.9452 12.2697 53.9062C12.9689 53.3671 13.7306 52.9257 14.5509 52.6171C16.1212 52.0077 18.3126 52.0077 22.672 52.0077H33.352C37.7114 52.0077 39.9028 52.0077 41.4614 52.6171C42.2817 52.9374 43.0512 53.3671 43.7426 53.9062C45.0707 54.9374 46.1918 56.8164 48.4418 60.5546C48.9926 61.4647 49.9535 62.0155 51.0199 62.0155C51.559 62.0155 52.0902 61.867 52.559 61.5858C53.2504 61.1756 53.7309 60.5155 53.9301 59.746C54.1293 58.9765 54.0004 58.1679 53.5903 57.4765C51.0512 53.2382 49.6489 50.9062 47.4301 49.1757C46.2817 48.2772 45.0004 47.5546 43.6293 47.0273C41.0199 46.0156 38.3012 46.0156 33.3483 46.0156H31.0085V36.0156L38.0078 36.0155ZM13.2578 29.8436C9.67966 29.1327 6.89836 26.3553 6.18746 22.7733C6.01558 21.9022 6.01558 20.6014 6.01558 18.0116C6.01558 15.4218 6.01558 14.121 6.18746 13.2499C6.8984 9.67182 9.67576 6.89052 13.2578 6.17962C14.1288 6.00775 15.4297 6.00775 18.0195 6.00775H38.0195C40.6093 6.00775 41.9101 6.00775 42.7812 6.17962C46.3593 6.89056 49.1406 9.66792 49.8515 13.2499C50.0233 14.121 50.0233 15.4218 50.0233 18.0116C50.0233 20.6014 50.0233 21.9022 49.8515 22.7733C49.1405 26.3514 46.3632 29.1327 42.7812 29.8436C41.9101 30.0155 40.6093 30.0155 38.0195 30.0155H18.0195C15.4297 30.0155 14.1289 30.0155 13.2695 29.8436H13.2578Z'
				fill={fila}
			/>
		</svg>
	);
};

export const SearchSVG = ({ fill, ...props }: ISVGComponent) => (
	<svg
		width='12'
		height='12'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<path
			d='M20 19.3578L13.578 12.9358C14.7706 11.5596 15.5963 9.72477 15.5963 7.79817C15.5963 3.48624 12.1101 0 7.79817 0C3.48624 0 0 3.48624 0 7.79817C0 12.1101 3.48624 15.5963 7.79817 15.5963C9.81651 15.5963 11.5596 14.8624 12.9358 13.578L19.3578 20L20 19.3578ZM7.70642 14.6789C3.94495 14.6789 0.825688 11.5596 0.825688 7.79817C0.825688 4.0367 3.94495 0.917431 7.70642 0.917431C11.4679 0.917431 14.5872 4.0367 14.5872 7.79817C14.5872 11.5596 11.4679 14.6789 7.70642 14.6789Z'
			fill={fill || 'currentColor'}
		/>
	</svg>
);

export const HistorySVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'currentColor';
	return (
		<svg
			width='14'
			height='15'
			viewBox='0 0 14 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7.19383 14.4642C3.52279 14.4642 0.536057 11.4425 0.536057 7.72829C0.491545 2.27761 6.81585 -0.98497 11.1459 2.3138C11.1458 2.3137 9.6149 2.67632 9.6149 2.67632C9.27214 2.76443 9.39647 3.27354 9.73841 3.1975C9.7384 3.1975 11.8017 2.70903 11.8017 2.70903C11.9301 2.67387 12.0223 2.54524 12.0056 2.41389C12.0056 2.4139 11.7217 0.230003 11.7217 0.230003C11.6701 -0.117633 11.1515 -0.0523067 11.1904 0.299089C11.1904 0.299075 11.3886 1.82436 11.3886 1.82436C6.70107 -1.64462 -0.0496882 1.88681 0.00027575 7.72838C0.000224845 11.7379 3.22727 15 7.19384 15C7.54698 14.9934 7.54322 14.4685 7.19383 14.4642Z'
				fill={fila}
			/>
			<path
				d='M7.19272 4.16943C7.04476 4.16943 6.9248 4.28927 6.9248 4.43735V7.72824C6.9248 7.87632 7.04476 7.99615 7.19272 7.99615H9.39637C9.74788 7.99 9.74918 7.46656 9.39636 7.46032C9.39637 7.46032 7.46064 7.46032 7.46064 7.46032V4.43735C7.46064 4.28927 7.34068 4.16943 7.19272 4.16943Z'
				fill={fila}
			/>
			<path
				d='M7.41602 10.4129C7.41602 10.561 7.53598 10.6809 7.68393 10.6809H13.2876C13.4355 10.6809 13.5555 10.561 13.5555 10.4129C13.5555 10.2649 13.4355 10.145 13.2876 10.145H7.68393C7.53598 10.145 7.41602 10.2649 7.41602 10.4129Z'
				fill={fila}
			/>
			<path
				d='M13.2876 11.6473H7.68393C7.53598 11.6473 7.41602 11.7672 7.41602 11.9153C7.41602 12.0633 7.53598 12.1832 7.68393 12.1832H13.2876C13.6379 12.1778 13.6412 11.6534 13.2876 11.6473Z'
				fill={fila}
			/>
			<path
				d='M13.2876 13.15H7.68393C7.53598 13.15 7.41602 13.2699 7.41602 13.4179C7.41602 13.566 7.53598 13.6859 7.68393 13.6859H13.2876C13.6379 13.6805 13.6412 13.156 13.2876 13.15Z'
				fill={fila}
			/>
		</svg>
	);
};

export const MailSVG = ({ fill }: { fill?: string }) => {
	const fila = fill || 'currentColor';
	return (
		<svg
			width='22'
			height='15'
			viewBox='0 0 27 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M22.1326 0H4.53392C2.03397 0 0 2.03383 0 4.53392V15.4661C0 17.966 2.03383 20 4.53392 20H22.134C24.6326 20 26.6666 17.9662 26.6666 15.4661V4.53392C26.6666 2.03397 24.6327 0 22.1326 0ZM4.53392 1.99997H22.134C23.5011 1.99997 24.617 3.08978 24.6639 4.44653L14.6197 10.6898C13.8267 11.1832 12.8398 11.1832 12.0468 10.6898L2.00397 4.44653C2.04954 3.08978 3.16678 1.99997 4.53392 1.99997ZM24.6663 15.4657C24.6663 16.8629 23.5295 17.9996 22.1324 17.9996H4.53372C3.13661 17.9996 1.9999 16.8629 1.9999 15.4657V6.79922L10.9894 12.3891C11.7134 12.8397 12.5233 13.0623 13.3331 13.0623C14.143 13.0623 14.9529 12.8383 15.6768 12.3891L24.6663 6.79922L24.6663 15.4657Z'
				fill={fila}
			/>
		</svg>
	);
};

export const ClockSVG = ({ color, width, height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width={width || '21'}
		height={height || '20'}
		viewBox='0 0 21 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M10.1336 0C7.42984 0 4.88641 1.03786 2.97105 2.9265C1.05568 4.81514 0 7.32739 0 10C0 12.6726 1.05568 15.1849 2.97105 17.0735C4.88641 18.9621 7.42539 20 10.1336 20C12.8419 20 15.3808 18.9621 17.2962 17.0735C19.2116 15.1849 20.2673 12.6726 20.2673 10C20.2673 7.32739 19.2116 4.81514 17.2962 2.9265C15.3808 1.03786 12.8374 0 10.1336 0ZM10.1336 18.6637C5.28285 18.6637 1.3363 14.7751 1.3363 10C1.3363 5.22494 5.28285 1.3363 10.1336 1.3363C14.9844 1.3363 18.931 5.22494 18.931 10C18.931 14.7751 14.9844 18.6637 10.1336 18.6637Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M14.5039 12.8956L10.7133 9.97797V4.21405C10.7133 3.84434 10.4148 3.5459 10.0451 3.5459C9.67539 3.5459 9.37695 3.84434 9.37695 4.21405V10.3076C9.37695 10.5169 9.46604 10.7129 9.63085 10.8377L13.6888 13.9557C13.809 14.0492 13.9516 14.0938 14.0941 14.0938C14.2945 14.0938 14.495 14.0047 14.6286 13.831C14.8513 13.5414 14.7979 13.1227 14.5039 12.8956Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const AddSVG = (_props: { color?: string; width?: string; height?: string }) => (
	<svg
		width='14'
		height='14'
		viewBox='0 0 14 14'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M6 8H0V6H6V0H8V6H14V8H8V14H6V8Z'
			fill='#525252'
		/>
	</svg>
);

export const UploadIconSVG = ({ color, width: _width, height: _height }: { color?: string; width?: string; height?: string }) => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M7 12V3.85L4.4 6.45L3 5L8 0L13 5L11.6 6.45L9 3.85V12H7ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z'
			fill={color || '#525252'}
		/>
	</svg>
);

export const DivisionsSVG = (_props: { color?: string; width?: string; height?: string }) => (
	<svg
		width='17'
		height='16'
		viewBox='0 0 80 92'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M79.442 22.6343L40.471 0.13425C40.161 -0.04475 39.781 -0.04475 39.471 0.13425L0.5 22.6343C0.19 22.8133 0 23.1432 0 23.5002V68.5003C0 68.8573 0.19 69.1882 0.5 69.3662L39.471 91.8662C39.626 91.9562 39.798 92.0003 39.971 92.0003C40.144 92.0003 40.316 91.9562 40.471 91.8662L79.442 69.3662C79.754 69.1872 79.942 68.8573 79.942 68.5003V23.5002C79.942 23.1432 79.752 22.8133 79.442 22.6343ZM58.291 56.7683L58.748 55.9753L56.582 54.7253L55.832 56.0243L57.707 57.1063L40.971 66.7682V46.7463L41.117 46.4943L60.623 35.2323L60.164 36.0253L62.33 37.2753L63.08 35.9763L61.207 34.8943L77.943 25.2323V45.2553L77.797 45.5063L58.291 56.7683ZM21.183 78.4823L20.736 78.7402L2.146 68.0073L2 67.7552V47.7323L18.736 57.3943L16.862 58.4763L17.612 59.7753L19.778 58.5253L19.32 57.7323L38.221 68.6452L36.347 69.7272L37.097 71.0263L38.971 69.9433V89.2702L21.63 79.2573L21.183 78.4823ZM40.116 2.23925L76.942 23.5002L58.291 34.2683L58.748 33.4753L56.582 32.2243L55.832 33.5233L57.707 34.6053L40.115 44.7623H39.826L22.236 34.6063L24.11 33.5243L23.36 32.2253L21.194 33.4763L21.652 34.2693L3 23.5002L39.826 2.23925H40.116ZM18.735 34.8953L16.861 35.9773L17.611 37.2763L19.777 36.0263L19.319 35.2333L38.826 46.4953L38.971 46.7453V66.7673L22.236 57.1053L24.11 56.0233L23.36 54.7243L21.194 55.9763L21.652 56.7693L2.145 45.5063L2 45.2553V25.2323L18.735 34.8953ZM38.971 69.2702L38.805 68.9813L38.971 69.0783V69.2702ZM40.971 69.0783L41.138 68.9823L40.971 69.2702V69.0783ZM40.971 69.9433L42.846 71.0253L43.596 69.7262L41.722 68.6442L60.623 57.7303L60.166 58.5233L62.332 59.7733L63.082 58.4743L61.207 57.3923L77.943 47.7303V67.7523L77.797 68.0042L59.207 78.7402L58.76 78.4823L58.312 79.2552L40.971 89.2682V69.9433Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 14.7454H39.2207V17.2464H40.7207V14.7454Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 34.7563H39.2207V37.2573H40.7207V34.7563Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 9.74316H39.2207V12.2442H40.7207V9.74316Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 4.74023H39.2207V7.24123H40.7207V4.74023Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 29.7542H39.2207V32.2551H40.7207V29.7542Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 19.7483H39.2207V22.2493H40.7207V19.7483Z'
			fill='currentColor'
		/>
		<path
			d='M39.2204 24.7513V27.2523H40.7204V24.7513H40.6784L41.4174 23.4713L40.3444 22.8513L39.9704 23.5003L39.5954 22.8513L38.5234 23.4713L39.2634 24.7513H39.2204ZM39.9704 24.3663L40.6354 24.7503H39.3054L39.9704 24.3663Z'
			fill='currentColor'
		/>
		<path
			d='M40.7207 39.7593H39.2207V42.2603H40.7207V39.7593Z'
			fill='currentColor'
		/>
		<path
			d='M12.5269 60.9755L13.2773 62.2742L15.4418 61.0234L14.6914 59.7247L12.5269 60.9755Z'
			fill='currentColor'
		/>
		<path
			d='M3.85913 65.9784L4.60938 67.2795L6.77599 66.0303L6.02574 64.7291L3.85913 65.9784Z'
			fill='currentColor'
		/>
		<path
			d='M8.19486 63.4777L8.94531 64.7764L11.1107 63.5251L10.3602 62.2264L8.19486 63.4777Z'
			fill='currentColor'
		/>
		<path
			d='M37.1116 48.5199L36.3613 47.2188L34.1947 48.468L34.945 49.7692L37.1116 48.5199Z'
			fill='currentColor'
		/>
		<path
			d='M32.7755 51.0246L32.0254 49.7256L29.8604 50.9758L30.6105 52.2748L32.7755 51.0246Z'
			fill='currentColor'
		/>
		<path
			d='M28.4435 53.5246L27.6934 52.2256L25.5275 53.4763L26.2776 54.7753L28.4435 53.5246Z'
			fill='currentColor'
		/>
		<path
			d='M76.0808 65.9846L73.916 64.7339L73.1656 66.0327L75.3303 67.2835L76.0808 65.9846Z'
			fill='currentColor'
		/>
		<path
			d='M71.7501 63.4805L69.584 62.2305L68.8343 63.5296L71.0004 64.7796L71.7501 63.4805Z'
			fill='currentColor'
		/>
		<path
			d='M51.4999 53.5271L53.666 54.7771L54.4157 53.4779L52.2496 52.228L51.4999 53.5271Z'
			fill='currentColor'
		/>
		<path
			d='M67.4061 60.9792L65.2422 59.7292L64.4919 61.0281L66.6558 62.2781L67.4061 60.9792Z'
			fill='currentColor'
		/>
		<path
			d='M42.8397 48.5266L45.0059 49.7766L45.7566 48.4757L43.5904 47.2257L42.8397 48.5266Z'
			fill='currentColor'
		/>
		<path
			d='M47.1737 51.0269L49.3398 52.2769L50.0895 50.9777L47.9234 49.7277L47.1737 51.0269Z'
			fill='currentColor'
		/>
		<path
			d='M45.0175 72.2805L47.1836 73.5305L47.9338 72.2305L45.7677 70.9805L45.0175 72.2805Z'
			fill='currentColor'
		/>
		<path
			d='M49.3397 74.7754L51.5059 76.0254L52.2556 74.7262L50.0894 73.4762L49.3397 74.7754Z'
			fill='currentColor'
		/>
		<path
			d='M54.4298 75.9827L53.6797 77.2817L55.8456 78.5325L56.5957 77.2335L54.4298 75.9827Z'
			fill='currentColor'
		/>
		<path
			d='M32.0093 72.2313L32.7598 73.53L34.9251 72.2788L34.1747 70.9801L32.0093 72.2313Z'
			fill='currentColor'
		/>
		<path
			d='M23.3491 77.2324L24.0996 78.5322L26.2646 77.2822L25.5141 75.9824L23.3491 77.2324Z'
			fill='currentColor'
		/>
		<path
			d='M27.6815 74.7252L28.4316 76.0242L30.5975 74.7734L29.8474 73.4744L27.6815 74.7252Z'
			fill='currentColor'
		/>
		<path
			d='M37.1079 26.0221L36.3574 24.7234L34.1921 25.9746L34.9425 27.2733L37.1079 26.0221Z'
			fill='currentColor'
		/>
		<path
			d='M32.7772 28.5228L32.0273 27.2236L29.8612 28.4739L30.6111 29.773L32.7772 28.5228Z'
			fill='currentColor'
		/>
		<path
			d='M28.4393 31.0233L27.6895 29.7241L25.5233 30.9744L26.2732 32.2735L28.4393 31.0233Z'
			fill='currentColor'
		/>
		<path
			d='M15.4455 38.5297L14.6953 37.2307L12.5294 38.4815L13.2796 39.7805L15.4455 38.5297Z'
			fill='currentColor'
		/>
		<path
			d='M11.1137 41.0299L10.3633 39.7312L8.19792 40.9825L8.94837 42.2812L11.1137 41.0299Z'
			fill='currentColor'
		/>
		<path
			d='M4.61709 44.7751L6.7832 43.5251L6.0335 42.226L3.86739 43.476L4.61709 44.7751Z'
			fill='currentColor'
		/>
		<path
			d='M64.5002 38.5273L66.666 39.7778L67.416 38.4788L65.2502 37.2283L64.5002 38.5273Z'
			fill='currentColor'
		/>
		<path
			d='M45.7529 25.9695L43.5859 24.719L42.8362 26.0181L45.0032 27.2686L45.7529 25.9695Z'
			fill='currentColor'
		/>
		<path
			d='M54.4187 30.9758L52.2539 29.7253L51.5036 31.0242L53.6684 32.2747L54.4187 30.9758Z'
			fill='currentColor'
		/>
		<path
			d='M50.0838 28.4741L47.918 27.2236L47.168 28.5226L49.3338 29.7731L50.0838 28.4741Z'
			fill='currentColor'
		/>
		<path
			d='M73.9159 42.2321L73.166 43.5312L75.3321 44.7815L76.082 43.4823L73.9159 42.2321Z'
			fill='currentColor'
		/>
		<path
			d='M68.8341 41.0283L71 42.2788L71.75 40.9798L69.5841 39.7293L68.8341 41.0283Z'
			fill='currentColor'
		/>
	</svg>
);

export const ViewIconSVG = (_props: { color?: string; width?: string; height?: string }) => (
	<svg
		width='22'
		height='15'
		viewBox='0 0 22 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11 12C12.25 12 13.3125 11.5625 14.1875 10.6875C15.0625 9.8125 15.5 8.75 15.5 7.5C15.5 6.25 15.0625 5.1875 14.1875 4.3125C13.3125 3.4375 12.25 3 11 3C9.75 3 8.6875 3.4375 7.8125 4.3125C6.9375 5.1875 6.5 6.25 6.5 7.5C6.5 8.75 6.9375 9.8125 7.8125 10.6875C8.6875 11.5625 9.75 12 11 12ZM11 10.2C10.25 10.2 9.6125 9.9375 9.0875 9.4125C8.5625 8.8875 8.3 8.25 8.3 7.5C8.3 6.75 8.5625 6.1125 9.0875 5.5875C9.6125 5.0625 10.25 4.8 11 4.8C11.75 4.8 12.3875 5.0625 12.9125 5.5875C13.4375 6.1125 13.7 6.75 13.7 7.5C13.7 8.25 13.4375 8.8875 12.9125 9.4125C12.3875 9.9375 11.75 10.2 11 10.2ZM11 15C8.56667 15 6.35 14.3208 4.35 12.9625C2.35 11.6042 0.9 9.78333 0 7.5C0.9 5.21667 2.35 3.39583 4.35 2.0375C6.35 0.679167 8.56667 0 11 0C13.4333 0 15.65 0.679167 17.65 2.0375C19.65 3.39583 21.1 5.21667 22 7.5C21.1 9.78333 19.65 11.6042 17.65 12.9625C15.65 14.3208 13.4333 15 11 15ZM11 13C12.8833 13 14.6125 12.5042 16.1875 11.5125C17.7625 10.5208 18.9667 9.18333 19.8 7.5C18.9667 5.81667 17.7625 4.47917 16.1875 3.4875C14.6125 2.49583 12.8833 2 11 2C9.11667 2 7.3875 2.49583 5.8125 3.4875C4.2375 4.47917 3.03333 5.81667 2.2 7.5C3.03333 9.18333 4.2375 10.5208 5.8125 11.5125C7.3875 12.5042 9.11667 13 11 13Z'
			fill='#525252'
		/>
	</svg>
);

export const TrashSVG = ({ color }: { color?: string }) => (
	<svg
		width='12'
		height='12'
		viewBox='0 0 20 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M17.7351 5.07178L17.0431 21.6796C17.0212 22.2067 16.5657 22.6425 16.0365 22.6425H3.96107C3.43186 22.6425 2.97637 22.2058 2.95444 21.6796L2.26245 5.07178C2.24944 4.75944 1.98568 4.51678 1.67334 4.5298C1.361 4.54281 1.11835 4.80657 1.13136 5.11891L1.82335 21.7267C1.87055 22.8594 2.82507 23.7746 3.96107 23.7746H16.0365C17.1719 23.7746 18.127 22.8609 18.1742 21.7267L18.8662 5.11891C18.8792 4.80657 18.6366 4.54281 18.3242 4.5298C18.0119 4.51678 17.7481 4.75944 17.7351 5.07178Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M9.62305 7.35901V20.1892C9.62305 20.5018 9.87647 20.7552 10.1891 20.7552C10.5017 20.7552 10.7551 20.5018 10.7551 20.1892V7.35901C10.7551 7.04639 10.5017 6.79297 10.1891 6.79297C9.87647 6.79297 9.62305 7.04639 9.62305 7.35901Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M5.28345 7.37565L5.66081 20.2058C5.67 20.5183 5.93077 20.7642 6.24324 20.755C6.55572 20.7458 6.80159 20.485 6.7924 20.1726L6.41504 7.34237C6.40585 7.02989 6.14508 6.78403 5.8326 6.79322C5.52013 6.80241 5.27426 7.06317 5.28345 7.37565Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M13.5846 7.34237L13.2073 20.1726C13.1981 20.485 13.444 20.7458 13.7564 20.755C14.0689 20.7642 14.3297 20.5183 14.3389 20.2058L14.7162 7.37565C14.7254 7.06317 14.4796 6.80241 14.1671 6.79322C13.8546 6.78403 13.5938 7.02989 13.5846 7.34237Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M0.566038 3.20825H19.434C19.7466 3.20825 20 2.95482 20 2.64221C20 2.3296 19.7466 2.07617 19.434 2.07617H0.566038C0.253424 2.07617 0 2.3296 0 2.64221C0 2.95482 0.253424 3.20825 0.566038 3.20825Z'
			fill={color || 'currentColor'}
		/>
		<path
			d='M6.75228 2.66305L7.15615 1.65337C7.26367 1.38458 7.63668 1.13208 7.92484 1.13208H12.0758C12.366 1.13208 12.7362 1.38271 12.8445 1.65337L13.2483 2.66305L14.2994 2.24261L13.8956 1.23293C13.6154 0.532464 12.8289 0 12.0758 0H7.92484C7.17381 0 6.3845 0.534297 6.10504 1.23293L5.70117 2.24261L6.75228 2.66305Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const ErrorSVG = ({ color }: { color?: string }) => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 83 83'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M41.404 0C18.574 0 0 18.575 0 41.406C0 64.237 18.574 82.811 41.404 82.811C64.235 82.811 82.808 64.237 82.808 41.406C82.809 18.575 64.235 0 41.404 0ZM41.404 77.811C21.331 77.811 5 61.48 5 41.406C5 21.332 21.331 5 41.404 5C61.477 5 77.809 21.332 77.809 41.406C77.809 61.48 61.477 77.811 41.404 77.811Z'
			fill={color || '#000'}
		/>
		<path
			d='M55.0062 27.806C54.0292 26.83 52.4452 26.83 51.4712 27.807L41.4042 37.878L31.3382 27.807C30.3612 26.829 28.7782 26.83 27.8032 27.806C26.8262 28.782 26.8262 30.365 27.8022 31.341L37.8702 41.414L27.8022 51.486C26.8262 52.462 26.8262 54.046 27.8032 55.021C28.2912 55.509 28.9302 55.752 29.5702 55.752C30.2102 55.752 30.8502 55.508 31.3382 55.02L41.4042 44.95L51.4702 55.02C51.9582 55.508 52.5972 55.752 53.2382 55.752C53.8782 55.752 54.5172 55.508 55.0062 55.021C55.9832 54.045 55.9832 52.461 55.0062 51.486L44.9382 41.414L55.0052 31.341C55.9822 30.365 55.9822 28.782 55.0062 27.806Z'
			fill={color || '#000'}
		/>
	</svg>
);

export const PrintSVG = ({ color: _color }: { color?: string }) => (
	<svg
		width='12'
		height='15'
		viewBox='0 0 12 15'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M11.7611 4.24352H9.16544V0.233733C9.16544 0.104232 9.0589 0 8.92654 0H3.07506C2.94269 0 2.83615 0.104232 2.83615 0.233733V4.24195H0.238902C0.106537 4.24195 0 4.34618 0 4.47568V10.4943C0 10.6238 0.106537 10.728 0.238902 10.728H2.83615V14.7663C2.83615 14.8958 2.94269 15 3.07506 15H8.92493C9.05729 15 9.16383 14.8958 9.16383 14.7663V10.7312H11.7611C11.8934 10.7312 12 10.627 12 10.4975V4.47726C12.0016 4.34776 11.8934 4.24352 11.7611 4.24352ZM3.31396 0.469046H8.68441V4.24352H3.31396V0.469046ZM8.68602 14.5341H3.31396V10.4959V8.62129H8.68441V10.4959V14.5341H8.68602ZM11.5222 10.2622H9.16544V8.38598C9.16544 8.25647 9.0589 8.15224 8.92654 8.15224H3.07506C2.94269 8.15224 2.83615 8.25647 2.83615 8.38598V10.2606H0.479418V4.71257H3.07667H8.92654H11.5238V10.2622H11.5222ZM4.55205 9.56412H7.44632V10.0332H4.55205V9.56412ZM4.55205 10.6396H7.44632V11.1087H4.55205V10.6396ZM4.55205 11.7151H7.44632V12.1841H4.55205V11.7151ZM4.55205 12.789H7.44632V13.2581H4.55205V12.789ZM8.97658 5.61434C8.97658 5.48484 9.08312 5.38061 9.21548 5.38061H10.5198C10.6521 5.38061 10.7587 5.48484 10.7587 5.61434C10.7587 5.74384 10.6521 5.84807 10.5198 5.84807H9.21548C9.08312 5.84965 8.97658 5.74384 8.97658 5.61434Z'
			fill='currentColor'
		/>
	</svg>
);

export const FlagSVG = () => (
	<svg
		width='13'
		height='13'
		viewBox='0 0 16 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M12.3999 5.03268L15.9494 1.1832C16.0137 1.0802 16.017 0.950882 15.9584 0.844869C15.8993 0.738856 15.7877 0.673203 15.6667 0.673203H0.666667V0.333333C0.666667 0.148987 0.517647 0 0.333333 0C0.14902 0 0 0.14902 0 0.333333V1.00654V8.05882V9.05882V19.6667C0 19.851 0.148987 20 0.333333 20C0.51768 20 0.666667 19.851 0.666667 19.6667V9.39216H15.6667C15.7877 9.39216 15.8993 9.32647 15.9584 9.22013C16.017 9.11448 16.0137 8.9848 15.9494 8.8818L12.3999 5.03268ZM0.666699 8.72549V8.05882V1.33987H15.065L11.7239 4.85601C11.6562 4.96402 11.6562 5.10134 11.7239 5.20967L15.065 8.72549H0.666699Z'
			fill='currentColor'
		/>
	</svg>
);

export const NotesSVG = () => (
	<svg
		width='9'
		height='13'
		viewBox='0 0 9 13'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M0.120687 13H8.83346C8.89445 13 8.944 12.9504 8.944 12.8895V0.691577C8.944 0.630587 8.89445 0.581033 8.83346 0.581033H8.07273V0.110543C8.07273 0.0495541 8.02317 0 7.96219 0C7.9012 0 7.85164 0.0495541 7.85164 0.110543V0.581033H5.74594V0.110543C5.74594 0.0495541 5.69638 0 5.6354 0C5.57441 0 5.52485 0.0495541 5.52485 0.110543V0.581033H3.41915V0.110543C3.41915 0.0495541 3.3696 0 3.30861 0C3.24762 0 3.19806 0.0495541 3.19806 0.110543V0.581033H1.09236V0.110543C1.09236 0.0495541 1.04281 0 0.981816 0C0.920827 0 0.871273 0.0495541 0.871273 0.110543V0.581033H0.110544C0.0495542 0.581033 0 0.630587 0 0.691577V12.8895C0 12.9504 0.0495542 13 0.110544 13H0.120687ZM0.23123 2.54467H8.72625V11.0397H7.09425C7.03326 11.0397 6.9837 11.0892 6.9837 11.1502V12.7822H0.231234L0.23123 2.54467ZM0.23123 1.38316H0.884688V1.85365C0.884688 1.91464 0.934242 1.96419 0.995231 1.96419C1.05622 1.96419 1.10577 1.91464 1.10577 1.85365V1.38316H3.21148V1.85365C3.21148 1.91464 3.26103 1.96419 3.32202 1.96419C3.38301 1.96419 3.43256 1.91464 3.43256 1.85365V1.38316H5.53827V1.85365C5.53827 1.91464 5.58782 1.96419 5.64881 1.96419C5.7098 1.96419 5.75935 1.91464 5.75935 1.85365V1.38316H7.86506V1.85365C7.86506 1.91464 7.91461 1.96419 7.9756 1.96419C8.03659 1.96419 8.08614 1.91464 8.08614 1.85365V1.38316H8.7396V2.32686H0.231057L0.23123 1.38316ZM8.57207 11.2574L7.20145 12.6281V11.2574H8.57207ZM7.355 12.7823L8.72562 11.4116V12.7823H7.355ZM8.72562 0.80212V1.16534H8.07217V0.80212H8.72562ZM7.85435 0.80212V1.16534H5.74864V0.80212H7.85435ZM5.53076 0.80212V1.16534H3.42505V0.80212H5.53076ZM3.20716 0.80212V1.16534H1.10146V0.80212H3.20716ZM0.883573 0.80212V1.16534H0.230115V0.80212H0.883573Z'
			fill='currentColor'
		/>
		<path
			d='M1.28242 4.28701H7.6716C7.73259 4.28701 7.78214 4.23745 7.78214 4.17646C7.78214 4.11547 7.73259 4.06592 7.6716 4.06592L1.28242 4.06646C1.22143 4.06646 1.17188 4.11602 1.17188 4.17701C1.17188 4.238 1.22143 4.28755 1.28242 4.28755V4.28701Z'
			fill='currentColor'
		/>
		<path
			d='M1.28242 6.32021H7.6716C7.73259 6.32021 7.78214 6.27065 7.78214 6.20966C7.78214 6.14867 7.73259 6.09912 7.6716 6.09912L1.28242 6.09967C1.22143 6.09967 1.17188 6.14922 1.17188 6.21021C1.17188 6.2712 1.22143 6.32075 1.28242 6.32075V6.32021Z'
			fill='currentColor'
		/>
		<path
			d='M1.28242 8.35341H7.6716C7.73259 8.35341 7.78214 8.30386 7.78214 8.24287C7.78214 8.18188 7.73259 8.13232 7.6716 8.13232H1.28242C1.22143 8.13232 1.17188 8.18188 1.17188 8.24287C1.17188 8.30386 1.22143 8.35341 1.28242 8.35341Z'
			fill='currentColor'
		/>
		<path
			d='M5.9296 10.1655H1.28242C1.22143 10.1655 1.17188 10.2151 1.17188 10.2761C1.17188 10.3371 1.22143 10.3866 1.28242 10.3866H5.92904C5.99003 10.3866 6.03959 10.3371 6.03959 10.2761C6.03959 10.2151 5.99003 10.1655 5.92904 10.1655H5.9296Z'
			fill='currentColor'
		/>
	</svg>
);

export const PadlockElectionSVG = ({ ...rest }: ISVGComponent) => (
	<svg
		width='49'
		height='40'
		viewBox='0 0 37 30'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M15.5203 8.56836H14.0814C13.2316 8.56836 12.5415 9.25995 12.5415 10.1097V12.6546H17.0617V10.1097C17.0617 9.25995 16.3716 8.56836 15.5219 8.56836H15.5203Z'
			fill='currentColor'
		/>
		<path
			d='M16.331 16.6074C16.331 15.7622 15.6455 15.0781 14.8017 15.0781C13.9565 15.0781 13.2725 15.7622 13.2725 16.6074C13.2725 17.2372 13.6537 17.7766 14.1961 18.0117L13.5482 20.2266C13.4608 20.5234 13.6838 20.8202 13.9926 20.8202H15.6093C15.9182 20.8202 16.1412 20.5234 16.0538 20.2266L15.4059 18.0117C15.9498 17.7766 16.331 17.2372 16.331 16.6074Z'
			fill='currentColor'
		/>
		<path
			d='M29.5993 14.7269C25.2855 14.3984 21.8835 10.7899 21.8835 6.39188C21.8835 5.06747 22.1878 3.81539 22.7468 2.71096C20.4506 1.2404 17.7279 0.390625 14.8003 0.390625C6.62197 0.389119 0 7.02307 0 15.2003C0 23.3776 6.62196 29.9992 14.7987 29.9992C22.9755 29.9992 29.6095 23.3772 29.6095 15.2003C29.6095 15.0421 29.6095 14.8854 29.5974 14.7272L29.5993 14.7269ZM21.772 21.4723C21.772 22.4502 20.9795 23.2443 20.0001 23.2443H9.60081C8.62294 23.2443 7.82891 22.4517 7.82891 21.4723V14.421C7.82891 13.4431 8.62144 12.6506 9.60081 12.6506H10.3677V10.1058C10.3677 8.05815 12.0326 6.39172 14.0817 6.39172H15.5207C17.5683 6.39172 19.2347 8.05815 19.2347 10.1058V12.6506H20.0001C20.9779 12.6506 21.772 13.4447 21.772 14.421V21.4723Z'
			fill='currentColor'
		/>
		<path
			d='M30.2489 0C26.7187 0 23.8545 2.86277 23.8545 6.39446C23.8545 9.92614 26.7172 12.7874 30.2489 12.7874C33.7791 12.7874 36.6433 9.9246 36.6433 6.39446C36.6433 2.86273 33.7805 0 30.2489 0ZM33.315 5.58522L30.0183 8.88192C29.83 9.06875 29.5844 9.16368 29.3388 9.16368C29.0932 9.16368 28.8462 9.07026 28.6593 8.88192L27.0215 7.24412C26.6464 6.86894 26.6464 6.26023 27.0215 5.88507C27.3967 5.5099 28.0054 5.5099 28.3806 5.88507L29.3388 6.84336L31.9544 4.22617C32.3296 3.851 32.9383 3.851 33.3135 4.22617C33.6901 4.60135 33.6901 5.21007 33.3135 5.58522H33.315Z'
			fill='currentColor'
		/>
	</svg>
);

export const CautionSvg = ({ ...rest }: ISVGComponent) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 24 24'
		width='14'
		height='14'
		role='img'
		aria-labelledby='cautionTitle cautionDesc'
		focusable='false'
		style={{ color: '#f6c23e' }}
		{...rest}
	>
		<path
			d='M1 21h22L12 2 1 21z'
			fill='currentColor'
		/>

		<rect
			x='11'
			y='7.5'
			width='2'
			height='6'
			rx='0.6'
			fill='#fff'
		/>
		<circle
			cx='12'
			cy='17.2'
			r='1.2'
			fill='#fff'
		/>
	</svg>
);

export const ArrowDownSvg = ({ ...rest }: ISVGComponent) => (
	<svg
		width='8'
		height='11'
		viewBox='0 0 8 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M4.37616 10.8509L7.82962 7.55087C8.01422 7.3654 8.07742 6.96865 7.87364 6.75165C7.66987 6.53538 7.28292 6.53609 7.07986 6.75452L4.54647 9.17231V0.549997C4.54647 0.246362 4.30222 0 4.00119 0C3.70015 0 3.4559 0.246362 3.4559 0.549997V9.17231L0.922516 6.75452C0.720161 6.53681 0.318306 6.52178 0.128729 6.75165C-0.0459325 6.96362 -0.0537411 7.35823 0.17275 7.55087L3.62621 10.8509C3.76537 10.9912 4.13245 11.1008 4.37598 10.8509H4.37616Z'
			fill='red'
		/>
	</svg>
);

export const ArrowUpSvg = ({ ...rest }: ISVGComponent) => (
	<svg
		width='8'
		height='11'
		viewBox='0 0 8 11'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M3.62384 0.149141L0.170379 3.44913C-0.0142176 3.6346 -0.0774155 4.03135 0.126359 4.24835C0.330131 4.46462 0.717081 4.46391 0.920145 4.24548L3.45353 1.82769L3.45353 10.45C3.45353 10.7536 3.69778 11 3.99881 11C4.29985 11 4.5441 10.7536 4.5441 10.45L4.5441 1.82769L7.07748 4.24548C7.27984 4.46319 7.68169 4.47822 7.87127 4.24835C8.04593 4.03638 8.05374 3.64177 7.82725 3.44913L4.37379 0.149141C4.23463 0.00877809 3.86755 -0.100796 3.62403 0.149141L3.62384 0.149141Z'
			fill='#0C9F29'
		/>
	</svg>
);

// Menu Icons - Organization Specific

export const MyElectionSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='17'
		height='20'
		viewBox='0 0 17 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		{/* Ballot box body */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M1 8C0.447715 8 0 8.44772 0 9V18C0 19.1046 0.895431 20 2 20H15C16.1046 20 17 19.1046 17 18V9C17 8.44772 16.5523 8 16 8H1ZM2 10H15V18H2V10Z'
			fill={fill || 'currentColor'}
		/>
		{/* Ballot slot */}
		<rect
			x='5'
			y='6'
			width='7'
			height='2'
			rx='0.5'
			fill={fill || 'currentColor'}
		/>
		{/* Ballot paper */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5.5 0C5.22386 0 5 0.223858 5 0.5V5H12V0.5C12 0.223858 11.7761 0 11.5 0H5.5ZM6.5 1.5H10.5V3.5H6.5V1.5Z'
			fill={fill || 'currentColor'}
		/>
		{/* Checkmark on ballot */}
		<path
			d='M7.5 2.8L8.2 3.5L9.8 1.8'
			stroke={fill || 'currentColor'}
			strokeWidth='0.8'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);

export const ResultAnalyticsSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		{/* Chart bars */}
		<rect
			x='1'
			y='12'
			width='3'
			height='7'
			rx='0.5'
			fill={fill || 'currentColor'}
		/>
		<rect
			x='6'
			y='8'
			width='3'
			height='11'
			rx='0.5'
			fill={fill || 'currentColor'}
		/>
		<rect
			x='11'
			y='5'
			width='3'
			height='14'
			rx='0.5'
			fill={fill || 'currentColor'}
		/>
		{/* Trend line with arrow */}
		<path
			d='M2.5 10L7.5 6L12.5 3L16 1'
			stroke={fill || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		{/* Arrow head */}
		<path
			d='M14 0.5L17 1L16 4'
			stroke={fill || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		{/* Baseline */}
		<rect
			x='0'
			y='19'
			width='18'
			height='1'
			rx='0.5'
			fill={fill || 'currentColor'}
		/>
	</svg>
);

export const ManageAgentsSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		{/* Main person head */}
		<circle
			cx='7'
			cy='4'
			r='3'
			fill={fill || 'currentColor'}
		/>
		{/* Main person body */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 15C0 11.134 3.13401 8 7 8C8.32608 8 9.55479 8.38892 10.5858 9.05C10.2113 9.63089 10 10.3167 10 11.05C10 11.3814 10.0388 11.7037 10.1118 12.0129C9.47081 11.369 8.28595 11 7 11C4.79086 11 3 12.7909 3 15V18H11V15.8284C11.3144 15.9395 11.6505 16 12 16C12.1699 16 12.337 15.9872 12.5 15.9622V18C12.5 19.1046 11.6046 20 10.5 20H2C0.89543 20 0 19.1046 0 18V15Z'
			fill={fill || 'currentColor'}
		/>
		{/* Gear icon */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12 6.5C11.7239 6.5 11.5 6.72386 11.5 7V7.62635C11.0534 7.77362 10.6515 8.01675 10.3192 8.33262L9.78647 8.02514C9.5478 7.88718 9.24319 7.96886 9.10522 8.20753L8.60522 9.07307C8.46726 9.31174 8.54893 9.61635 8.7876 9.75432L9.31739 10.0601C9.27255 10.2688 9.25 10.4846 9.25 10.705C9.25 10.9254 9.27255 11.1412 9.31739 11.3499L8.7876 11.6557C8.54893 11.7937 8.46726 12.0983 8.60522 12.3369L9.10522 13.2025C9.24319 13.4411 9.5478 13.5228 9.78647 13.3849L10.3192 13.0774C10.6515 13.3933 11.0534 13.6364 11.5 13.7837V14.41C11.5 14.6861 11.7239 14.91 12 14.91H13C13.2761 14.91 13.5 14.6861 13.5 14.41V13.7837C13.9466 13.6364 14.3485 13.3933 14.6808 13.0774L15.2135 13.3849C15.4522 13.5228 15.7568 13.4411 15.8948 13.2025L16.3948 12.3369C16.5327 12.0983 16.4511 11.7937 16.2124 11.6557L15.6826 11.3499C15.7275 11.1412 15.75 10.9254 15.75 10.705C15.75 10.4846 15.7275 10.2688 15.6826 10.0601L16.2124 9.75432C16.4511 9.61635 16.5327 9.31174 16.3948 9.07307L15.8948 8.20753C15.7568 7.96886 15.4522 7.88718 15.2135 8.02514L14.6808 8.33262C14.3485 8.01675 13.9466 7.77362 13.5 7.62635V7C13.5 6.72386 13.2761 6.5 13 6.5H12ZM12.5 12.205C13.3284 12.205 14 11.5335 14 10.705C14 9.87657 13.3284 9.205 12.5 9.205C11.6716 9.205 11 9.87657 11 10.705C11 11.5335 11.6716 12.205 12.5 12.205Z'
			fill={fill || 'currentColor'}
		/>
	</svg>
);

export const MyPartySVG = ({ fill }: { fill?: string }) => (
	<svg
		width='17'
		height='20'
		viewBox='0 0 17 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		{/* Flag pole */}
		<rect
			x='1'
			y='0'
			width='2'
			height='20'
			rx='1'
			fill={fill || 'currentColor'}
		/>
		{/* Flag body with wave */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M4 1C4 0.447715 4.44772 0 5 0H15C15.3788 0 15.725 0.214002 15.8944 0.552786C16.0638 0.891569 16.0273 1.29668 15.8 1.6L13.5 4.75L15.8 7.9C16.0273 8.20332 16.0638 8.60843 15.8944 8.94721C15.725 9.286 15.3788 9.5 15 9.5H5C4.44772 9.5 4 9.05228 4 8.5V1Z'
			fill={fill || 'currentColor'}
		/>
		{/* Star emblem on flag */}
		<path
			d='M9.5 2.5L10.0451 3.90983H11.5L10.2275 4.78034L10.7725 6.19017L9.5 5.31966L8.22746 6.19017L8.77254 4.78034L7.5 3.90983H8.95492L9.5 2.5Z'
			fill='var(--bg-primary, #ffffff)'
		/>
	</svg>
);

export const MyWalletSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='17'
		height='20'
		fill='none'
		viewBox='0 0 24 24'
	>
		{/* Icon from Iconoir by Luca Burgio - https://github.com/iconoir-icons/iconoir/blob/main/LICENSE */}
		<g
			fill='none'
			stroke={props.color || 'black'}
			strokeWidth='1.5'
		>
			<path d='M19 20H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2Z' />
			<path
				fill='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M16.5 14a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1'
			/>
			<path d='M18 7V5.603a2 2 0 0 0-2.515-1.932l-11 2.933A2 2 0 0 0 3 8.537V9' />
		</g>
	</svg>
);

export const EmailSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
		<path
			fill='currentColor'
			d='M2 20V4h20v16zm10-7L4 8v10h16V8zm0-2l8-5H4zM4 8V6v12z'
		/>
	</svg>
);

export const SmsSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE */}
		<path
			fill='currentColor'
			d='M8 10.77q.31 0 .54-.23t.23-.54t-.23-.54T8 9.23t-.54.23t-.23.54t.23.54t.54.23m4 0q.31 0 .54-.23t.23-.54t-.23-.54t-.54-.23t-.54.23t-.23.54t.23.54t.54.23m4 0q.31 0 .54-.23t.23-.54t-.23-.54t-.54-.23t-.54.23t-.23.54t.23.54t.54.23M3 20.076V4.616q0-.691.463-1.153T4.615 3h14.77q.69 0 1.152.463T21 4.616v10.769q0 .69-.463 1.153T19.385 17H6.077zM5.65 16h13.735q.23 0 .423-.192t.192-.423V4.615q0-.23-.192-.423T19.385 4H4.615q-.23 0-.423.192T4 4.615v13.03zM4 16V4z'
		/>
	</svg>
);

export const WhatsappSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE */}
		<path
			fill='currentColor'
			d='M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28'
		/>
	</svg>
);

export const TelegramSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Simple Icons - https://github.com/simple-icons/simple-icons/blob/develop/LICENSE.md */}
		<path
			fill='currentColor'
			d='M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12a12 12 0 0 0 12-12A12 12 0 0 0 12 0zm4.962 7.224c.1-.002.321.023.465.14a.5.5 0 0 1 .171.325c.016.093.036.306.02.472c-.18 1.898-.962 6.502-1.36 8.627c-.168.9-.499 1.201-.82 1.23c-.696.065-1.225-.46-1.9-.902c-1.056-.693-1.653-1.124-2.678-1.8c-1.185-.78-.417-1.21.258-1.91c.177-.184 3.247-2.977 3.307-3.23c.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345c-.48.33-.913.49-1.302.48c-.428-.008-1.252-.241-1.865-.44c-.752-.245-1.349-.374-1.297-.789c.027-.216.325-.437.893-.663c3.498-1.524 5.83-2.529 6.998-3.014c3.332-1.386 4.025-1.627 4.476-1.635z'
		/>
	</svg>
);

export const LinkedInSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Simple Icons - https://github.com/simple-icons/simple-icons/blob/develop/LICENSE.md */}
		<path
			fill='currentColor'
			d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037c-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85c3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065a2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z'
		/>
	</svg>
);

export const XTwitterSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Simple Icons - https://github.com/simple-icons/simple-icons/blob/develop/LICENSE.md */}
		<path
			fill='currentColor'
			d='M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584l-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932zM17.61 20.644h2.039L6.486 3.24H4.298z'
		/>
	</svg>
);

export const VoterInteractionSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1em'
		height='1em'
		viewBox='0 0 48 48'
		{...props}
	>
		{/* Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE */}
		<path
			fill={props.color || 'black'}
			d='M26.222 27.222c4.295-4.296 11.26-4.296 15.556 0c4.296 4.295 4.296 11.26 0 15.556a1.25 1.25 0 0 1-1.768-1.767a8.5 8.5 0 1 0-12.02 0a1.25 1.25 0 0 1-1.768 1.767c-4.296-4.295-4.296-11.26 0-15.556m3.18 3.181a6.5 6.5 0 0 1 9.193 9.193a1.25 1.25 0 0 1-1.768-1.768a4 4 0 1 0-5.656 0a1.25 1.25 0 0 1-1.769 1.768a6.5 6.5 0 0 1 0-9.193M25.25 25q.212 0 .417.023a13 13 0 0 0-2.286 2.477H6.75c-.69 0-1.25.56-1.25 1.25v1.242l.001.032q.002.053.015.174c.017.162.054.407.13.706a6.2 6.2 0 0 0 1.069 2.216c1.182 1.56 3.71 3.38 9.285 3.38c2.066 0 3.713-.25 5.028-.645c.056.853.194 1.684.406 2.484C19.925 38.755 18.13 39 16 39c-6.175 0-9.522-2.055-11.277-4.37a8.7 8.7 0 0 1-1.501-3.112a8 8 0 0 1-.192-1.05a6 6 0 0 1-.029-.415L3 30.02v-1.27A3.75 3.75 0 0 1 6.75 25zM16 6a8 8 0 1 1 0 16a8 8 0 0 1 0-16m18 4a6 6 0 1 1 0 12a6 6 0 0 1 0-12M16 8.5a5.5 5.5 0 1 0 0 11a5.5 5.5 0 0 0 0-11m18 4a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7'
		/>
	</svg>
);

export const WalletOffSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1em'
		height='1em'
		viewBox='0 0 24 24'
		{...props}
	>
		{/* Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE */}
		<g
			fill='none'
			stroke='currentColor'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='2'
		>
			<path d='M17 8V5a1 1 0 0 0-1-1H8m-3.413.584A2 2 0 0 0 6 8h2m4 0h6a1 1 0 0 1 1 1v3' />
			<path d='M19 19a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2V6' />
			<path d='M16 12h4v4m-4 0a2 2 0 0 1-2-2M3 3l18 18' />
		</g>
	</svg>
);

export const TaskListSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1rem'
		height='1rem'
		viewBox='0 0 20 20'
		{...props}
	>
		{/* Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE */}
		<path
			fill='currentColor'
			d='M5.854 4.354a.5.5 0 1 0-.708-.708L3.5 5.293l-.646-.647a.5.5 0 1 0-.708.708l1 1a.5.5 0 0 0 .708 0zM8.75 4.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5zM8 15.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75M5.854 9.854a.5.5 0 1 0-.708-.708L3.5 10.793l-.646-.647a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0zm0 4.292a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647l1.646-1.647a.5.5 0 0 1 .708 0'
		/>
	</svg>
);

export const AgentSourceSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '14'}
		height={height || '14'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2c-3.866 0-7 2.239-7 5v1h14v-1c0-2.761-3.134-5-7-5Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const AiSourceSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '14'}
		height={height || '14'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M12 2 13.6 8.4 20 10l-6.4 1.6L12 18l-1.6-6.4L4 10l6.4-1.6L12 2Zm6.5 11 .9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9.9-2.6ZM5.5 14l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const CitizenSourceSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '14'}
		height={height || '14'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm6 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 1.5c-2.761 0-5 1.567-5 3.5V18h10v-2c0-1.933-2.239-3.5-5-3.5Zm6 0c-.42 0-.83.034-1.222.097C15.135 13.495 16 14.668 16 16v2h5v-2c0-1.933-2.582-3.5-6-3.5Z'
			fill={color || 'currentColor'}
		/>
	</svg>
);

export const IRevSourceSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '14'}
		height={height || '14'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M17.5 10c-.07-3.31-2.74-6-6-6a6 6 0 0 0-5.83 4.5A4.5 4.5 0 0 0 6 17.5h11a3.5 3.5 0 0 0 .5-7Zm-5.5-3a3 3 0 0 1 3 3 1 1 0 1 1-2 0 1 1 0 0 0-1-1 1 1 0 1 1 0-2Z'
			fill={color || 'currentColor'}
		/>
		<ellipse
			cx='12'
			cy='20'
			rx='6'
			ry='1.5'
			fill={color || 'currentColor'}
			opacity='0.55'
		/>
	</svg>
);

export const ResultVerificationSVG = ({ fill }: { fill?: string }) => (
	<svg
		width='18'
		height='20'
		viewBox='0 0 18 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		{/* Result sheet */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M2 0.5h10.5L16 4v9.5h-1.4V4.9L11.9 1.9H3.4v16.2h5.1V19.5H2V0.5Zm9.4 0.9V4.5h3.2L11.4 1.4Z'
			fill={fill || 'currentColor'}
		/>
		{/* Sheet lines */}
		<rect
			x='4.6'
			y='6.4'
			width='6.8'
			height='1.1'
			rx='0.4'
			fill={fill || 'currentColor'}
		/>
		<rect
			x='4.6'
			y='9'
			width='6.8'
			height='1.1'
			rx='0.4'
			fill={fill || 'currentColor'}
		/>
		<rect
			x='4.6'
			y='11.6'
			width='4.2'
			height='1.1'
			rx='0.4'
			fill={fill || 'currentColor'}
		/>
		{/* Verification check seal */}
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M13.4 12.4a4.1 4.1 0 1 1 0 8.2 4.1 4.1 0 0 1 0-8.2Zm0 1.2a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8Zm-1.7 2.9 0.8-0.8 0.9 0.9 1.8-1.8 0.8 0.8-2.6 2.6-1.7-1.7Z'
			fill={fill || 'currentColor'}
		/>
	</svg>
);

// --- Registration-page brand + media glyphs (mirror volunteer BrandedHero) ---

export const GlobeSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='1.8'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<circle
			cx='12'
			cy='12'
			r='9'
		/>
		<path d='M3 12h18M12 3a15 15 0 0 1 0 18a15 15 0 0 1 0-18' />
	</svg>
);

export const FacebookSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill={color || 'currentColor'}
	>
		<path d='M14 9h2.5V6H14c-2 0-3.5 1.5-3.5 3.5V11H8v3h2.5v7h3v-7H16l.5-3h-3V9.5C13.5 9.2 13.7 9 14 9Z' />
	</svg>
);

export const XSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill={color || 'currentColor'}
	>
		<path d='M17.5 3h3l-6.6 7.5L22 21h-5.9l-4.2-5.4L6.9 21H3.8l7-8L2.5 3h6l3.8 5 4.2-5Zm-1 16 1.7-.1L7.6 4.8H5.8L16.5 19Z' />
	</svg>
);

export const InstagramSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill='none'
		stroke={color || 'currentColor'}
		strokeWidth='1.8'
		strokeLinecap='round'
		strokeLinejoin='round'
	>
		<rect
			x='3'
			y='3'
			width='18'
			height='18'
			rx='5'
		/>
		<circle
			cx='12'
			cy='12'
			r='4'
		/>
		<circle
			cx='17'
			cy='7'
			r='1'
			fill={color || 'currentColor'}
			stroke='none'
		/>
	</svg>
);

export const YoutubeSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill={color || 'currentColor'}
	>
		<path d='M22 8.2a3 3 0 0 0-2.1-2.1C18 5.6 12 5.6 12 5.6s-6 0-7.9.5A3 3 0 0 0 2 8.2 31 31 0 0 0 1.7 12 31 31 0 0 0 2 15.8a3 3 0 0 0 2.1 2.1c1.9.5 7.9.5 7.9.5s6 0 7.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .3-3.8 31 31 0 0 0-.3-3.8ZM10 15V9l5.2 3L10 15Z' />
	</svg>
);

export const WhatsAppBrandSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '18'}
		height={height || '18'}
		viewBox='0 0 24 24'
		fill={color || 'currentColor'}
	>
		<path d='M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.5A10 10 0 1 0 12 2Zm0 18a8 8 0 0 1-4.1-1.1l-.3-.2-2.9.9.9-2.8-.2-.3A8 8 0 1 1 12 20Zm4.4-6c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1-.6.8-.8 1-.3.2-.5.1a6.5 6.5 0 0 1-3.2-2.8c-.2-.4.2-.4.6-1.2a.4.4 0 0 0 0-.4l-.8-1.9c-.2-.5-.4-.4-.5-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-1 2.2 5.3 5.3 0 0 0 1.1 2.8 12 12 0 0 0 4.6 4c2.3.9 2.3.6 2.7.6a2.5 2.5 0 0 0 1.6-1.2 2 2 0 0 0 .2-1.2c-.1-.1-.3-.2-.5-.3Z' />
	</svg>
);

export const PlaySVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill={color || 'currentColor'}
	>
		<path d='M8 5.14v13.72a1 1 0 0 0 1.54.84l10.79-6.86a1 1 0 0 0 0-1.68L9.54 4.3A1 1 0 0 0 8 5.14Z' />
	</svg>
);

// Contacts module (Voter Outreach). Address-book glyph — distinct from VoterInteractionSVG's
// people-with-signal mark, so the sibling nav items are not confusable at 20px.
export const ContactsSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1em'
		height='1em'
		viewBox='0 0 24 24'
		{...props}
	>
		<path
			fill={props.color || 'currentColor'}
			d='M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1H3a1 1 0 1 1 0-2h1v-3H3a1 1 0 1 1 0-2h1V9H3a1 1 0 0 1 0-2h1V4a2 2 0 0 1 2-2Zm0 2v16h12V4H6Zm6 2.75a2.75 2.75 0 1 1 0 5.5a2.75 2.75 0 0 1 0-5.5Zm0 1.5a1.25 1.25 0 1 0 0 2.5a1.25 1.25 0 0 0 0-2.5ZM12 13.5c2.485 0 4.5 1.343 4.5 3v.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V16.5c0-1.657 2.015-3 4.5-3Zm0 1.5c-1.79 0-3 .84-3 1.5v.5h6v-.5c0-.66-1.21-1.5-3-1.5Z'
		/>
	</svg>
);

/** Speech bubble — "message this person". Pairs with `MapPinSVG` and the phone glyph. */
export const ChatSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<path
			d='M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
